import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, NgModule, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService, ConfirmationService } from 'primeng/api';
import { BaseFormComponent } from '../../models/base/base-form.component';
import { ModalLeftNavItem } from '../../models/modal-left-nav.model';
import { AbstractControl, FormControl, ValidationErrors, Validators, FormGroup, FormArray, ReactiveFormsModule, FormsModule, FormBuilder } from '@angular/forms';
import { LookupService } from '../../services/lookup.service';
import { UserService } from '../../services/user.service';
import { FileService } from '../../services/file.service';
import { LocationService } from '../../services/location.service';
import { OrderService } from '../../services/order.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { FormService } from '../../services/form.service';
import { CommonModule, DatePipe } from '@angular/common';
import { VehiclesFormModule } from '../shared/controls/vehicles-form.component';
import { NotesModule } from '../shared/controls/notes.component';
import { DialogModule } from 'primeng/dialog';
import { LoadingModule } from '../shared/controls/loading.component';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { UploadsModule } from '../shared/controls/uploads.component';
import { KebobMenuModule } from '../shared/controls/dynamic/kebob-menu.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContactsFormModule } from '../shared/controls/contacts-form.component';
import { DynamicControlErrorModule } from '../shared/controls/dynamic/dynamic-control-error.component';
import { ModalLeftNavModule } from '../shared/controls/dynamic/modal-left-nav.component';
import { FormHelperService } from '../../services/form-helper.service';
import { FormError } from '../../models/form-error.model';
import { OrderSetting } from '../../models/order-settings.component';
import { OrderTagsModule } from './order-tags.component';
import { ContactService } from '../../services/contact.service';
import { YesNoNA } from '../../models/enums';
import { DynamicDateFormModule } from '../shared/controls/dynamic-date-form.componet';
import { allEnums } from '../helper/enum';
import { CustomerChargedType } from '../invoices/invoice-form.component';
import { NoteService } from '../../services/note.service';
import { environment } from '../../environments/environment';
import { SharedService } from '../../services/shared.service';
import { NavigationService } from '../../services/navigation.service';
import { AccountService } from '../../services/account.service';
import { Note } from '../../models/note.model';
import { ApplicationInsightsService } from '../../services/application-insights.service';
import * as Sentry from '@sentry/angular';
import { DriverTruckOverhualFormModule } from '../shared/controls/driver-truck-overhual-form.componet';
import { ConfirmDeleteDialogModule } from "../shared/controls/confirm-delete-dialog.component";
import { SanitizeInputDirective } from '../../directives/sanitize-input.directive';

export enum customerChargedType {
  Prepay = 1,
  Invoice = 2,
  COD = 3,
  COP = 4
}

export enum carrierPaymentType {
  "COD" = 1,
  "COP" = 2,
  "COD+Invoice" = 3,
  "COP+Invoice" = 5,
  "Invoice" = 4
}

export enum PaymentMethod {
  "Check" = 1,
  "Credit Card" = 2,
  "Paypal" = 3,
  "Venmo" = 4,
  "Zelle" = 5,
  "Wash" = 6,
  "ACH" = 7,
  "Other" = 8,
}

// Custom validator for pickup transport result - must include OnTime(1) or Late(2)
export function pickupTransportResultValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value?.length > 0 && !(value.includes(1) || value.includes(2))) {
    return { incorrect: 'Please select either OnTime or Late.' };
  }
  return null;
}

// Custom validator for delivery transport result - must include OnTime(3) or Late(4)
export function deliveryTransportResultValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value?.length > 0 && !(value.includes(3) || value.includes(4))) {
    return { incorrect: 'Please select either OnTime or Late.' };
  }
  return null;
}

@Component({
  selector: 'order-form',
  templateUrl: './order-form.component.html',
  providers: [
    OrderService,
    LookupService,
    UserService,
    FileService,
    LocationService,
    ConfirmationService,
    FormService,
    ContactService,
    NoteService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderFormComponent extends BaseFormComponent implements OnInit,OnDestroy {
  public isTenderOrder: boolean = false;
  @Input() id: string;
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSaveComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRevert: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialog: any;
  @Input() navigateOnSave: boolean = true;

  orderSetting: OrderSetting;
  initialVehicleInformation: any = [];
  cancelForm: FormGroup;
  revertForm: FormGroup;
  pickupCancelForm: FormGroup;

  isLoading: boolean = false;
  serverError: string = null;

  leftNav: ModalLeftNavItem[] = [];
  navKeys: any = {};
  status: number = 0;
  selectedCustomer = null;
  showCustomerSearch = false;

  errors: FormError[] = [];

  newNotes: any[] = [];
  agentsLoading: boolean = false;

  now: Date = new Date();
  currentDateOnly: Date = (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; })();
  isPopupOpen = false;

  isPrivateCustomer: boolean = false;
  isPrivateCustomerAtPickupOrDeliveryCheck: boolean = false;
  perVehicleDollarAmountRequired: boolean = false;
  payDropRequired: boolean = false;
  newClientSelected: boolean = false;
  isNewClient: boolean = false;
  isNewClientYes: boolean = false;
  customerSelected: boolean = false;
  loadedCustomerList: boolean = false;
  loadedCarrierList: boolean = false;
  saveCustomer: boolean = false;
  isPaymentTermsReadOnly: boolean = false;
  isBrokerFeeReadOnly: boolean = false;
  private cachedCarrierPaymentTerms: number | null = null;
  isDownloadingCarrierTerms: boolean = false;
  showDepositPaymentDate: boolean = false;
  showCustomerDocsDate: boolean = false;
  showCustomerDoc: boolean = false;
  showPickupDoc: boolean = false;
  showDeliveryDoc:boolean = false;
  showYesCustomerDocs:boolean = false;
  isCancellationInfoReadOnly: boolean = false;
  isMultipleOderReadOnly: boolean = false;
  foundAssignedTo: null | boolean = null;
  buttons: any[] = [];
  uploads: any[] = [];
  contacts: any[] = [];
  orderContacts: any[] = [];
  customerContacts: any[] = [];
  pickupLocationItems: any[] = [];
  deliveryLocationItems: any[] = [];
  pickupLocationContacts: any[] = [];
  deliveryLocationContacts: any[] = [];
  contactsValid: boolean = false;
  temp = [];

  showCancelDialog: boolean = false;
  showRevetOrderDialog:boolean = false;
  showPickupCancelDialog: boolean = false;
  isCarrierCanceled: boolean = false;
  isDryRun: boolean = false;
  isPaymentToCarrier: boolean = false;
  isPaymentToCustomer: boolean = false;
  missingPaymentInfo: boolean = false;

  leftNavSelected: string = 'basic';
  leftNavSelectedIndex: number = 0;

  hideSaveAsNewLocation = false;
  hideSaveAsNewLocationForPickUp = false;
  showLocationSearch = false;
  showLocationSearchButton = true;
  locationSearchArea = 'pickup';
  selectedLocation: any = null;
  locationItems: any[] = [];
  locationSearchString = null;
  customerSearchString = null;
  showCancelWarning = false;
  showTransport = false;
  scheduledDateChanged = false;
  firstCustomerLoad = true;
  showDesiredProfit = false;
  isUpdateCancel = false;
  assignedCarrierPhones = [];
  assignedCarrierPhone = null;
  mcNumber = null;
  businessPhone = null;

  assignedCargoLimit = [];
  cargoInsuranceDeductible = [];

  additionalInfo = {
    pickup: [],
    delivery: [],
    emails: [],
    carrierEmails: []
  };


  formSettings = {
    disableVehicles: false,
    disableCustomer: false,
    disableInvoicing: false,
    disablePrivateCustomer: false
  };

  isContactsLoading = false;

  initialModel: any = {};

  changeEvents: Subject<void>[] = [];
  metadata: any = {};
  totalCount = {
    order: false,
    invoice: false,
    tender: false
  }

  isDoNotUseCarrier = false;
  isTransitCompleteCarrier: boolean = true;
  isDoNotUseAssignedTo = false;

  customerItems: any[] = [];
  carrierItems: any[] = [];
  freezeOrderNumber: any = environment.freezeOrderNumber;
  assignedRepOrderNumber: any = environment.assignedRepOrderNumber
  isOldRecords: boolean = false;
  email_pattern = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  dateOverhaulOrderNumber: number = environment.dateOverhaulOrderNumber;
  isNewRecordForDateOverhual: boolean = false;
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  isNewRecordForTruckOverhual:boolean =false;
  updatedCustomerDocOrder: number = environment.updatedCustomerDocOrder;
  isNewCustomerDocOrder: boolean = false;
  bookedDispatchOrderNumber: number = environment.bookedDispatchOrderNumber;
  isNewBookedOrderNumber: boolean = false;
  orderConfirmDeliveryNumber: number = environment.orderConfirmDeliveryNumber;
  isOrderConfirmDelivery: boolean = false;
  pickupPasswordOrderNumber: number = environment.pickupPasswordOrderNumber;
  isShowPickupPassword: boolean = false;
  hubSpotDealOrderNumber: number = environment.hubSpotDealOrderNumber;
  isNewHubSpotDealOrderNumber: boolean = false;
  // excludeKeys = [7, 8, 9]
  isValidETAReason = false;
  pickupCarrierLabel: string = '';
  pickupFSCLabel: string = '';
  copyCancleDocs = [];
  phoneNumberRegex: RegExp = /[x 0-9\-\+\(\)\s]/;
  customerTempId = null;
  startTime: number;
  totalTime: number = 3600;
  warningShown = false;
  lastWarningTime: number = 0;
  visibilityChangeListener: () => void;
  sharedServiceClient: SharedService;
  private destroy$ = new Subject<void>();
  hasActiveDriver:boolean
  policyDetails:any[] = [];
  isPolicyExpired:boolean = false;
  isPolicyEmpty:boolean = false;

  isAddContactEnabled$ = new BehaviorSubject<boolean>(true);
  isContactDisabled: boolean = false;

  isAddPickupContactEnabled$ = new BehaviorSubject<boolean>(true);
  isPickupContactDisabled: boolean = false;

  isAddDeliveryContactEnabled$ = new BehaviorSubject<boolean>(true);
  isDeliveryContactDisabled: boolean = false;

  showDeleteWarning: boolean = false;
  deleteMessage: string = '';
  deleteId: number | null = null;
  deleteEntityName: string | null = null;

  constructor(
    protected messageService: MessageService,
    private orderService: OrderService,
    private contactService: ContactService,
    private router: Router,
    private lookupService: LookupService,
    private ref: ChangeDetectorRef,
    private userService: UserService,
    private fileService: FileService,
    private locationService: LocationService,
    private confirmationService: ConfirmationService,
    private formService: FormService,
    private datePipe: DatePipe,
    private fh: FormHelperService,
    private navigationService: NavigationService,
    private sharedService: SharedService,
    private accountService: AccountService,
    private fb: FormBuilder,
    private noteService: NoteService,
    private applicationInsights: ApplicationInsightsService) {
    super();
    this.entityName = 'order';
    this.sharedServiceClient = sharedService;
    //this.now.setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    this.applicationInsights.trackEvent('Order Form Opened', {
      orderId: this.id,
      isAdding: this.isAdding,
      isEditing: this.isEditing,
      timestamp: new Date().toISOString()
    });
    this.initializeForm();
    this.setupVisibilityChangeListener();
  }

  private displayErrorMessage(errorMessage: string): void {
    const errorMessages = errorMessage.split('\n').filter(msg => msg.trim().length > 0);
    if (errorMessages.length > 1) {
      errorMessages.forEach(message => {
        this.messageService.add(this.toast(true, message.trim()));
      });
      this.serverError = errorMessages.join(' ');
    } else {
      this.messageService.add(this.toast(true, errorMessage));
      this.serverError = errorMessage;
    }
  }

  initializeForm() {
    this.isLoading = true;
    this.buttons = [];

    this.isAdding = this.id == null || this.id == '';
    this.isEditing = this.id != null && this.id != '';

    this.changeEvents['agents'] = new Subject();
    this.changeEvents['carriers'] = new Subject();

    this.loadLookup('yesNoNa');
    this.loadLookup('multipleorders');
    this.loadLookup('yesNoOnly');
    this.loadLookup('yesNoNaNull');
    this.loadLookup('yesNo');
    this.loadLookup('yesNoNull');
    this.loadLookup('reviewRequested');
    this.loadLookup('phoneTypes');
    this.loadLookup('stateCodes');
    this.loadLookup('sources');
    this.loadLookup('customerChargedType');
    this.loadLookup('carrierPaymentType');
    this.loadLookup('paymentTerms');
    this.loadLookup('cancelationTypes');
    this.loadLookup('operability');
    this.loadLookup('carrierTransportResults');
    this.loadLookup('deliveryCarrierTransportResults');
    this.loadLookup('fscTransportResults');
    this.loadLookup('deliveryfscTransportResults');
    this.loadLookup('openEnclosed');
    this.loadLookup('paymentMethodDepositBy');
    this.loadLookup('privateCustomerLocationType');
    this.loadLookup('segment');
    this.loadLookup('subsegmentupfitter');
    this.loadLookup('reviewRequested');

    this.loadLookup('customerDocs')
    this.loadLookup('customerDocOptions')
    this.loadLookup('bookedBy')
    this.userService
      .agents()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        this.lookups["agentsonly"] = r.body;
        //this.lookups['agents'].unshift({ value: null, label: '' });

        // this.changeEvents["agents"].next();
      });


    if (this.loadedCustomerList && this.loadedCarrierList) {
      this.load();
    }
    else {
      this.userService.customers()
        .pipe(takeUntil(this.destroy$))
        .subscribe((customers: any) => {
          this.lookups.customersList = customers.body;
          this.lookups.customers = customers.body.map((customer) => {
            return { label: customer.label, value: customer.id };
          });
          this.lookups.customers.unshift({ label: "Select...", value: null });


          this.loadedCustomerList = true;
          this.load();
        });
    }
  }

  loadForm() {
    this.leftNav = [];
    this.form = new FormGroup({}, []);

    if (this.model == null)
      this.model = { id: 0, vip: false, rush: false, status: 0 };

    this.status = this.model.status;

    if (this.isAdding)
      this.id = null;

    this.isPrivateCustomer = this.model.privateCustomer == 2;

    this.form.addControl('id', new FormControl(this.model.id));
    this.form.addControl('number', new FormControl(this.model.number));

    //for load existing selected value
    this.form.addControl('selectedLoadExistingLocationForPickup', new FormControl(null))
    this.form.addControl('selectedLoadExistingLocationForDelivery', new FormControl(null))
    this.form.addControl('selectedLoadExistingCustomer', new FormControl(null))
    this.form.addControl('pickupPhones', this.fb.array(this.model.pickupPhones ?
      this.getStringArray(this.model.pickupPhones).map((p) => {
        return new FormControl(p, [Validators.minLength(10), Validators.maxLength(18)]);
      }) : []));

    this.form.addControl('deliveryPhones', this.fb.array(this.model.deliveryPhones ?
      this.getStringArray(this.model.deliveryPhones).map((p) => {
        return new FormControl(p, [Validators.minLength(10), Validators.maxLength(18)]);
      }) : []));

    //calculated fields
    this.form.addControl('calculatedPriceToCarrier', new FormControl(null));
    this.form.addControl('calculatedCompanyProfit', new FormControl(null));
    this.form.addControl('calculatedBalance', new FormControl(null));

    this.form.addControl('number', new FormControl(this.model.number));
    this.form.addControl('perVehicleDollarAmount', new FormControl(this.model.perVehicleDollarAmount, this.model.payDrop == 2 ? [Validators.required] : []));
    this.form.addControl('payDropReason', new FormControl(this.model.payDropReason, this.model.payDrop == 2 ? [Validators.required] : []));
    this.form.addControl('payDrop', new FormControl(this.model.payDrop == null ? 3 : this.model.payDrop, [Validators.required]));
    this.form.addControl('dealerTrade', new FormControl(this.model.dealerTrade == null ? 3 : this.model.dealerTrade, [Validators.required]));
    this.form.addControl('privateCustomer', new FormControl(this.model.privateCustomer, [Validators.required]));
    this.form.addControl('customerDocs', new FormControl(this.model.customerDocs, [Validators.required]));
    this.onCustomerDocDropDownSelect('customerDocs',this.model.customerDocs == null ? [] : this.model.customerDocs)
    this.form.addControl('customerDocCustomer', new FormControl(this.model.customerDocCustomer));
    this.form.addControl('customerDocPickup', new FormControl(this.model.customerDocPickup));
    this.form.addControl('customerDocDelivery', new FormControl(this.model.customerDocDelivery));
    this.form.addControl('hubspotDealId', new FormControl(this.model.hubspotDealId));
    this.form.addControl('generatePickupPassword', new FormControl(this.model.generatePickupPassword || false));
    this.form.addControl('pickupPassword', new FormControl(this.model.pickupPassword));

    this.form.addControl('customerDocsSignedDate', new FormControl(this.model.customerDocsSignedDate == null ? null : new Date(this.model.customerDocsSignedDate )));

    this.form.addControl('assignedTo', new FormControl(this.model.assignedTo, [Validators.required]));

    this.form.addControl('customerId', new FormControl(this.model.customerId));
    var currentCustomer = this.lookups?.customersList?.find(x => x.id == this.model.customerId);
    this.form.addControl('selectedCustomer', new FormControl(currentCustomer, [Validators.required]));

    if (this.model.number && this.model.number <= this.freezeOrderNumber) {
      this.isOldRecords = true;
    }

    if (this.model.number && this.model.number > this.dateOverhaulOrderNumber) {
      this.isNewRecordForDateOverhual = true;
    }

    if(this.model.number && this.model.number > this.updatedCustomerDocOrder){
      this.isNewCustomerDocOrder = true;
    }

    if(this.model.number && this.model.number > this.bookedDispatchOrderNumber){
      this.isNewBookedOrderNumber = true;
    }

    if (this.model.number && this.model.number > this.truckOverhaulOrderNumber) {
      this.isNewRecordForTruckOverhual = true;
    }

    if(this.model.number && this.model.number > this.orderConfirmDeliveryNumber){
      this.isOrderConfirmDelivery = true;
    }

    if(this.model.number && this.model.number > this.pickupPasswordOrderNumber){
      this.isShowPickupPassword = true;
    }

    if (this.model.number && this.model.number > this.hubSpotDealOrderNumber) {
      this.isNewHubSpotDealOrderNumber = true;
    }

    if (this.isAdding) {
      this.form.addControl('numOrders', new FormControl(2));
      this.form.addControl('newClient', new FormControl(3, [Validators.required]));
      this.form.addControl('vip', new FormControl(false));
      this.form.addControl('rush', new FormControl(false));
      this.form.addControl('sameCustomer', new FormControl(false));
      this.form.addControl('samePickup', new FormControl(false));
      this.form.addControl('sameDelivery', new FormControl(false));
      this.form.addControl('samePaymentNotes', new FormControl(false));
      this.form.addControl('saveCustomer', new FormControl(true));
      this.form.addControl('enableNotifications', new FormControl(false));

      this.form.addControl('savePickup', new FormControl(false));
      this.form.addControl('saveDelivery', new FormControl(false));
    } else {
      this.form.addControl('vip', new FormControl(this.model.vip));
      this.form.addControl('rush', new FormControl(this.model.rush));
      this.form.addControl('saveCustomer', new FormControl(this.model.saveCustomer));
      this.form.addControl('newClient', new FormControl(this.model.newClient));

    }

    let assignedUser = this.model.assignedTo == null ? this.userId : this.model.assignedTo;
    let agent = this.lookups['agents']?.find(x => x.value == assignedUser);
    if (this.isAdmin) {
      this.form.addControl(
        "salesAgentCommissionPercentage",
        new FormControl(this.model.salesAgentCommissionPercentage, [
          Validators.required,
          Validators.min(0),
          Validators.max(100),
          Validators.pattern(/^(0|[1-9]\d*)$/)
        ]),
      );
      this.applicationInsights.trackEvent('SalesAgentCommission_FormInit', {
        source: 'admin_model',
        orderId: this.model.id ?? null,
        orderNumber: this.model.number ?? null,
        assignedTo: this.model.assignedTo ?? null,
        value: this.model.salesAgentCommissionPercentage ?? null,
        performedByUserId: this.userId ?? null,
        performedByUserName: localStorage.getItem('userName') ?? null,
        status: this.status ?? null
      });
    } else {
      this.form.addControl('salesAgentCommissionPercentage', new FormControl(agent?.salesAgentCommissionPercentage));
      this.applicationInsights.trackEvent('SalesAgentCommission_FormInit', {
        source: 'non_admin_agent_lookup',
        orderId: this.model.id ?? null,
        orderNumber: this.model.number ?? null,
        assignedUser: assignedUser ?? null,
        agentFound: agent != null,
        value: agent?.salesAgentCommissionPercentage ?? null,
        performedByUserId: this.userId ?? null,
        performedByUserName: localStorage.getItem('userName') ?? null,
        status: this.status ?? null
      });
    }

    this.form.addControl('customerBusinessName', new FormControl(this.model.customerBusinessName));
    this.form.addControl('customerBusinessHours', new FormControl(this.model.customerBusinessHours));

    this.form.addControl('customerFirstName', new FormControl(this.model.customerFirstName));
    this.form.addControl('customerLastName', new FormControl(this.model.customerLastName));
    this.form.addControl('customerEmail', new FormControl(this.model.customerEmail, [Validators.email]));
    this.form.addControl('customerPhoneType', new FormControl(this.model.customerPhoneType, [Validators.required]));
    this.form.addControl('customerPhone', new FormControl(this.model.customerPhone, [Validators.required, Validators.minLength(10), Validators.maxLength(18)]));
    this.form.addControl('customerAddress1', new FormControl(this.model.customerAddress1, [Validators.required]));
    this.form.addControl('customerAddress2', new FormControl(this.model.customerAddress2));
    this.form.addControl('customerCity', new FormControl(this.model.customerCity, [Validators.required]));
    this.form.addControl('customerStateCode', new FormControl(this.model.customerStateCode, [Validators.required]));
    this.form.addControl('customerZip', new FormControl(this.model.customerZip, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]));
    this.form.addControl('segment', new FormControl(this.model.segment, [Validators.required]));
    this.form.addControl('customerPickupNotes', new FormControl(this.model?.customerPickupNotes));
    this.form.addControl('customerDeliveryNotes', new FormControl(this.model?.customerDeliveryNotes));
    this.form.addControl('subsegment', new FormControl(this.model.subSegment));
    this.form.addControl('customerContacts', new FormControl(this.model.customerContacts == null ? [] : this.model.customerContacts));
    this.loadAddlInfo('emails', this.model.contactEmails);


    if (!this.isAdding) {
      if (this.model.contacts != null && this.model.contacts.length > 0) {
        let forms = [];
        this.model.contacts.forEach(c => {
          forms.push(this.fh.getContactForm(c, true));
        });

        this.form.addControl('contacts', new FormArray(forms));
      }
      else {
        this.form.addControl('contacts', new FormArray([]));
      }

      if (this.model.pickupContacts != null && this.model.pickupContacts.length > 0) {
        let forms = [];
        this.model.pickupContacts.forEach(c => {
          c.entity = 'OrderPickup';
          forms.push(this.fh.getContactForm(c, true));
        });

        this.form.addControl('pickupContacts', new FormArray(forms));
      }
      else {
        this.form.addControl('pickupContacts', new FormArray([]));
      }

      if (this.model.deliveryContacts != null && this.model.deliveryContacts.length > 0) {
        let forms = [];
        this.model.deliveryContacts.forEach(c => {
          c.entity = "OrderDelivery";
          forms.push(this.fh.getContactForm(c, true));
        });

        this.form.addControl('deliveryContacts', new FormArray(forms));
      }
      else {
        this.form.addControl('deliveryContacts', new FormArray([]));
      }
    }
    else {
      this.form.addControl('contacts', new FormArray([]));
      this.form.addControl('pickupContacts', new FormArray([]));
      this.form.addControl('deliveryContacts', new FormArray([]));

    }

    this.form.addControl('pickupContactsList', new FormArray([]));
    this.form.addControl('deliveryContactsList', new FormArray([]));

    this.form.addControl('pickupBusinessName', new FormControl(this.model.pickupBusinessName));
    this.form.addControl('pickupFirstName', new FormControl(this.model.pickupFirstName));
    this.form.addControl('pickupLastName', new FormControl(this.model.pickupLastName));
    this.form.addControl('pickupBusinessHours', new FormControl(this.model.pickupBusinessHours));
    this.form.addControl('pickupAddress1', new FormControl(this.model.pickupAddress1, [Validators.required]));
    this.form.addControl('pickupAddress2', new FormControl(this.model.pickupAddress2));
    this.form.addControl('pickupStateCode', new FormControl(this.model.pickupStateCode, [Validators.required]));
    this.form.addControl('pickupCity', new FormControl(this.model.pickupCity, [Validators.required]));
    this.form.addControl('pickupZip', new FormControl(this.model.pickupZip, this.getValidators(5, 5, true)));
    this.form.addControl('pickupNotes', new FormControl(this.model.pickupNotes));
    this.form.addControl('pickupPhone', new FormControl(this.model.pickupPhone, [Validators.required, Validators.minLength(10), Validators.maxLength(18)]));
    this.form.addControl('pickupLocationId', new FormControl(this.model.pickupLocationId));
    this.form.addControl('useCustomerContactForPickup', new FormControl(this.model.useCustomerContactForPickup));

    this.loadAddlInfo('pickup', this.model.pickupPhones)

    this.form.addControl('deliveryBusinessName', new FormControl(this.model.deliveryBusinessName));
    this.form.addControl('deliveryFirstName', new FormControl(this.model.deliveryFirstName));
    this.form.addControl('deliveryLastName', new FormControl(this.model.deliveryLastName));
    this.form.addControl('deliveryBusinessHours', new FormControl(this.model.deliveryBusinessHours));
    this.form.addControl('deliveryAddress1', new FormControl(this.model.deliveryAddress1, [Validators.required]));
    this.form.addControl('deliveryAddress2', new FormControl(this.model.deliveryAddress2));
    this.form.addControl('deliveryStateCode', new FormControl(this.model.deliveryStateCode, [Validators.required]));
    this.form.addControl('deliveryCity', new FormControl(this.model.deliveryCity, [Validators.required]));
    this.form.addControl('deliveryZip', new FormControl(this.model.deliveryZip, this.getValidators(5, 5, true)));
    this.form.addControl('deliveryNotes', new FormControl(this.model.deliveryNotes));
    this.form.addControl('deliveryPhone', new FormControl(this.model.deliveryPhone, [Validators.required, Validators.minLength(10), Validators.maxLength(18)]));
    this.form.addControl('deliveryLocationId', new FormControl(this.model.deliveryLocationId));
    this.form.addControl('useCustomerContactForDelivery', new FormControl(this.model.useCustomerContactForDelivery));
    this.loadAddlInfo('delivery', this.model.deliveryPhones)


    this.form.addControl('source', new FormControl(this.model.source));
    this.form.addControl('depositRequired', new FormControl(this.model.depositRequired, this.model.privateCustomer == 2 || this.model.privateCustomer == 3 ? [Validators.required] : []));
    this.form.addControl('reviewRequired', new FormControl(this.model.reviewRequired, [Validators.required]));
    this.form.addControl('isPrivateCustomerAtPickupOrDelivery', new FormControl(this.model.isPrivateCustomerAtPickupOrDelivery, !this.isPrivateCustomer ? [Validators.required] : []));
    this.form.addControl('privateCustomerLocationType', new FormControl(this.model.privateCustomerLocationType, !this.isPrivateCustomer && this.model.isPrivateCustomerAtPickupOrDelivery == YesNoNA.Yes ? [Validators.required] : []));
    this.form.addControl('assignedTo', new FormControl(this.model.assignedTo));
    this.form.addControl('customerExpectedPickup', new FormControl(this.model.customerExpectedPickup, [Validators.required]));
    this.form.addControl('customerExpectedDelivery', new FormControl(this.model.customerExpectedDelivery, [Validators.required]));
    this.form.addControl('specialInstructions', new FormControl(this.model.specialInstructions));
    this.form.addControl('isDocumentationNecessary', new FormControl(this.model.isDocumentationNecessary == null ? 3 : this.model.isDocumentationNecessary));


    // Billing Group
    this.form.addControl('poNumber', new FormControl(this.model.poNumber));
    this.form.addControl('additionalCost', new FormControl(this.model.additionalCost || 3, [Validators.required]));
    this.form.addControl('customerChargedType', new FormControl(this.model.customerChargedType, [Validators.required]));
    this.form.addControl('carrierPaymentType', new FormControl(this.model.carrierPaymentType, [Validators.required]));
    this.form.addControl('price', new FormControl(this.model.price, [Validators.required]));
    this.form.addControl('deposit', new FormControl(this.model.deposit));
    this.form.addControl('depositBy', new FormControl(this.model.depositBy == null ? null : this.model.depositBy));

    this.form.addControl('wash', new FormControl(this.model.wash));
    this.form.addControl('depositPaymentDate', new FormControl(this.model.depositPaymentDate == null ? null : this.setDateFormat(this.model.depositPaymentDate)));
    this.form.addControl('desiredProfit', new FormControl(this.model.desiredProfit));
    this.form.addControl('paymentNotes', new FormControl(this.model.paymentNotes));

    this.form.addControl('openEnclosed', new FormControl(this.model.openEnclosed == null ? this.lookups['openEnclosed'][0].value : this.model.openEnclosed, [Validators.required]));

    this.form.addControl('cancelationReason', new FormControl(this.model.cancelationReason));
    this.form.addControl('cancelationType', new FormControl(this.model.cancelationType));
    this.form.addControl('dryRun', new FormControl(this.model.dryRun));
    this.form.addControl('paymentToCustomer', new FormControl(this.model.paymentToCustomer));
    this.form.addControl('paymentToCarrier', new FormControl(this.model.paymentToCarrier));
    this.form.addControl('customerDryRunFee', new FormControl(this.model.customerDryRunFee));
    this.form.addControl('carrierDryRunFee', new FormControl(this.model.carrierDryRunFee));

    this.form.addControl('canceledBy', new FormControl(this.model.canceledBy));
    this.form.addControl('transportVehicle', new FormControl(this.model.transportVehicle));


    if (this.model.vehicles != null && this.model.vehicles.length > 0) {
      let vehicleForms = [];
      this.model.vehicles.forEach(r => {
        vehicleForms.push(this.fh.getVehicleForm(r));
      });
      this.form.addControl('vehicles', new FormArray(vehicleForms));
    } else {
      this.form.addControl('vehicles', new FormArray([this.fh.getVehicleForm()]));
    }


    if (this.model.status >= 1) {
      this.form.addControl('confirmReadyForPickup', new FormControl(this.model.confirmReadyForPickup == null ? 3 : this.model.confirmReadyForPickup, [Validators.required]));
      this.form.addControl('confirmedBy', new FormControl(this.model.confirmedBy, [Validators.required]));
      if(this.isOrderConfirmDelivery){
      this.form.addControl('confirmReadyForDelivery', new FormControl(this.model?.confirmReadyForDelivery == null ? 3 : this.model.confirmReadyForDelivery, [Validators.required]));
      this.form.addControl('confirmedByReadyForDelivery', new FormControl(this.model?.confirmedByReadyForDelivery, [Validators.required]));
      this.form.addControl('pickupDeliveryConfirmNotes', new FormControl(this.model?.pickupDeliveryConfirmNotes));
      }
      if (this.isNewRecordForDateOverhual) {
        this.addControlDynamically('customerExpectedPickupDates');
      }
      if(this.isNewRecordForDateOverhual && this.isOrderConfirmDelivery){
        this.addControlDynamically('customerExpectedDeliveryDates');
      }
    }

    if (this.model.status >= 2) {
      this.form.addControl('assignedCarrier', new FormControl(this.model.assignedCarrier));
      this.form.addControl("selectedCarrier", new FormControl(null));
      this.form.addControl('communicationPreferences', new FormControl(''));
      setTimeout(() => {
        this.valueChanges('assignedCarrier', this.model.assignedCarrier);
        this.onCarrierChange(this.model.assignedCarrier, this.lookups.carriers);
      }, 1);
      this.form.addControl('cargoInsuranceLimit', new FormControl(null));
      this.form.addControl('cargoInsuranceDeductible', new FormControl(null));
      this.form.addControl('dispatcherName', new FormControl(this.model.dispatcherName, [Validators.required]));
      this.form.addControl('dispatcherPhone', new FormControl(this.model.dispatcherPhone, [Validators.required, Validators.minLength(10), Validators.maxLength(18)]));
      this.form.addControl('dispatcherEmail', new FormControl(this.model.dispatcherEmail, [Validators.required, Validators.email]));
      if(this.isNewRecordForTruckOverhual){
      if (this.model.orderDriverDetail != null && this.model.orderDriverDetail.length > 0) {
        let driverTruckOverhualForm = [];
        this.model.orderDriverDetail.forEach(r => {
          driverTruckOverhualForm.push(this.fh.getDriverTruckOverhualForm(r, this.form.get("selectedCarrier")?.value?.carrierStatus));
        });
        this.form.addControl('orderDriverDetail', new FormArray(driverTruckOverhualForm));
      } else {
        this.form.addControl('orderDriverDetail', new FormArray([this.fh.getDriverTruckOverhualForm(null, this.form.get("selectedCarrier")?.value?.carrierStatus, true)]));
      }}
      else{
      this.form.addControl('driverName', new FormControl(this.model.driverName, [Validators.required]));
      this.form.addControl('driverPhone', new FormControl(this.model.driverPhone, [Validators.required, Validators.minLength(10), Validators.maxLength(18)]));
      this.form.addControl('trailerSize', new FormControl(this.model.trailerSize, [Validators.required]));
      }

      this.form.addControl('brokerFeePaid', new FormControl(this.model.brokerFeePaid == null ? 1 : this.model.brokerFeePaid));
      this.form.addControl('brokerFee', new FormControl(this.model.brokerFee <= 0 ? 0 : this.model.brokerFee));
      this.form.addControl('brokerFeePaidDate', new FormControl(this.model.brokerFeePaidDate == null ? null : this.setDateFormat(this.model.brokerFeePaidDate)));
      this.form.addControl('brokerFeePaymentMethod', new FormControl(this.model.brokerFeePaymentMethod?.toString()));
      this.loadAddlInfo('carrierEmails', this.model.carrierEmails)

      this.form.addControl('includeBoL', new FormControl(this.model.includeBoL));
      this.form.addControl('includePort', new FormControl(this.model.includePort));
      this.form.addControl('includeRidgeville', new FormControl(this.model.includeRidgeville));
      if (this.isNewBookedOrderNumber) {
        this.form.addControl(
          "whoBooked",
          new FormControl(
            this.status === 2 &&
            localStorage.getItem("userId") &&
            !isNaN(Number(localStorage.getItem("userId")))
              ? +localStorage.getItem("userId")
              : this.model.whoBooked,
            [Validators.required]
          )
        );
        this.form.addControl(
          "bookedBy",
          new FormControl(this.model.bookedBy, [Validators.required])
        );
      }

      this.form.addControl('priceToCarrier', new FormControl(this.model.priceToCarrier, [Validators.required]));
      if (this.model.carrierPaymentType == 4 ||
        (
          (this.model.carrierPaymentType == 1 || this.model.carrierPaymentType == 2) && (this.model.balanceDue < this.model.priceToCarrier)
        )) {
        this.form.addControl('paymentTerms', new FormControl(this.model.paymentTerms, [Validators.required]));
      } else {
        this.form.addControl('paymentTerms', new FormControl(this.model.paymentTerms));
      }
      this.form.addControl('adjustmentToProfit', new FormControl(this.model.adjustmentToProfit));
      this.form.addControl('adjustmentProfit', new FormControl(null));
      this.form.addControl('paymentTerms', new FormControl(this.model.paymentTerms, [Validators.required]));
      this.cachedCarrierPaymentTerms = this.model.paymentTerms;
      if (this.isNewRecordForDateOverhual) {
        if(!this.isOrderConfirmDelivery){
          this.addControlDynamically('customerExpectedDeliveryDates');
        }
        this.addControlDynamically("carrierScheduledPickupDates");
        this.addControlDynamically("carrierScheduledDeliveryDates");
        this.form.addControl("scheduledPickup", new FormControl(this.model.scheduledPickup)
        );
        this.form.addControl("scheduledDelivery", new FormControl(this.model.scheduledDelivery)
        );
      } else {
        this.form.addControl("scheduledPickup", new FormControl(this.model.scheduledPickup, [Validators.required]));
        this.form.addControl("scheduledDelivery", new FormControl(this.model.scheduledDelivery, [Validators.required]));
        this.form.addControl("pickupConfirmationDate", new FormControl(this.model.pickupConfirmationDate == null ? null : new Date(this.model.pickupConfirmationDate)));
        // this.form.addControl("dateToInvoiceCustomer", new FormControl(this.model.dateToInvoiceCustomer == null ? null : this.datePipe.transform(this.model.dateToInvoiceCustomer, "MM/dd/yyyy", "UTC"), [Validators.required]));
        this.form.addControl('scheduledChangeReason', new FormControl());
      }
      this.form.addControl('isValidForDispatch', new FormControl(this.model?.isValidForDispatch || false));
    }

    if (this.model.status >= 3) {
      this.showLocationSearchButton = false;
      this.form.addControl('actualPickupDate', new FormControl(this.model.actualPickupDate == null ? null : new Date(this.model.actualPickupDate), [Validators.required]));
      this.form.addControl('pickupConfirmedBy', new FormControl(this.model.pickupConfirmedBy, [Validators.required]));
      this.form.addControl('pickupCarrierTransportResult', new FormControl(this.model.pickupCarrierTransportResult == null ? [] : this.model.pickupCarrierTransportResult, [Validators.required, pickupTransportResultValidator]));
      setTimeout(() => {
        this.onTransportResultDropDownSelect('carrierTransportResults', this.model.pickupCarrierTransportResult == null ? [] : this.model.pickupCarrierTransportResult);
      }, 1)
      this.form.addControl('pickupFSCTransportResult', new FormControl(this.model.pickupFSCTransportResult == null ? [] : this.model.pickupFSCTransportResult.filter((ele)=> ele !== 9), [Validators.required]));
      this.onTransportResultDropDownSelect('fscTransportResults',this.model.pickupFSCTransportResult == null ? [] : this.model.pickupFSCTransportResult);
      this.form.addControl('callback1', new FormControl(this.model?.callback1));
      this.form.addControl('callback1date', new FormControl(this.model?.callback1date == null ? null : new Date(this.model.callback1date)));
      this.form.addControl('callback1note', new FormControl(this.model?.callback1note));
      if (this.isNewRecordForDateOverhual) {
        this.form.addControl('isPickupNewETA', new FormControl(this.model.isPickupNewETA));
        this.form.addControl('isDeliveryNewETA', new FormControl(this.model.isDeliveryNewETA));
        this.form.addControl('deliveryNewETAReason', new FormControl(''));
        this.form.addControl('pickupNewETAReason', new FormControl(''));
      }
    }

    if (this.model.status >= 4) {
      this.form.addControl('actualDeliveryDate', new FormControl(this.model.actualDeliveryDate == null ? null : new Date(this.model.actualDeliveryDate), [Validators.required]));
      this.form.addControl('deliveryConfirmedBy', new FormControl(this.model.deliveryConfirmedBy, [Validators.required]));
      this.form.addControl('CarrierPaid', new FormControl(this.model.carrierPaid));
      this.form.addControl('carrierPaidDate', new FormControl(this.model.carrierPaidDate));
      this.form.addControl('achNotes', new FormControl(this.model.achNotes));
      this.form.addControl('deliveryCarrierTransportResult', new FormControl(this.model.deliveryCarrierTransportResult == null ? [] : this.model.deliveryCarrierTransportResult, [Validators.required, deliveryTransportResultValidator]));
      setTimeout(() => {
        this.onTransportResultDropDownSelect('deliveryCarrierTransportResults', this.model.deliveryCarrierTransportResult == null ? [] : this.model.deliveryCarrierTransportResult);
      }, 1)
      this.form.addControl('deliveryFSCTransportResult', new FormControl(this.model.deliveryFSCTransportResult == null ? [] : this.model.deliveryFSCTransportResult.filter((ele)=> ele !== 9), [Validators.required]));
      this.onTransportResultDropDownSelect('deliveryfscTransportResults',this.model.deliveryFSCTransportResult == null ? [] : this.model.deliveryFSCTransportResult);
      if (this.isNewRecordForDateOverhual) {
        this.form.addControl('isDeliveryNewETAForDeliveryDetails', new FormControl(this.model.isDeliveryNewETAForDeliveryDetails));
      }
      this.form.addControl('callback2', new FormControl(this.model?.callback2));
      this.form.addControl('callback2date', new FormControl(this.model?.callback2date == null ? null : new Date(this.model.callback2date)));
      this.form.addControl('callback2note', new FormControl(this.model?.callback2note));
      this.form.addControl('carrierPolicyDetail', new FormControl(this.model?.carrierPolicyDetail));
      if (this.model?.carrierPolicyDetail && this.status > 4) {
        this.policyDetails = this.model.carrierPolicyDetail;
        this.isPolicyEmpty = this.policyDetails?.length === 0;
        this.isPolicyExpired = this.policyDetails?.some((item) => item.isExpire);
      }
    }


    this.loadNav();
    this.loadKebob();

    this.loadFormFromSettings();
    this.ref.markForCheck();
    this.customerChargedTypeChanged();
  }

  addControlDynamically(key: string) {
    const orderDateType = allEnums.OrderDateType[key]
    if (this.model[key]?.length > 0) {
      let dateForms = [];
      this.model[key]?.forEach(r => {
        dateForms.push(this.fh.getDynamicDateForm(this.model?.id, orderDateType, r));
      });
      this.form.addControl(key, new FormArray(dateForms));
    } else {
      this.form.addControl(key, new FormArray([this.fh.getDynamicDateForm(this.model?.id, orderDateType)]));
    }
  }

  loadFormFromSettings() {
    if (this.orderSetting != null) {

      if (this.orderSetting.isTender) {
        this.formSettings.disableVehicles = true;
        this.formSettings.disableCustomer = true;
      }

      if (this.orderSetting.disableInvoicing) {
        console.log(this.navKeys);
        // if (this.navKeys.dispatch != null && !this.isNewRecordForDateOverhual) {
        //   this.navKeys.dispatch = this.navKeys.dispatch.filter(k => k !== 'dateToInvoiceCustomer');
        //   this.form.get('dateToInvoiceCustomer').clearValidators();
        //   this.form.get('dateToInvoiceCustomer').updateValueAndValidity();
        // }

        this.formSettings.disableInvoicing = true;

      }
    }
  }

  onDateChange(formKey: any) {
    if (formKey === 'deliveryNewETADates') {
      const validator = this.form.get('deliveryNewETAReason').hasValidator(Validators.required);
      if (!validator) {
        this.form.get('deliveryNewETAReason').setValidators([Validators.required]);
        this.form.get('deliveryNewETAReason').updateValueAndValidity();
      }
    }
    if (formKey === 'pickupNewETADates') {
      const validator = this.form.get('pickupNewETAReason').hasValidator(Validators.required);
      if (!validator) {
        this.form.get('pickupNewETAReason').setValidators([Validators.required]);
        this.form.get('pickupNewETAReason').updateValueAndValidity();
      }
    }
    this.disableSaveOnNewETAReasonInvalid();
  }

  commonFunctionForPickupAndDelivery(checkboxLabel: string, dateLabel: string, reasonLabel: string, navKeyValue: string) {
    if (this.form.get(checkboxLabel).value) {
      this.addControlDynamically(dateLabel);
      if (!this.navKeys[navKeyValue].includes(dateLabel)) {
        this.navKeys[navKeyValue].push(dateLabel);
      }
      if (!this.navKeys[navKeyValue].includes(reasonLabel)) {
        this.navKeys[navKeyValue].push(reasonLabel);
      }
      this.form.get(dateLabel)?.enable();
      this.form.get(reasonLabel)?.enable();
    } else {
      this.navKeys[navKeyValue] = this.navKeys[navKeyValue].filter((el: string) => {
        if (el == dateLabel || el == reasonLabel) {
          return false;
        } else {
          return true;
        }
      });
    }
    this.disableSaveOnNewETAReasonInvalid();
    this.ref.detectChanges();
  }

  disableSaveOnNewETAReasonInvalid() {
    let isPickupReasonValid = false, isDeliveryReasonValid = false;
    if (this.form.get('isPickupNewETA')?.value) {
      isPickupReasonValid = !this.form.get('pickupNewETAReason')?.valid;
    }
    if (this.form.get('isDeliveryNewETAForDeliveryDetails')?.value || this.form.get('isDeliveryNewETA')?.value) {
      isDeliveryReasonValid = !this.form.get('deliveryNewETAReason')?.valid;
    }
    this.isValidETAReason = isPickupReasonValid || isDeliveryReasonValid;
  }

  setDateFormat(date: any) {
    return this.datePipe.transform(date, 'MM/dd/yyyy', 'UTC');
  }

  // For Pickup Phones
  get getPickupPhone(): FormArray {
    return this.form.get('pickupPhones') as FormArray;
  }

  addPickupPhone() {
    this.getPickupPhone.push(new FormControl('', [Validators.minLength(10), Validators.maxLength(18)]));
  }

  removePickupPhone(i: number) {
    this.getPickupPhone.removeAt(i);
  }

  // For Delivery Phones
  get getDeliveryPhone(): FormArray {
    return this.form.get('deliveryPhones') as FormArray;
  }

  addDeliveryPhone() {
    this.getDeliveryPhone.push(new FormControl('', [Validators.minLength(10), Validators.maxLength(18)]));
  }

  removeDeliveryPhone(i: number) {
    this.getDeliveryPhone.removeAt(i);
  }

  loadCancelForm() {
    this.cancelForm = new FormGroup({}, []);
    this.cancelForm.addControl('cancelationReason', new FormControl(null, [Validators.required]));
  }

  loadRevertOrderForm(){
    this.revertForm = new FormGroup({}, []);
    this.revertForm.addControl('revertOrderReason', new FormControl(null, [Validators.required]));
  }

  loadPickupCancelForm() {
    let v:any;
    if (!this.isUpdateCancel) {
      v = {
        cancelationType: this.model.cancelationType,
        dryRun: this.model.dryRun,
        paymentToCarrier: this.model.paymentToCarrier,
        paymentToCustomer:this.model.paymentToCustomer,
        customerDryRunFee: this.model.customerDryRunFee,
        carrierDryRunFee: this.model.carrierDryRunFee,
        transportVehicle:this.model.transportVehicle,
        canceledBy: this.model.canceledBy,
        cancelationReason: this.model.cancelationReason,
      }
    } else {
      v = {
        cancelationType: this.form.get("cancelationType")?.value,
        dryRun: this.form.get("dryRun")?.value,
        paymentToCarrier: this.form.get("paymentToCarrier")?.value,
        paymentToCustomer: this.form.get("paymentToCustomer")?.value,
        customerDryRunFee: this.form.get("customerDryRunFee")?.value,
        carrierDryRunFee: this.form.get("carrierDryRunFee")?.value,
        transportVehicle: this.form.get("transportVehicle")?.value,
        canceledBy: this.form.get("canceledBy")?.value,
        cancelationReason: this.form.get("cancelationReason")?.value,
      };
    }
    this.pickupCancelForm = new FormGroup({}, []);
    this.pickupCancelForm.addControl('cancelationType', new FormControl(v.cancelationType, [Validators.required]));
    this.pickupCancelForm.addControl('dryRun', new FormControl(v.dryRun, [Validators.required]));
    this.pickupCancelForm.addControl('paymentToCarrier', new FormControl(v.paymentToCarrier));
    this.pickupCancelForm.addControl('paymentToCustomer', new FormControl(v.paymentToCustomer));
    this.pickupCancelForm.addControl('customerDryRunFee', new FormControl(v.customerDryRunFee));
    this.pickupCancelForm.addControl('carrierDryRunFee', new FormControl(v.carrierDryRunFee));
    this.pickupCancelForm.addControl('transportVehicle', new FormControl(v.transportVehicle, [Validators.required]));
    this.pickupCancelForm.addControl('canceledBy', new FormControl(v.canceledBy, [Validators.required]));
    if (this.model.status && +this.model.status === 5 && v.isCanceled) {
      this.pickupCancelForm.addControl('cancelationReason', new FormControl(v.cancelationReason));
    } else {
      this.pickupCancelForm.addControl('cancelationReason', new FormControl(v.cancelationReason, [Validators.required]));
    }
    this.loadPickupCancelFormSubs();
  }

  loadPickupCancelFormSubs() {
    let formFields = [
      'paymentToCarrier',
      'paymentToCustomer',
      'dryRun'
    ];

    formFields.forEach(f => {
      this.subs[f] = this.pickupCancelForm
        .get(f)
        .valueChanges.subscribe(() => this.updatePickupCancelForm());
    });

    this.updatePickupCancelForm();
  }

  updatePickupCancelForm() {
    let dryRun = this.pickupCancelForm.get('dryRun').value;
    let cancellationType = this.pickupCancelForm.get('cancelationType').value;
    let carrierPayment = this.pickupCancelForm.get('paymentToCarrier').value;
    let customerPayment = this.pickupCancelForm.get('paymentToCustomer').value;

    this.isDryRun = dryRun == 2;
    this.isCarrierCanceled = cancellationType == 1;
    this.isPaymentToCarrier = carrierPayment == 2;
    this.isPaymentToCustomer = customerPayment == 2;

    if (this.isDryRun) {
      this.pickupCancelForm.get('paymentToCarrier').setValidators([Validators.required]);
      this.pickupCancelForm.get('paymentToCustomer').setValidators([Validators.required]);

      this.pickupCancelForm.get('paymentToCarrier').updateValueAndValidity({ emitEvent: false });
      this.pickupCancelForm.get('paymentToCustomer').updateValueAndValidity({ emitEvent: false });

      if (this.isPaymentToCarrier) {
        this.pickupCancelForm.get('carrierDryRunFee').setValidators([Validators.required]);
        this.pickupCancelForm.get('carrierDryRunFee').updateValueAndValidity();
      } else {
        this.pickupCancelForm.get('carrierDryRunFee').setValue(null);
        this.pickupCancelForm.get('carrierDryRunFee').clearValidators();
        this.pickupCancelForm.get('carrierDryRunFee').updateValueAndValidity();
      }

      if (this.isPaymentToCustomer) {
        this.pickupCancelForm.get('customerDryRunFee').setValidators([Validators.required]);
        this.pickupCancelForm.get('customerDryRunFee').updateValueAndValidity();
      } else {
        this.pickupCancelForm.get('customerDryRunFee').setValue(null);
        this.pickupCancelForm.get('customerDryRunFee').clearValidators();
        this.pickupCancelForm.get('customerDryRunFee').updateValueAndValidity();
      }

      if (!this.isPaymentToCustomer && !this.isPaymentToCarrier) {
        this.missingPaymentInfo = true;
      } else {
        this.missingPaymentInfo = false;
      }

    } else {
      this.pickupCancelForm.get('paymentToCarrier').setValue(null, { emitEvent: false });
      this.pickupCancelForm.get('paymentToCustomer').setValue(null, { emitEvent: false });
      this.pickupCancelForm.get('customerDryRunFee').setValue(null);
      this.pickupCancelForm.get('carrierDryRunFee').setValue(null);
      this.pickupCancelForm.get('paymentToCarrier').clearValidators();
      this.pickupCancelForm.get('paymentToCustomer').clearValidators();
      this.pickupCancelForm.get('customerDryRunFee').clearValidators();
      this.pickupCancelForm.get('carrierDryRunFee').clearValidators();

      this.pickupCancelForm.get('paymentToCarrier').updateValueAndValidity({ emitEvent: false });
      this.pickupCancelForm.get('paymentToCustomer').updateValueAndValidity({ emitEvent: false });
      this.pickupCancelForm.get('customerDryRunFee').updateValueAndValidity();
      this.pickupCancelForm.get('carrierDryRunFee').updateValueAndValidity();
    }
  }

  clearPickupCancelFormSubs() {
    this.safeUnsub('cancelationType');
    this.safeUnsub('dryRun');
  }

  submitPickupCancelForm() {
    let v = this.pickupCancelForm.value;
    this.safeFormSet('isCanceled', true);
    this.safeFormSet('newStatus', this.status);
    this.safeFormSet('cancelationReason', v.cancelationReason);
    this.safeFormSet('cancelationType', v.cancelationType);
    this.safeFormSet('dryRun', v.dryRun);
    this.safeFormSet('paymentToCustomer', v.paymentToCustomer);
    this.safeFormSet('paymentToCarrier', v.paymentToCarrier);
    this.safeFormSet('carrierDryRunFee', v.carrierDryRunFee);
    this.safeFormSet('customerDryRunFee', v.customerDryRunFee);
    this.safeFormSet('transportVehicle', v.transportVehicle);
    this.safeFormSet('canceledBy', v.canceledBy);
    this.showPickupCancelDialog = false;
    this.isUpdateCancel = true;
    this.dryRunCancelOrderCalculation(v);
    if (this.isCancellationInfoReadOnly) {
      this.edit(false);
    } else {
      this.edit();
    }
  }

  dryRunCancelOrderCalculation(v: any) {
    if (v.dryRun == YesNoNA.No) {
      this.form.get('price').setValue(0);

      this.form.get('priceToCarrier').setValue(0);

      this.form.get('deposit').setValue(0);

      if (this.form.controls.carrierPaymentType.value != carrierPaymentType.Invoice && this.form.controls?.customerChargedType.value != customerChargedType.Invoice) {
        this.form.get('paymentTerms').setValue(null);
        this.form.get('paymentTerms').updateValueAndValidity();
      }
    }
    else if (v.dryRun == YesNoNA.Yes
      && v.paymentToCustomer == YesNoNA.Yes
      && v.paymentToCarrier == YesNoNA.Yes) {

      this.form.get('price').setValue(v.customerDryRunFee ?? 0);

      if (this.form.get('depositRequired').value == YesNoNA.Yes) {
        this.form.get('deposit').setValue(v.customerDryRunFee ?? 0);
      }

      this.form.get('priceToCarrier').setValue(v.carrierDryRunFee ?? 0);

      this.form.get('carrierPaymentType').setValue(carrierPaymentType.Invoice)
      this.form.get('carrierPaymentType').updateValueAndValidity()
    }
    else if (v.dryRun == YesNoNA.Yes
      && v.paymentToCustomer == YesNoNA.No
      && v.paymentToCarrier == YesNoNA.Yes) {
      this.form.get('price').setValue(0);

      if (this.form.get('depositRequired').value == YesNoNA.Yes) {
        this.form.get('deposit').setValue(0);
      }


      this.form.get('priceToCarrier').setValue(v.carrierDryRunFee ?? 0);

      this.form.get('carrierPaymentType').setValue(carrierPaymentType.Invoice)
      this.form.get('carrierPaymentType').updateValueAndValidity()
    }
    else if (v.dryRun == YesNoNA.Yes
      && v.paymentToCustomer == YesNoNA.Yes
      && v.paymentToCarrier == YesNoNA.No) {

      this.form.get('price').setValue(v.customerDryRunFee ?? 0);

      if (this.form.get('depositRequired').value == YesNoNA.Yes) {
        this.form.get('deposit').setValue(v.customerDryRunFee ?? 0);
      }

      this.form.get('priceToCarrier').setValue(0);
    }
    this.form.get('price').updateValueAndValidity();
    this.form.get('priceToCarrier').updateValueAndValidity();
    this.form.get('deposit').updateValueAndValidity();
  }

  submitCancelForm() {
    let v = this.cancelForm.value;
    this.safeFormSet('isCanceled', true);
    this.safeFormSet('newStatus', this.status);

    this.safeFormSet('cancelationReason', v.cancelationReason);
    this.showCancelDialog = false;
    this.edit();

  }

  submitRevertOrderForm(){
    let v = this.revertForm.value;
    const revertOrderObject = {
      id: this.model.id,
      reason: v.revertOrderReason,
    };
    try {
      this.orderService
        .revertOrder(revertOrderObject)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            if (res != null) {
              if (!res.isError) {
                try {
                  this.sharedServiceClient
                    .getMenuCount("order")
                    .subscribe({
                      next: (orderRes) => {
                        this.navigationService.menuCountChange(
                          orderRes.body,
                          "order"
                        );
                        this.totalCount.order = false;
                      },
                      error: (error) => {
                        Sentry.captureException(error);
                      },
                    });
                  if (this.status == 5) {
                    this.sharedServiceClient.getMenuCount("invoice").subscribe({
                      next: (invoiceRes) => {
                        this.navigationService.menuCountChange(
                          invoiceRes.body,
                          "invoice"
                        );
                        this.totalCount.invoice = false;
                      },
                      error: (error) => {
                        Sentry.captureException(error);
                      },
                    });
                  }

                  this.messageService.add(this.toast(true, res.message));
                  this.totalTime = 0;
                  this.onRevert.emit(true);
                  this.ref.markForCheck();
                  this.onCancel.emit(
                    this.model?.id && this.model?.status >= 1
                      ? [this.model?.id]
                      : null
                  );
                } catch (nestedError) {
                  Sentry.captureException(nestedError);
                }
              } else {
                this.messageService.add(this.toast(false, res.message));
              }
            }
          },
          error: (error) => {
            Sentry.captureException(error);
          },
        });
    } catch (error) {
      Sentry.captureException(error);
    }

    this.showRevetOrderDialog = false;
  }
  

  loadNav() {
    this.navKeys = {};
    this.leftNav = [];

    if (this.status >= -1) {
      let nav = new ModalLeftNavItem();
      nav.key = 'basic';
      nav.label = 'Basic';
      nav.order = 0;
      nav.selected = true;
      this.navKeys['basic'] = [];


      this.navKeys.basic.push('payDrop');
      this.navKeys.basic.push('perVehicleDollarAmount');
      this.navKeys.basic.push('payDropReason');
      this.navKeys.basic.push('dealerTrade');
      this.navKeys.basic.push('privateCustomer');
      this.navKeys.basic.push('customerDocs');
      if(this.isNewCustomerDocOrder){
        this.navKeys.basic.push('customerDocCustomer');
        this.navKeys.basic.push('customerDocPickup');
        this.navKeys.basic.push('customerDocDelivery');
      }
      this.navKeys.basic.push('customerDocsSignedDate');
      this.navKeys.basic.push('assignedTo');
      if (this.isAdmin) {
        this.navKeys.basic.push('salesAgentCommission');
        this.navKeys.basic.push('salesAgentCommissionPercentage');
      }

      if (this.isAdding) {
        this.navKeys.basic.push('numOrders');
        this.navKeys.basic.push('newClient');
      }

      this.leftNav.push(nav);

      nav = new ModalLeftNavItem();
      nav.key = 'order';
      nav.label = 'Order';
      nav.order = 20;
      nav.count = 0;
      this.navKeys['order'] = [];
      this.navKeys.order.push('source');
      this.navKeys.order.push('depositRequired');
      this.navKeys.order.push('reviewRequired');
      this.navKeys.order.push('isPrivateCustomerAtPickupOrDelivery');
      this.navKeys.order.push('privateCustomerLocationType');
      this.navKeys.order.push('specialInstructions');
      this.navKeys.order.push('isDocumentationNecessary');

      this.leftNav.push(nav);

      nav = new ModalLeftNavItem();
      nav.key = 'vehicles';
      nav.label = 'Vehicles';
      nav.order = 20;
      nav.count = 0;
      if (this.form.contains('vehicles') && (this.form.get('vehicles') as FormArray).length > 0)
        nav.count = (this.form.get('vehicles') as FormArray).length;
      this.navKeys['vehicles'] = [];
      this.navKeys.vehicles.push('openEnclosed');
      this.navKeys.vehicles.push('vehicles');

      this.leftNav.push(nav);

      nav = new ModalLeftNavItem();
      nav.key = 'customer';
      nav.label = 'Customer';
      nav.order = 30;
      nav.count = 0;
      this.navKeys['customer'] = [];
      this.navKeys.customer.push('customerFirstName');
      this.navKeys.customer.push('customerLastName');
      this.navKeys.customer.push('customerBusinessName');
      this.navKeys.customer.push('customerBusinessHours');
      this.navKeys.customer.push('customerEmail');
      this.navKeys.customer.push('customerAddress1');
      this.navKeys.customer.push('customerStateCode');
      this.navKeys.customer.push('customerCity');
      this.navKeys.customer.push('customerZip');
      this.navKeys.customer.push('customerPhoneType');
      this.navKeys.customer.push('customerPhone');
      this.navKeys.customer.push('orderContacts');
      this.navKeys.customer.push('customerId');
      this.navKeys.customer.push('selectedCustomer');
      this.navKeys.customer.push('segment');
      this.leftNav.push(nav);

      nav = new ModalLeftNavItem();
      nav.key = 'pickup';
      nav.label = 'Pickup';
      nav.order = 40;
      nav.count = 0;
      this.navKeys['pickup'] = [];
      this.navKeys.pickup.push('customerExpectedPickup');
      this.navKeys.pickup.push('pickupFirstName');
      this.navKeys.pickup.push('pickupLastName');
      this.navKeys.pickup.push('pickupBusinessName');
      this.navKeys.pickup.push('pickupBusinessHours');
      this.navKeys.pickup.push('pickupAddress1');
      this.navKeys.pickup.push('pickupStateCode');
      this.navKeys.pickup.push('pickupCity');
      this.navKeys.pickup.push('pickupZip');
      this.navKeys.pickup.push('pickupNotes');
      this.navKeys.pickup.push('pickupPhone');
      this.navKeys.pickup.push('pickupPhones');

      this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'delivery';
      nav.label = 'Delivery';
      nav.order = 50;
      nav.count = 0;
      this.navKeys['delivery'] = [];
      this.navKeys.delivery.push('customerExpectedDelivery');
      this.navKeys.delivery.push('deliveryFirstName');
      this.navKeys.delivery.push('deliveryLastName');
      this.navKeys.delivery.push('deliveryBusinessName');
      this.navKeys.delivery.push('deliveryBusinessHours');
      this.navKeys.delivery.push('deliveryAddress1');
      this.navKeys.delivery.push('deliveryStateCode');
      this.navKeys.delivery.push('deliveryCity');
      this.navKeys.delivery.push('deliveryZip');
      this.navKeys.delivery.push('deliveryNotes');
      this.navKeys.delivery.push('deliveryPhone');
      this.navKeys.delivery.push('deliveryPhones');

      this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'billing';
      nav.label = 'Billing';
      nav.order = 60;
      nav.count = 0;
      this.navKeys['billing'] = [];
      this.navKeys.billing.push('customerChargedType');
      this.navKeys.billing.push('carrierPaymentType');
      this.navKeys.billing.push('adjustmentToProfit');
      this.navKeys.billing.push('depositBy');
      this.navKeys.billing.push('price');
      this.navKeys.billing.push('deposit');
      this.navKeys.billing.push('depositPaymentDate');
      this.navKeys.billing.push('additionalCost');

      this.leftNav.push(nav);

    }

    if (this.status >= 1) {
      let nav = new ModalLeftNavItem();
      nav.key = 'confirmation';
      nav.label = 'Order Confirmation';
      nav.order = 70;
      this.navKeys['confirmation'] = [];
      this.navKeys.confirmation.push('confirmReadyForPickup');
      this.navKeys.confirmation.push('confirmedBy');
      if (this.isNewRecordForDateOverhual) {
        this.navKeys.confirmation.push('customerExpectedPickupDates');
      }
      if( this.isOrderConfirmDelivery){
        this.navKeys.confirmation.push('confirmReadyForDelivery');
        this.navKeys.confirmation.push('confirmedByReadyForDelivery');
      }
      if(this.isNewRecordForDateOverhual && this.isOrderConfirmDelivery){
        this.navKeys.confirmation.push('customerExpectedDeliveryDates');
      }
      this.leftNav.push(nav);

    }

    if (this.status >= 2) {
      let nav = new ModalLeftNavItem();
      nav.key = 'dispatch';
      nav.label = 'Dispatch';
      nav.order = 80;
      this.navKeys['dispatch'] = [];
      this.navKeys.dispatch.push('dispatcherName');
      this.navKeys.dispatch.push('dispatcherPhone');
      this.navKeys.dispatch.push('dispatcherEmail');
      this.navKeys.dispatch.push('assignedCarrier');
      this.navKeys.dispatch.push('selectedCarrier');
      this.navKeys.dispatch.push('cargoInsuranceLimit');
      this.navKeys.dispatch.push('cargoInsuranceDeductible');
      if(this.isNewRecordForTruckOverhual){
      this.navKeys.dispatch.push('orderDriverDetail')
      }
      else{
      this.navKeys.dispatch.push('trailerSize');
      this.navKeys.dispatch.push('driverName');
      this.navKeys.dispatch.push('driverPhone');
      }
      this.navKeys.dispatch.push('priceToCarrier');
      this.navKeys.dispatch.push('adjustmentToProfit');
      this.navKeys.dispatch.push('paymentTerms');
      this.navKeys.dispatch.push('scheduledPickup');
      this.navKeys.dispatch.push('scheduledDelivery');
      if (this.isNewRecordForDateOverhual) {
        if(!this.isOrderConfirmDelivery){
          this.navKeys.dispatch.push('customerExpectedDeliveryDates');
        }
        this.navKeys.dispatch.push("carrierScheduledPickupDates");
        this.navKeys.dispatch.push("carrierScheduledDeliveryDates");
      }
       else {
        this.navKeys.dispatch.push('pickupConfirmationDate');
        // this.navKeys.dispatch.push('dateToInvoiceCustomer');
      }
      if (this.isNewBookedOrderNumber) {
        this.navKeys.dispatch.push("whoBooked");
        this.navKeys.dispatch.push("bookedBy");
      }
      this.leftNav.push(nav);
    }

    if (this.status >= 3) {
      let nav = new ModalLeftNavItem();
      nav.key = 'pickupDetails';
      nav.label = 'Pickup Details';
      nav.order = 90;
      this.navKeys['pickupDetails'] = [];
      this.navKeys.pickupDetails.push('actualPickupDate');
      this.navKeys.pickupDetails.push('pickupConfirmedBy');
      this.navKeys.pickupDetails.push('pickupCarrierTransportResult');
      this.navKeys.pickupDetails.push('pickupFSCTransportResult');
      this.navKeys.pickupDetails.push('callback1');
      this.navKeys.pickupDetails.push('callback1date');
      this.navKeys.pickupDetails.push('callback1note');
      if (this.isNewRecordForDateOverhual) {
        this.navKeys.pickupDetails.push('pickupNewETADates');
        this.navKeys.pickupDetails.push('deliveryNewETADates');
      }

      this.leftNav.push(nav);
    }

    if (this.status >= 4) {
      let nav = new ModalLeftNavItem();
      nav.key = 'deliveryDetails';
      nav.label = 'Delivery Details';
      nav.order = 100;
      this.navKeys['deliveryDetails'] = [];
      this.navKeys.deliveryDetails.push('actualDeliveryDate');
      this.navKeys.deliveryDetails.push('deliveryConfirmedBy');
      this.navKeys.deliveryDetails.push('deliveryCarrierTransportResult');
      this.navKeys.deliveryDetails.push('deliveryFSCTransportResult');
      this.navKeys.deliveryDetails.push('callback2');
      this.navKeys.deliveryDetails.push('callback2date');
      this.navKeys.deliveryDetails.push('callback2note');
      this.navKeys.deliveryDetails.push('carrierPolicyDetail');
      if (this.isNewRecordForDateOverhual) {
        this.navKeys.deliveryDetails.push('deliveryNewETADates');
      }


      this.leftNav.push(nav);
    }

    if (!this.isAdding || true) {
      let nav = new ModalLeftNavItem();
      nav.key = 'notes';
      nav.label = 'Notes';
      nav.order = 1000;
      nav.count = 0;
      this.navKeys['notes'] = [];

      this.leftNav.push(nav);
    }

    let navMain = new ModalLeftNavItem();
    navMain.key = 'documents';
    navMain.label = 'Documents';
    navMain.order = 1010;
    navMain.count = 0;
    this.navKeys['documents'] = [];

    this.leftNav.push(navMain);


    this.leftNav = this.leftNav.sort((a, b) => {
      if (a.order > b.order) return 1;
      if (a.order < b.order) return -1;
      return 0;
    });

    this.leftNav = this.leftNav.slice();
  }

  loadAddlInfo(key: string, v: string) {
    if (v == null || v.length == 0 || v === 'null' || v === 'undefined') {
      this.additionalInfo[key] = [];
    } else {
      this.additionalInfo[key] = [];

      v.split(';').forEach(s => {
        if (s == null || s == '' || s === 'null' || s === 'undefined')
          return;
        this.additionalInfo[key].push(s);
      });
    }

    if (key == "emails") {
      this.validate_additional_emails("customer", key);
      this.form.markAllAsTouched();
    }
    if (key == "carrierEmails") {
      this.validate_additional_emails("dispatch", key);
    }
    this.ref.markForCheck();
  }

  getAddlInfo(key: string): string {
    if (this.additionalInfo == null || this.additionalInfo[key] == null || this.additionalInfo[key].length == 0) {
      return null;
    }

    return this.getArrayString(this.additionalInfo[key]);
  }

  addAddlInfo(key: string) {
    this.additionalInfo[key].push(null);
    this.ref.markForCheck();
  }

  removeAddlInfo(key: string, i: number) {
    if (i < 0 || i > this.additionalInfo[key].length) return;
    this.additionalInfo[key].splice(i, 1);
    this.additionalInfo[key] = this.additionalInfo[key].slice();
    if (key == "emails") {
      this.validate_additional_emails("customer", key);
    }
    if (key == "carrierEmails") {
      this.validate_additional_emails("dispatch", key);
    }
    this.ref.markForCheck();

  }

  phoneTrackBy(index, item) {
    return index;
  }

  addlInfoArray(key: string) {
    if (this.additionalInfo == null || this.additionalInfo[key] == null || this.additionalInfo[key].length == 0)
      return [];
    return Array(this.additionalInfo[key].length);
  }

  selectCurrentNav() {
    switch (this.model.status) {
      case -1:
      case 0:
      case 5:
      case 6:
        this.leftNavSelected = 'basic';
        break;
      case 1:
        this.leftNavSelected = 'confirmation';
        break;
      case 2:
        this.leftNavSelected = 'dispatch';
        break;
      case 3:
        this.leftNavSelected = 'pickupDetails';
        break;
      case 4:
        this.leftNavSelected = 'deliveryDetails';
        break;
    }
    this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService
      .get(key, force)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r: any) => {
        this.lookups[key] = r;
      });
  }

  getCarriers() {
    this.userService.carriers().pipe(takeUntil(this.destroy$)).subscribe(carriers => {
      this.lookups["carriers"] = carriers.body;
      this.changeEvents["carriers"].next();
      this.valueChanges("assignedCarrier", this.model?.assignedCarrier);
      let currentCarrier = this.lookups?.carriers?.find(x => x.value == this.model.assignedCarrier);
      this.form.get("selectedCarrier").setValue(currentCarrier);
      this.form.get("selectedCarrier").setValidators([Validators.required]);
      this.form.get("selectedCarrier").updateValueAndValidity();
      this.loadCarrierDriversAndPolicies(this.model?.assignedCarrier)
      this.onCarrierChange(
        this.model?.assignedCarrier,
        this.lookups.carriers
      );
      this.loadedCarrierList = true;
    });
}

  load() {
    if (this.isAdding) {
      this.isNewCustomerDocOrder = true;
      this.isNewHubSpotDealOrderNumber = true;
      this.isShowPickupPassword = true;
      this.orderService
        .getEditNew()
        .pipe(takeUntil(this.destroy$))
        .subscribe((r) => {
          this.metadata = r.body;
          this.orderSetting = new OrderSetting();
          this.loadForm();
          this.setFormValueSubs();
          this.forceValidation();
          this.ref.markForCheck();
          this.isLoading = false;
          this.userService
            .agents1()
            .pipe(takeUntil(this.destroy$))
            .subscribe((r) => {
              this.lookups["agents"] = r.body;
              this.changeEvents["agents"].next();
            });
        });
    } else if (this.isEditing) {
      this.orderService
        .getEdit(this.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (r) => {
            this.model = r.body;
            this.initialVehicleInformation =
              r.body.vehicles && r.body.vehicles.length > 0
                ? r.body.vehicles
                : [];
            this.orderSetting = this.model.settings;
            this.isTenderOrder = this.orderSetting?.isTender;
            this.metadata = this.model.metadata;
            this.initialModel = JSON.stringify(this.model);
            this.loadForm();
            this.setFormValueSubs();
            this.forceValidation();

            this.leftNav.forEach((n) => this.validateSection(n.key));

            this.selectCurrentNav();
            this.ref.markForCheck();
            this.isLoading = false;
            this.startTime = Date.now();
            this.timer();
            if (this.model.status >= 2) {
              this.loadLookup('paymentMethod');
              this.getCarriers()
            }

            this.onLoad.emit(this.model);

            this.applicationInsights.trackEvent('Order Loaded', {
              orderId: this.model.id,
              orderNumber: this.model.number,
              status: this.model.status,
              customerBusinessName: this.model.customerBusinessName,
              timestamp: new Date().toISOString()
            });

            this.userService
              .agents1()
              .pipe(takeUntil(this.destroy$))
              .subscribe((r) => {
                this.foundAssignedTo = r.body.some(
                  (item) => item.value == this.model.assignedTo
                );
                this.lookups["agents"] = r.body;
                this.changeEvents["agents"].next();
              });
          },
          (err) => {
            Sentry.captureException(err);
            if (err && err.error && err.error.message != null) {
              this.displayErrorMessage(err.error.message);
            } else if (err && err.status && err.status == 500) {
              this.messageService.add(
                this.toast(true, "Internal Server Error")
              );
              this.serverError = "Internal Server Error";
            }
            this.cancel();
          }
        );
    }
  }


  cancel() {
    this.totalTime = 0;
    this.form = new FormGroup({}, []);
    this.ref.markForCheck();
    this.onCancel.emit(this.model?.id ? [this.model?.id] : null);
  }

  setupVisibilityChangeListener() {
    this.visibilityChangeListener = () => {
      if (!document.hidden) {
        const timeRemaining = Math.round(this.totalTime);
        if (timeRemaining <= 120 && !this.warningShown) {
          this.safeFormSet('newStatus', this.status);
          this.edit(false);
          this.messageService.add(this.toast(true, `Auto Save in Progress, Order will close in 2 minutes`));
          this.warningShown = true;
          this.lastWarningTime = Date.now();
        }
      }
    };
    
    document.addEventListener('visibilitychange', this.visibilityChangeListener);
  }

  onNoActiveDriverFlagChange(val: boolean){
    this.hasActiveDriver = val;
  }

  timer() {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - this.startTime) / 1000;
    this.totalTime -= elapsedTime;

    if (this.totalTime <= 0) {
      this.totalTime = 0;
      this.cancel();
      return;
    }
    this.startTime = currentTime;
    const timeRemaining = Math.round(this.totalTime);
    if (timeRemaining <= 120 && !this.warningShown && (currentTime - this.lastWarningTime > 1000)) {
        this.safeFormSet('newStatus', this.status);
        this.edit(false);
        
        const message = `Auto Save in Progress, Order will close in 2 minutes`;
      
        this.messageService.add(this.toast(true, message));
        this.warningShown = true;
        this.lastWarningTime = currentTime;
    }

    if (this.totalTime > 0) {
      setTimeout(() => this.timer(), 1000); // Update every second instead of every frame
    }
  }

  get title(): string {
    return (this.form != null && this.form.contains('number') && this.form.get('number').value != null) ?
      'Order ' + this.form.get('number').value : 'Order';
  }

  get navIndex(): number {
    return this.leftNav.findIndex(r => r.key == this.leftNavSelected);
  }

  hasChanged(): boolean {
    let f = JSON.stringify(this.form.value);

    return f != this.initialModel;
  }

  clickLeftNav(n: ModalLeftNavItem) {
    this.applicationInsights.trackEvent('Order Navigation Click', {
      orderId: this.id,
      orderNumber: this.form.get('number')?.value,
      fromSection: this.leftNavSelected,
      toSection: n.key,
      timestamp: new Date().toISOString()
    });
    
      this.validateSection(this.leftNavSelected);
    this.leftNavSelected = n.key;
      if (this.leftNavSelected === 'delivery') {
        this.validateNewDeliveryContacts();
      }
      if (this.leftNavSelected === 'pickup') {
        this.validateNewPickupContacts();
      }
    this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);
    this.scrollToTop();
  }

  clickNext() {
    this.validateSection(this.leftNavSelected);
    let n = this.leftNav.findIndex(r => r.key == this.leftNavSelected);
    if (n < (this.leftNav.length - 1)) {
      let x = this.leftNav[n + 1];
      this.leftNavSelected = x.key;
      if (this.leftNavSelected === 'delivery') {
        this.validateNewDeliveryContacts();
      }
      if (this.leftNavSelected === 'pickup') {
        this.validateNewPickupContacts();
      }
      this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);

      this.scrollToTop();
    }
  }

  clickPrevious() {
    this.validateSection(this.leftNavSelected);
    let n = this.leftNav.findIndex(r => r.key == this.leftNavSelected);
    if (n > 0) {
      let x = this.leftNav[n - 1];
      this.leftNavSelected = x.key;
      if (this.leftNavSelected === 'delivery') {
        this.validateNewDeliveryContacts();
      }
      if (this.leftNavSelected === 'pickup') {
        this.validateNewPickupContacts();
      }
      this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);

      this.scrollToTop();

    }
  }

  validateSection(key: string) {
    let issueCount = 0;
    let nav = this.leftNav.find(n => n.key == key);
    if (nav != null) {
      let keys = this.navKeys[key];
      if (keys != null && keys.length > 0) {
        keys.forEach(k => {
          if (this.form.contains(k)) {
            if (this.form.get(k) instanceof FormArray) {
              if (!['pickupPhones', 'deliveryPhones'].includes(k) && ((this.form.get(k) as FormArray).length < 1)) {
                issueCount++;
              }
              (this.form.get(k) as FormArray).controls.forEach((c: any) => {
                if (c instanceof FormGroup) {
                  Object.keys((c as FormGroup).controls).forEach(ck => {
                    c.get(ck).markAsTouched();
                  });
                } else if (c instanceof FormControl) {
                  c.markAsTouched();
                }
              });
            } else {
              this.form.get(k).markAsTouched();
            }

            if (this.form.get(k).invalid)
              if (k != 'customerId') {   //added condition for customer validation count
              issueCount++;
            }
          }
        });
      }

      switch (key) {
        case 'documents':
          issueCount += this.errors.filter(e => e.subkey == 'docs').length;
          break;
        case 'customer':
          issueCount += this.errors.filter(e => e.subkey == 'contacts').length > 0 ? 1 : 0;
          issueCount += this.errors.filter(e => e.key == 'customer' && e.subkey == 'emailErrors').length > 0 ? 1 : 0;
          issueCount += !(this.form.get('contacts') as FormArray).valid && this.errors.filter(e => e.subkey == 'contacts').length == 0 ? 1 : 0;
          issueCount += this.errors.filter(e => e.subkey == 'customerOrLocationExist').length > 0 ? 1 : 0;
          break;
        case 'pickup':
          issueCount += this.errors.filter(e => e.subkey == 'pickupContacts').length > 0 ? 1 : 0;
          issueCount += !(this.form.get('pickupContacts') as FormArray).valid && this.errors.filter(e => e.subkey == 'pickupContacts').length == 0 ? 1 : 0;
          issueCount += this.errors.filter(e => e.subkey == 'pickupLocationExist').length > 0 ? 1 : 0;
          break;
        case 'delivery':
          issueCount += this.errors.filter(e => e.subkey == 'deliveryContacts').length > 0 ? 1 : 0;
          issueCount += !(this.form.get('deliveryContacts') as FormArray).valid && this.errors.filter(e => e.subkey == 'deliveryContacts').length == 0 ? 1 : 0;
          issueCount += this.errors.filter(e => e.subkey == 'deliveryLocationExist').length > 0 ? 1 : 0;
          break;
        case 'dispatch':
          issueCount += this.errors.filter(e => e.key == 'dispatch' && e.subkey == 'emailErrors').length > 0 ? 1 : 0;
          issueCount += this.errors.filter(e => e.subkey == 'assignedCarrier').length > 0 ? 1 : 0;
          issueCount += this.isPolicyExpired ? 1:0;
          issueCount += this.isPolicyEmpty? 1 : 0;
          issueCount += !this.isTransitCompleteCarrier? 1 : 0;
          break;
      }

      nav.issueCount = issueCount;
      nav.icon = issueCount > 0 ? './assets/images/alert' : './assets/images/input-selected-green';
    }
  }

  validate_additional_emails(sectionKey: string, additionalInfoKey: string) {
    let errorArray: any[] = [];
    this.additionalInfo[additionalInfoKey]?.forEach((v) => {
      if (v?.length > 0 && this.email_pattern.test(v)) {
        errorArray.push(false); //success
      } else if (v?.length > 0) {
        errorArray.push(true);  //error
      }
    });
    let ix = this.errors.findIndex(
      (e) => e.key == sectionKey && e.subkey == "emailErrors"
    );
    if (errorArray.find((e) => e == true)) {
      if (ix == -1) {
        this.errors.push({
          key: sectionKey,
          subkey: "emailErrors",
          message: "* Email is not a valid email address",
        });
      }
    } else {
      if (ix > -1) {
        this.errors.splice(ix, 1);
      }
    }
    this.validateSection(sectionKey);
  }

  markAllDirty(form: FormGroup) {
    form.markAllAsTouched();
    Object.keys(form.controls).forEach(key => {
      form.controls[key].markAsDirty();
      if (form.controls[key] instanceof FormArray) {
        (form.controls[key] as FormArray).controls.forEach(c => {
          if (c instanceof FormGroup) {
            this.markAllDirty(c);
          } else {
            c.markAllAsTouched();
            c.markAsDirty();
          }
        })
      }
    });
  }

  showError(key: string): boolean {
    return !(this.form.get(key).invalid && (this.form.get(key).dirty || this.form.get(key).touched))
  }

  get getButtons(): any[] {

    if (this.buttons.length > 0)
      return this.buttons;

    let buttons = [];

    this.kebob = [];

    if (this.isAdding) {
      buttons.push({ label: 'Save as Draft', key: 'draft', validate: false });
      buttons.push({ label: 'Create Order', key: 'draftToCreated', validate: true });
    } else {
      if (this.model != null) {
        this.isMultipleOderReadOnly = true;
        switch (this.model.status) {
          case 0:
            buttons.push({ key: 'showCancelDialog', label: 'Cancel Order', validate: false, class: 'danger' });
            buttons.push({ label: 'Save', key: 'draft', validate: false });
            buttons.push({ label: 'Update to New', key: 'updateDraftToCreated', validate: true });
            break;
          case 1:
            buttons.push({ key: 'showCancelDialog', label: 'Cancel Order', validate: false, class: 'danger' });
            buttons.push({ label: 'Save', key: 'created', validate: false });
            buttons.push({ label: 'Save as Ready to Dispatch', key: 'createdToReadyToDispatch', validate: true });
            break;
          case 2:
            buttons.push({ key: 'showCancelDialog', label: 'Cancel Order', validate: false, class: 'danger' });
            buttons.push({ label: 'Save', key: 'readyToDispatch', validate: false });
            buttons.push({ label: 'Save as Dispatched', key: 'readyToDispatchToDispatched', validate: true });
            break;
          case 3:
            buttons.push({ label: 'Revert to Ready to Dispatch ', key: 'showRevetOrderDialog', validate: false,class: 'danger'});
            buttons.push({ key: 'showPickupCancelDialog', label: 'Cancel Order', validate: false, class: 'danger' });
            buttons.push({ label: 'Save', key: 'dispatched', validate: false });
            buttons.push({ label: 'Save as Picked Up', key: 'dispatchedToPickedUp', validate: true });
            break;
          case 4:
            buttons.push({ label: 'Revert to Dispatched ', key: 'showRevetOrderDialog', validate: false,class: 'danger'});
            buttons.push({ key: 'showPickupCancelDialog', label: 'Cancel Order', validate: false, class: 'danger' });
            buttons.push({ label: 'Save', key: 'pickedUp', validate: false });
            buttons.push({ label: 'Save as Delivered', key: 'pickedUpToDelivered', validate: true });
            break;
          case 5:
            if (this.model.isCanceled && this.model.canceledBy) {
              this.isCancellationInfoReadOnly = true;
              buttons.push({ key: 'showPickupCancelDialog', label: 'Update Cancel', validate: false,class: 'danger' });
            }
            else if(!this.model.isCanceled && !this.model.canceledBy){
              buttons.push({ label: 'Revert to Picked Up', key: 'showRevetOrderDialog', validate: false,class: 'danger'});
            }
            buttons.push({ label: 'Save', key: 'delivered', validate: false });
            break;
          case 6:
            buttons.push({ label: 'Save', key: 'completedMoves', validate: false });
            break;
        }
      }
    }



    this.buttons = buttons;
    return this.buttons;
  }

  loadKebob() {
    this.kebob = [];
    if (!this.isAdding) {
      if (this.model != null) {
        switch (this.model.status) {
          case 0:
            this.kebob.push({ id: 'showCancelDialog', label: 'Cancel Order' });
            break;
          case 1:
            this.kebob.push({ id: 'showCancelDialog', label: 'Cancel Order' });
            break;
          case 2:
            this.kebob.push({ id: 'showCancelDialog', label: 'Cancel Order' });
            break;
          case 3:
            this.kebob.push({ id: 'showPickupCancelDialog', label: 'Cancel Order' });
            this.kebob.push({ id: 'showRevetOrderDialog', label: 'Revert to Ready to Dispatch' });
            break;
          case 4:
            this.kebob.push({ id: 'showCancelDialog', label: 'showPickupCancelDialog Order' });
            this.kebob.push({ id: 'showRevetOrderDialog', label: 'Revert to Dispatched' });
            break;
          case 5:
            this.kebob.push({ id: 'showRevetOrderDialog', label: 'Revert to Picked Up' });
            break;
        }
      }

      this.ref.markForCheck();
    }
  }

  loadLocationContacts(pickup: boolean) {
    if (pickup) {
      if (this.pickupLocationId != null) {
        this.contactService
          .get("Location", this.pickupLocationId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            this.pickupLocationContacts = res.body;
            this.pickupLocationContacts.forEach((c) => {
              c.id = -c.id;
              c.entityName = "OrderPickup";
              c.entityId = this.form.value.id;
              c.label = c.firstName + " " + c.lastName;
              c.value = c.id;
            });
            let pcontacts = this.form.get("pickupContacts") as FormArray;

            const selectedLocationIds: number[] = [];
            this.pickupLocationContacts.forEach((contact) => {
              const contactId = contact?.id;
              const usedLocationIds = pcontacts.value.map(
                (item) => -item.usedLocationId
              );
              if (
                usedLocationIds.includes(contactId) &&
                !selectedLocationIds.includes(contactId)
              ) {
                selectedLocationIds.push(contactId);
              }
            });

            this.form
              .get("selectedLoadExistingLocationForPickup")
              .setValue(selectedLocationIds);

            if (this.pickupLocationContacts.length >= 1) {
              (this.form.get("pickupContacts") as FormArray).markAllAsTouched();
            }
            if (
              pcontacts.length < 1 &&
              this.pickupLocationContacts.length <= 0 &&
              this.leftNavSelected == "pickup"
            ) {
              let pickupContactError = this.errors.findIndex(
                (e) => e.key == "updatePickupValidity"
              );
              console.log("else", pickupContactError);

              if (pickupContactError >= 0) {
                this.errors.splice(pickupContactError, 1);
                pickupContactError = 0;
              }
              if (
                pickupContactError <= 0 &&
                !this.form.get("useCustomerContactForPickup").value
              ) {
                this.errors.push({
                  key: "updatePickupValidity",
                  subkey: "pickupContacts",
                  message: "Please add at least 1 pickup contact.",
                });
                this.ref.detectChanges();
              }
            }
            this.validateSection("pickup");
            console.log("pickup", this.pickupLocationContacts);
          });
      }
    } else {
      if (this.deliveryLocationId != null) {
        this.contactService
          .get("Location", this.deliveryLocationId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            this.deliveryLocationContacts = res.body;
            this.deliveryLocationContacts.forEach((c) => {
              c.id = -c.id;
              c.entityName = "OrderDelivery";
              c.entityId = this.form.value.id;
              c.label = c.firstName + " " + c.lastName;
              c.value = c.id;
            });
            let dcontacts = this.form.get("deliveryContacts") as FormArray;

            const selectedLocationIds: number[] = [];
            this.deliveryLocationContacts.forEach((contact) => {
              const contactId = contact?.id;
              const usedLocationIds = dcontacts.value.map(
                (item) => -item.usedLocationId
              );
              if (
                usedLocationIds.includes(contactId) &&
                !selectedLocationIds.includes(contactId)
              ) {
                selectedLocationIds.push(contactId);
              }
            });

            this.form
              .get("selectedLoadExistingLocationForDelivery")
              .setValue(selectedLocationIds);

            if (this.deliveryLocationContacts.length >= 1) {
              (
                this.form.get("deliveryContacts") as FormArray
              ).markAllAsTouched();
            }

            if (
              dcontacts.length < 1 &&
              this.deliveryLocationContacts.length <= 0 &&
              this.leftNavSelected == "delivery"
            ) {
              let deliveryContactError = this.errors.findIndex(
                (e) => e.key == "updateDeliveryValidity"
              );
              if (deliveryContactError >= 0) {
                this.errors.splice(deliveryContactError, 1);
                deliveryContactError = 0;
              }
              if (
                deliveryContactError <= 0 &&
                !this.form.get("useCustomerContactForDelivery").value
              ) {
                this.errors.push({
                  key: "updateDeliveryValidity",
                  subkey: "deliveryContacts",
                  message: "Please add at least 1 delivery contact.",
                });
                this.ref.detectChanges();
              }
            }
            this.validateSection("delivery");
            console.log("delivery", this.deliveryLocationContacts);
          });
      }
    }

  }

  calculateBalance() {
    let price = this.form.get('price').value;
    let deposit = this.form.get('deposit').value;

    if (deposit == null) {
      deposit = 0;
    }

    if (price == null) {
      this.form.get('calculatedBalance').setValue(null);
    } else {
      this.form.get('calculatedBalance').setValue((+price - +deposit).toFixed(2).toString());
    }

    this.form.get('calculatedBalance').updateValueAndValidity();
    this.customerChargedTypeChanged();
  }

  calculatePriceToCarrier() {
    let terms = this.form.get('paymentTerms').value,
      priceToCarrier = this.form.get('priceToCarrier').value,
      wash = this.form.get('wash').value,
      balanceDue = this.form.get('calculatedBalance')?.value,
      customerChargedType = this.form.get('customerChargedType')?.value,
      carrierPaymentType = this.form.get('carrierPaymentType')?.value

    if (wash == null)
      wash = 0;

    if ((customerChargedType == 3 && (carrierPaymentType == 1)) || (customerChargedType == 4 && (carrierPaymentType == 2))) {
      if ((+priceToCarrier > +balanceDue)) {
        if (terms == 1 || terms == 7) {
          // 1 => 2 ach , 2 => 5 ach
          this.form
            .get("calculatedPriceToCarrier")
            ?.setValue(
              (
                +priceToCarrier -
                +balanceDue -
                +wash -
                0.05 * (+priceToCarrier - +balanceDue)
              )
                .toFixed(2)
                .toString()
            );
        } else if (terms == 2) {
          this.form
            .get("calculatedPriceToCarrier")
            ?.setValue(
              (
                +priceToCarrier -
                +balanceDue -
                +wash -
                0.03 * (+priceToCarrier - +balanceDue)
              )
                .toFixed(2)
                .toString()
            );
        } else {
          this.form
            .get("calculatedPriceToCarrier")
            ?.setValue(
              (+priceToCarrier - +wash - +balanceDue).toFixed(2).toString()
            );
        }
      } else if (((+priceToCarrier == +balanceDue) || +priceToCarrier < +balanceDue)) {
        this.form.get('calculatedPriceToCarrier')?.setValue((0).toString());
      }
    }
    else {
      if (terms == 1 || terms == 7) {
        this.form
          .get("calculatedPriceToCarrier")
          ?.setValue(
            (+priceToCarrier - 0.05 * +priceToCarrier - +wash)
              .toFixed(2)
              .toString()
          );
      } else if (terms == 2) {
        this.form
          .get("calculatedPriceToCarrier")
          ?.setValue(
            (+priceToCarrier - 0.03 * +priceToCarrier - +wash)
              .toFixed(2)
              .toString()
          );
      } else {
        this.form
          .get("calculatedPriceToCarrier")
          ?.setValue((+priceToCarrier - +wash).toFixed(2).toString());
      }
    }
  }



  calculateCompanyProfit() {
    let price = 0;
    if (this.form.contains('price'))
      price = this.form.get('price').value ? parseFloat(this.form.get('price').value) : 0;

    let deposit = 0;
    if (this.form.contains('deposit'))
      deposit = this.form.get('deposit').value ? parseFloat(this.form.get('deposit').value) : 0;

    let priceToCarrier = 0;
    if (this.form.contains('priceToCarrier'))
      priceToCarrier = this.form.get('priceToCarrier').value ? parseFloat(this.form.get('priceToCarrier').value) : 0;

    let customerChargedType = null;
    if (this.form.contains('customerChargedType'))
      customerChargedType = this.form.get('customerChargedType').value;

    let depositBy = null;
    if (this.form.contains('depositBy'))
      depositBy = this.form.get('depositBy').value;
    let fscPaidBy = null;

    if (this.model?.fscPaidBy) {
      fscPaidBy = this.model.fscPaidBy;
    }
    //update fscPaidBy for canceled order => prepay, invoice
    if (this.form.value?.isCanceled && this.form.value?.customerChargedType === CustomerChargedType.Prepay) {
      fscPaidBy = PaymentMethod['Credit Card']
    }

    let brokerFeePaymentMethod = null;
    if (this.form.contains('brokerFeePaymentMethod')) {
      brokerFeePaymentMethod = this.form.get('brokerFeePaymentMethod')?.value;
    }

    let balanceDue = 0;
    if (this.form.contains('calculatedBalance')) {
      balanceDue = this.form.get('calculatedBalance').value ? parseFloat(this.form.get('calculatedBalance').value) : 0;
    }

    if (price == null || customerChargedType == 0 || customerChargedType == null) {
      this.form.get('calculatedCompanyProfit').setValue(null);
      this.onChangeAdjuctmentToprofit()
      return;
    }
    let profit = null;
    let isdeducted = false;
    switch (customerChargedType) {
      case 3: // COD
        profit = deposit + (balanceDue - priceToCarrier);
        break;
      case 1: // PrePay
        profit = deposit + (balanceDue - priceToCarrier);
        break;
      case 2: // Invoice
        profit = deposit + (balanceDue - priceToCarrier);
        break;
      case 4: // COP
        profit = deposit + (balanceDue - priceToCarrier);
        break;
      case 0: // NA
      default:
        break;
    }

    const brokerFee: any = this.setBrokerFee(true);
    if ((depositBy == PaymentMethod['Credit Card'] || depositBy == PaymentMethod.Paypal) ||
      (brokerFee != null
        && (brokerFeePaymentMethod != PaymentMethod['Credit Card'] || brokerFeePaymentMethod != PaymentMethod.Paypal || brokerFeePaymentMethod == null)
        && (depositBy != PaymentMethod['Credit Card'] || depositBy != PaymentMethod.Paypal)
        && (fscPaidBy == PaymentMethod['Credit Card'] || fscPaidBy == PaymentMethod.Paypal))) {
      if (deposit) {
        profit = (profit) + (-(deposit * (environment.percentage_of_deduction / 100)));
        isdeducted = true;
      }
      this.form.get('calculatedCompanyProfit').setValue((Math.sign(profit) * Math.abs(Math.round(Math.sign(profit) * profit * 100) / 100)).toFixed(2));
    }

    // deduction from brocker fee
    let currentCompanyProfit: any = profit;
    this.form.get('calculatedCompanyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));

    if (brokerFee != null
      && (brokerFeePaymentMethod == PaymentMethod['Credit Card'] || brokerFeePaymentMethod == PaymentMethod.Paypal)) {
      currentCompanyProfit = (currentCompanyProfit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));

      this.form.get('calculatedCompanyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));
    }
    else if (!isdeducted && (fscPaidBy == PaymentMethod['Credit Card'] || fscPaidBy == PaymentMethod.Paypal)) {
      if (deposit) {
        currentCompanyProfit = (currentCompanyProfit) + (-(deposit * (environment.percentage_of_deduction / 100)));
      }
      else if (brokerFee != null) {
        currentCompanyProfit = (currentCompanyProfit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
      } else {
        currentCompanyProfit = (currentCompanyProfit) + (-((price) * (environment.percentage_of_deduction / 100)));
      }
      this.form.get('calculatedCompanyProfit').setValue((Math.sign(currentCompanyProfit) * Math.abs(Math.round(Math.sign(currentCompanyProfit) * currentCompanyProfit * 100) / 100)).toFixed(2));
    }
    // if (depositBy == PaymentMethod['Credit Card'] || depositBy == PaymentMethod.Paypal || fscPaidBy == PaymentMethod['Credit Card'] || fscPaidBy == PaymentMethod.Paypal) {
    //   let subtractCommission = 0;
    //   if (deposit) {
    //     subtractCommission = (result) + (-(deposit * (environment.percentage_of_deduction / 100)));
    //   } else {
    //     subtractCommission = (result) + (-(balanceDue * (environment.percentage_of_deduction / 100)));
    //   }
    //   profit = subtractCommission;
    // } else {
    //   profit = result;
    // }

    // // If broker fee paid from cc or pp then deduct it from profit
    // if ((brokerFeePaymentMethod) && (+brokerFeePaymentMethod == PaymentMethod['Credit Card'] || +brokerFeePaymentMethod == PaymentMethod.Paypal)) {
    //   const brokerFee: any = this.setBrokerFee(true);
    //   if (brokerFee !== null) {
    //     profit = (profit) + (-((+brokerFee) * (environment.percentage_of_deduction / 100)));
    //   }
    // }

    // this.form.get('calculatedCompanyProfit').setValue(profit);

     // for uncollectible

      if (this.model.invoicePaid == 5) {
        if (customerChargedType == 2) {
          currentCompanyProfit = currentCompanyProfit - (balanceDue ?? 0);
        } else if (
          (customerChargedType == 3 || customerChargedType == 4) &&
          this.form.get('depositRequired')?.value == 3
        ) {
          currentCompanyProfit = currentCompanyProfit - (Number(brokerFee) ?? 0);
        }
        this.form
          .get("calculatedCompanyProfit")
          .setValue(
            (
              Math.sign(currentCompanyProfit) *
              Math.abs(
                Math.round(
                  Math.sign(currentCompanyProfit) * currentCompanyProfit * 100
                ) / 100
              )
            ).toFixed(2)
          );
      }
    this.onChangeAdjuctmentToprofit();
  }

  setFormValueSubs() {
    let fields: string[] = [
      'payDrop',
      'rush',
      'vip',
      'isDocumentationNecessary',
      'privateCustomer',
      'depositRequired',
      'scheduledDelivery',
      'assignedCarrier',
      'price',
      'depositBy',
      'deposit',
      'priceToCarrier',
      'paymentTerms',
      'customerChargedType',
      'carrierPaymentType',
      'adjustmentToProfit',
      'depositPaymentDate',
      'calculatedBalance',
      'customerId',
      'newClient',
      'dealerTrade',
      'saveCustomer',
      'customerBusinessName',
      'deliveryBusinessName',
      'pickupBusinessName',
      // 'transportResults',
      'scheduledPickup',
      'orderContacts',
      'contacts',
      'pickupContacts',
      'deliveryContacts',
      'brokerFeePaid',
      'poNumber',
      'desiredProfit',
      'customerDocs',
      'customerDocCustomer',
      'customerDocPickup',
      'customerDocDelivery',
      'customerDocsSignedDate',
      'wash',
      'pickupLocationId',
      'deliveryLocationId',
      'isPrivateCustomerAtPickupOrDelivery',
      'savePickup',
      'saveDelivery',
      'saveCustomer',
      'isPickupNewETA',
      'isDeliveryNewETA',
      'isDeliveryNewETAForDeliveryDetails',
      'pickupCarrierTransportResult',
      'pickupFSCTransportResult',
      'pickupNewETAReason',
      'deliveryNewETAReason',
      'callback1',
      'callback2',
    ];

    fields.forEach(f => {
      if (this.form.contains(f)) {
        this.form
          .get(f)
          .valueChanges.pipe(takeUntil(this.destroy$))
          .subscribe((v) => this.valueChanges(f, v));
      }
    });

    this.form.statusChanges.pipe(takeUntil(this.destroy$)).subscribe((s) => {
          this.leftNav.forEach((n) => {
            if ((n.issueCount != null && n.issueCount > 0) || n.icon != null) {
              this.validateSection(n.key);
            }
          });
      });

  }

  onCustomerValueChange(key: string, message: string) {
    let fields: string[] = [];
    if (key == 'customerOrLocationExist') {
      if (message.includes('zip')) {
        fields = [
          'customerBusinessName',
          'customerCity',
          'customerZip'
        ];
      } else {
        fields = [
          'customerBusinessName',
          'customerCity',
        ];
      }
    }
    if (key == 'pickupLocationExist') {
      fields = [
        'pickupBusinessName',
        'pickupCity',
        'pickupZip'
      ];
    }
    if (key == 'deliveryLocationExist') {
      fields = [
        'deliveryBusinessName',
        'deliveryCity',
        'deliveryZip'
      ];
    }

    fields.forEach(f => {
      if (this.form.contains(f)) {
        this.form
          .get(f)
          .valueChanges.pipe(takeUntil(this.destroy$))
          .subscribe((v) => {
            if (
              f != "customerZip" ||
              (f == "customerZip" &&
                this.errors.findIndex(
                  (e) =>
                    e.key == "customerOrLocationExist" &&
                    e.message.includes("zip")
                ) != -1)
            ) {
              let ix = this.errors.findIndex((e) => e.key == key);
              if (ix > -1) this.errors.splice(ix, 1);
            }
          });
      }
    });
  }

  forceValidation() {
    let fields: any[] = [
      { key: "payDrop", fromOrder: true },
      { key: "newClient", fromform: true },
      { key: "saveCustomer", fromForm: true },
      { key: "privateCustomer", fromOrder: true },
      { key: "depositRequired", fromOrder: true },
      { key: "scheduledDelivery", fromOrder: true },
      { key: "priceToCarrier" },
      { key: "adjustmentToProfit" },
      { key: "price" },
      { key: "depositBy" },
      { key: "deposit" },
      { key: "paymentTerms" },
      { key: "customerChargedType" },
      { key: "carrierPaymentType" },
      { key: "customerDocs" },
      { key: "customerDocCustomer" },
      { key: "customerDocPickup" },
      { key: "customerDocDelivery" },
      { key: "calculatedBalance" },
      { key: "customerBusinessName" },
      { key: "pickupBusinessName" },
      { key: "deliveryBusinessName" },
      { key: "brokerFeePaid", fromOrder: true },
      { key: "desiredProfit" },
      { key: "pickupCarrierTransportResult" },
      { key: "pickupFSCTransportResult" },
      { key: "assignedCarrier", fromOrder: true },
      { key: "pickupLocationId" },
      { key: "deliveryLocationId" },
      { key: "isPickupNewETA" },
      { key: "isDeliveryNewETA" },
      { key: "isDeliveryNewETAForDeliveryDetails" },
      { key: "callback1" },
      { key: "callback2" },
    ];

    fields.forEach(f => {
      if (this.form.contains(f.key)) {
        let value = null;
        if (f.fromform)
          value = this.form.get(f.key).value;
        if (f.fromOrder)
          value = this.model[f.key];
        this.valueChanges(f.key, value);
      }
    });

  }

  setBrokerFee(getBrokerfee: boolean = false) {
    let customerChargedType = this.form.get('customerChargedType')?.value,
      carrierPaymentType = this.form.get('carrierPaymentType')?.value,
      priceToCarrier = this.form.get('priceToCarrier')?.value,
      balanceDue = this.form.get('calculatedBalance')?.value,
      depositRequired = this.form.get('depositRequired')?.value;  //2-yes, 3-no

    if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 3 && depositRequired == 2 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : this.form.get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 3 && depositRequired == 2 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue == +priceToCarrier) {
      return getBrokerfee ? 0 : this.form.get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 3 && depositRequired == 3 && carrierPaymentType == 1 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : this.form.get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 3 && depositRequired == 3 && (carrierPaymentType == 1) && +balanceDue < +priceToCarrier) {
      return getBrokerfee ? 0 : this.form.get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 4 && depositRequired == 2 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : this.form.get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 4 && depositRequired == 2 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue == +priceToCarrier) {
      return getBrokerfee ? 0 : this.form.get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 4 && depositRequired == 3 && carrierPaymentType == 2 && +balanceDue > +priceToCarrier) {
      return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : this.form.get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
    }
    else if (customerChargedType == 4 && depositRequired == 3 && (carrierPaymentType == 2) && +balanceDue < +priceToCarrier) {
      return getBrokerfee ? 0 : this.form.get('brokerFee')?.setValue(0)
    }
    else if (customerChargedType == 2 && depositRequired == 3 && carrierPaymentType == 4) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else if (customerChargedType == 1 && depositRequired == 2 && carrierPaymentType == 4 && +balanceDue < +priceToCarrier) {
      this.form.get('brokerFeePaid')?.setValue(1);
      return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
    }
    else {
      if (+balanceDue > +priceToCarrier) {
        return getBrokerfee ? (+balanceDue - +priceToCarrier)?.toFixed(2).toString() : this.form.get('brokerFee')?.setValue((+balanceDue - +priceToCarrier)?.toFixed(2).toString());
      } else {
        this.form.get('brokerFeePaid')?.setValue(1);
        return getBrokerfee ? null : this.form.get('brokerFee')?.setValue(null)
      }
    }
  }
  setPaymentTerms() {
    let customerChargedType = this.form.get('customerChargedType').value;
    this.isPaymentTermsReadOnly = false;
    if (this.form.contains('customerChargedType'))
      this.form.get('customerChargedType').setValidators([Validators.required]);
    if (customerChargedType != null) {
      //COP or COD
      if (customerChargedType === 3 || customerChargedType === 4) {
        if (this.form.contains('priceToCarrier') && this.form.contains('calculatedBalance')) {
          let pToC = this.form.get('priceToCarrier').value;
          let balanceDue = this.form.get('calculatedBalance').value;

          if (pToC != null && balanceDue != null) {
            if (+pToC <= +balanceDue) {
              if (this.form.contains('paymentTerms')) {
                if (this.form.controls.carrierPaymentType.value == carrierPaymentType.Invoice) {
                  this.isPaymentTermsReadOnly = false;
                  this.form.get('paymentTerms').setValue(this.cachedCarrierPaymentTerms ?? this.form.get('selectedCarrier').value?.paymentTerms);
                  this.form.controls.paymentTerms.setValidators(Validators.required);
                  this.form.controls.paymentTerms.updateValueAndValidity();
                } else {
                  this.isPaymentTermsReadOnly = true;
                  this.form.get('paymentTerms').setValue(null);
                  this.form.get('paymentTerms').setValidators([]);
                }

                if (this.model.status >= 5) {
                  this.form.get('CarrierPaid').setValue(2);
                  this.form.get('carrierPaidDate').setValue(this.form.get('actualDeliveryDate').value);
                  this.form.get('achNotes').setValue('N/A');
                }
              }
            }
          }
        }
      }

      if (customerChargedType === 1 || customerChargedType === 2) {
        this.isBrokerFeeReadOnly = true;
      } else {
        this.isBrokerFeeReadOnly = false;
      }

    }
    if (this.form.contains('paymentTerms')) {
      this.form.get('paymentTerms').setValue(this.cachedCarrierPaymentTerms ?? this.form.get('selectedCarrier').value?.paymentTerms);
      this.form.get('paymentTerms').updateValueAndValidity();
    this.form.get('customerChargedType').updateValueAndValidity({ emitEvent: false });
    }
  }

  setDefaultCarrierPaid() {
    let type = this.form.get('customerChargedType').value
    if (type != null) {
      //COP or COD
      if (type == 3) {
        if (this.form.contains('priceToCarrier') && this.form.contains('calculatedBalance')) {
          let pToC = this.form.get('priceToCarrier').value;
          let balanceDue = this.form.get('calculatedBalance').value;

          if (pToC != null && balanceDue != null) {
            if (+pToC <= +balanceDue) {

              if (this.model.status >= 4) {
                this.form.get('CarrierPaid').setValue(2);
                this.form.get('carrierPaidDate').setValue(this.form.get('actualDeliveryDate').value);
                this.form.get('achNotes').setValue('N/A');
              }
            }
          }

        }
      }
    }
  }

  setDepositBy() {

    if (this.model.status >= 3 && this.form.get('depositRequired').value == 2) {
      this.form.get('depositBy').setValidators([Validators.required]);
    } else {
      this.form.get('depositBy').clearValidators();
    }
    this.form.get('depositBy').updateValueAndValidity({ emitEvent: false });
  }

  setDepositPaymentDate() {
    if (this.form.get('customerChargedType').value == 1) {
      this.showDepositPaymentDate = true;
      this.form.get('depositPaymentDate').clearValidators();
    } else if (this.form.get('depositRequired').value == 2) {
      this.showDepositPaymentDate = true;
    } else {
      this.showDepositPaymentDate = false;
    }

    if (this.showDepositPaymentDate) {
      if (this.model.status >= 3 && this.form.get('depositBy').value != 9) {   // no deposit taken
        this.form.get('depositPaymentDate').setValidators([Validators.required]);
      } else {
        this.form.get('depositPaymentDate').clearValidators();
      }
    } else {
      this.form.get('depositPaymentDate').clearValidators();
      this.form.get('depositPaymentDate').setValue(null);
    }

    this.form.get('depositPaymentDate').updateValueAndValidity();
    this.changeUploads(this.uploads);
  }

  upload(e: any) {
    let f = {};
    f['orderId'] = this.model.id;
    f['filename'] = e.files[0].name;

    let reader = new FileReader();
    reader.onload = () => {
      let buffer = reader.result as ArrayBuffer;
      let array = new Uint8Array(buffer);
      let dataString = String.fromCharCode.apply(null, array);

      f['data'] = window.btoa(dataString);
      this.fileService
        .upload(f)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            this.messageService.add(this.toast(true, "File uploaded."));
          },
          (err) => {
            Sentry.captureException(err);
            this.messageService.add(this.toast(false, "Error occurred"));
            console.error("err", err);
          }
        );


    }

    reader.readAsArrayBuffer(e.files[0]);
  }

  documentIds(ids: any) {
    this.copyCancleDocs = ids;
  }

  rowsChange() {
    this.ref.detectChanges();
  }

  changeUploads(rows: any[]) {
    if (rows == null)
      return;

    this.uploads = rows.filter(r => r.id != null);
    this.errors = this.errors.filter(e => e.key != 'changeUploads');

    if (this.status == 0) {
      if (this.form.get('isDocumentationNecessary').value == 2) {
        if (this.uploads.length < 1) {
          this.errors.push({ key: 'changeUploads', subkey: 'docs', message: 'Please upload documentation prior to submitting.' });
        }

        this.validateSection('documents');
      }
    }


    if (this.status == 2) {
      if (this.uploads.length < 3) {
        this.errors.push({ key: 'changeUploads', subkey: 'docs', message: 'Please upload Dispatch profile page, ratings page and SAFER page.' });
      }
    }

    if (this.form.get('depositPaymentDate').value != null) {
      let hasPaymentProof = false;
      this.uploads.forEach(u => {
        let n = u.fileName;
        if (n == null)
          n = u.name;

        if (n != null && n.toLowerCase().indexOf('proof') > -1)
          hasPaymentProof = true;
      });

      if (!hasPaymentProof) {
        this.errors.push({ key: 'changeUploads', subkey: 'docs', message: 'Please upload payment proof prior to submitting.' });
      }
      if (this.isAdding) {
        this.validateSection('documents');
      }
    }

    if (
      ((typeof this.form.get("customerDocs").value === "number" &&
        this.form.get("customerDocs").value === 2) ||
        (Array.isArray(this.form.get("customerDocs").value) &&
          !this.form.get("customerDocs").value?.includes(3) &&
          (this.isValidSelection(this.form.get("customerDocCustomer")?.value) ||
            this.isValidSelection(
              this.form.get("customerDocPickup")?.value
            ) ||
            this.isValidSelection(
              this.form.get("customerDocDelivery")?.value
            ) || !this.isNewCustomerDocOrder))) &&
      this.form.get("customerDocsSignedDate").value != null
    ) {
      let hasCustomerDocs = false;
      this.uploads.forEach((u) => {
        let n = u.fileName;
        if (n == null) n = u.name;

        if (n != null && n.toLowerCase().indexOf("customerdoc") > -1)
          hasCustomerDocs = true;
      });

      if (!hasCustomerDocs) {
        this.errors.push({
          key: "changeUploads",
          subkey: "docs",
          message: "Please upload customer docs prior to submitting.",
        });
      }
      if (this.isAdding) {
        this.validateSection("documents");
      }
    }

    if (!this.isAdding) {
      this.validateSection('documents');
    }
  }

  onPrivateCutomerChange() {
    this.form.get('source').setValue(null);
  }

  onCustomerDocs(e){
    this.form.get('customerDocs').setValue(e.value)
  }

  valueChanges(key: string, v: any) {
    switch (key) {
      case 'pickupCarrierTransportResult':
        if (this.form.contains('pickupCarrierTransportResult')) {
          this.pickupCarrierLabel = this.lookups.carrierTransportResults.reduce((next, current) => {
            let index = this.form.get('pickupCarrierTransportResult').value.findIndex((r) => { return r === current.value });
            if (index > -1) {
              next = next ? `${next}, ${current.label}` : current.label;
            }
            return next;
          }, '');
        }
        break;
      case 'pickupFSCTransportResult':
        if (this.form.contains('pickupFSCTransportResult')) {
          this.pickupFSCLabel = this.lookups.fscTransportResults.reduce((next, current) => {
            let index = this.form.get('pickupFSCTransportResult').value.findIndex((r) => { return r === current.value });
            if (index > -1) {
              next = next ? `${next}, ${current.label}` : current.label;
            }
            return next;
          }, '');
        }
        break;
      case 'customerChargedType':
      case 'carrierPaymentType':
        this.setPaymentTerms();
        this.setDepositPaymentDate();
        this.calculateCompanyProfit();
        break;
      case 'depositBy':
        if (v != 9 && this.model.status >= 3) {  // no deposit taken
          this.form.get('depositPaymentDate').setValidators(Validators.required)
        } else {
          this.form.get('depositPaymentDate').clearValidators()
        }
        this.form.get('depositPaymentDate').updateValueAndValidity()
        this.setDepositBy();
        break;
      case 'additionalCost':
        this.validateSection('additionalCost');
        break;
      case 'depositPaymentDate':
        this.changeUploads(this.uploads);
        break;
      case 'calculatedBalance':
        this.setPaymentTerms();
        break;
      case 'isDocumentationNecessary':
        if (v == 2 && this.uploads.length < 1) {
          this.errors.push({ key: 'changeUploads', subkey: 'docs', message: 'Please upload documentation prior to submitting.' });
          this.validateSection('documents');
        } else {
          let ix = this.errors.findIndex(i => i.subkey == 'docs' && i.key == 'changeUploads');
          if (ix > -1) {
            this.errors.splice(ix, 1);
          }
        }
        break;
      case 'privateCustomer':
        if (this.isAdding) {

          // this.form.get('source').clearValidators();
          this.form.get('depositRequired').clearValidators();
          this.isPrivateCustomer = false;
          if (v == 2) {
            this.isPrivateCustomer = true;
            this.form.get('reviewRequired').setValue(2);
            this.form.get('newClient').setValue(3);
            // this.form.get('source').setValidators([Validators.required]);
            this.form.get('depositRequired').setValidators([Validators.required]);
            this.form.get('selectedCustomer').clearValidators();
            this.isAddContactEnabled$.next(true);
          }
          else if (v == 3) {
            this.form.get('depositRequired').setValidators([Validators.required]);
            if (this.form.get('newClient').value == 2) {
              this.form.get('selectedCustomer').clearValidators();
            } else {
              this.form.get('selectedCustomer').setValidators([Validators.required]);
            }
          }
          else {
            this.isPrivateCustomer = false;
            this.form.get('depositRequired').setValue(null);

            this.form.get('reviewRequired').setValue(3);
            this.form.get('selectedCustomer').setValidators([Validators.required]);
          }

          // this.form.get('source').updateValueAndValidity();
          this.form.get('reviewRequired').updateValueAndValidity();
          this.form.get('depositRequired').updateValueAndValidity();
        } else {
          let hasDepositAmt = this.form.contains('deposit');
          // this.form.get('source').clearValidators();
          this.form.get('depositRequired').clearValidators();

          if (hasDepositAmt)
            this.form.get('deposit').clearValidators();

          if (v == 2) {
            this.isPrivateCustomer = true;

            // this.form.get('source').setValidators([Validators.required]);
            this.form.get('depositRequired').setValidators([Validators.required]);
            if (this.form.get('depositRequired').value == 2 && hasDepositAmt && this.status >= 2) {
              this.form.get('deposit').setValidators([Validators.required]);
            }
            this.form.get('selectedCustomer').clearValidators()
          }
          else if (v == 3) {
            this.isPrivateCustomer = false;
            this.form.get('depositRequired').setValidators([Validators.required]);
            if (this.form.get('depositRequired').value == 2 && hasDepositAmt && this.status >= 2) {
              this.form.get('deposit').setValidators([Validators.required]);
            }
            if (this.form.get('newClient').value == 2) {
              this.form.get('selectedCustomer').clearValidators();
            } else {
              this.form.get('selectedCustomer').setValidators([Validators.required]);
            }
          }
          else {
            this.form.get('depositRequired').clearValidators();
            this.form.get('depositRequired').setValue(null);
            this.form.get('selectedCustomer').setValidators([Validators.required]);
            this.isPrivateCustomer = false;
          }

          // this.form.get('source').updateValueAndValidity();
          this.form.get('depositRequired').updateValueAndValidity();

          if (hasDepositAmt)
            this.form.get('deposit').updateValueAndValidity();
        }
        this.form.get('selectedCustomer').updateValueAndValidity()
        this.updateContactValidity();
        this.validateCustomerEmail();
        this.checkPrivateCustomerAtPickupOrDelivery();

        break;
      case 'depositRequired':
        if (this.form.contains('depositRequired')) {

          let hasDepositAmt = this.form.contains('deposit');
          if (hasDepositAmt)
            this.form.get('deposit').clearValidators();

          if (v == 3) {
            this.form.get('deposit').setValue(null);
            this.form.get('deposit').clearValidators();
            this.form.get('depositBy').setValue(null);
          }
          if (v == 2) {
            if ((this.form.get('privateCustomer').value == 2 || this.form.get('privateCustomer').value == 3) && hasDepositAmt && this.status >= 2) {
              this.form.get('deposit').setValidators([Validators.required]);
              this.setDepositBy();
            }
          }
          if (hasDepositAmt)
            this.form.get('deposit').updateValueAndValidity();

          this.setDepositPaymentDate();
        }
        break;
      case 'payDrop':
        if (v == 2) {
          this.payDropRequired = true;
          this.form.get('perVehicleDollarAmount').setValidators(Validators.required);
          this.form.get('payDropReason').setValidators(Validators.required);
        } else {
          this.payDropRequired = false;

          this.form.get('perVehicleDollarAmount').clearValidators();
          this.form.get('payDropReason').clearValidators();

        }
        this.form.get('perVehicleDollarAmount').updateValueAndValidity();
        this.form.get('payDropReason').updateValueAndValidity();
        break;
      case 'scheduledDelivery':
        if (this.form.contains('scheduledDelivery')) {
          if (this.model.scheduledDelivery != null
            && this.model.scheduledDelivery.length > 0
            && this.form.get('scheduledDelivery').value != null
            && this.form.get('scheduledDelivery').value.length > 0
            && this.form.get('scheduledDelivery').value != this.model.scheduledDelivery
            && this.model.scheduledDelivery != null) {
            if (!this.scheduledDateChanged) {
              this.scheduledDateChanged = true;
              if (!this.isNewRecordForDateOverhual) {
                this.form.get('scheduledChangeReason').setValidators([Validators.required]);
                this.form.get('scheduledChangeReason').updateValueAndValidity();
                this.form.get('pickupConfirmationDate').setValue(null);
                this.form.get('pickupConfirmationDate').setValidators([Validators.required]);
                this.form.get('pickupConfirmationDate').updateValueAndValidity();
              }
            }


            // if (!this.isNewRecordForDateOverhual) {
            //   this.form.get('dateToInvoiceCustomer').setValue(null);
            //   this.form.get('dateToInvoiceCustomer').updateValueAndValidity();
            // }
          }
        }
        break;
      case 'scheduledPickup':
        let d = new Date();
        if (this.model.scheduledPickup != null && this.model.scheduledPickup.length > 0) {
          d = this.model.scheduledPickup;
        }

        if (this.form.contains('scheduledPickup')) {
          if (this.form.get('scheduledPickup').value != null
            && this.form.get('scheduledPickup').value.length > 0
            && this.form.get('scheduledPickup').value != d
            && this.model.scheduledPickup != null) {
            if (!this.scheduledDateChanged) {
              this.scheduledDateChanged = true;
              if (!this.isNewRecordForDateOverhual) {
                this.form.get('scheduledChangeReason').setValidators([Validators.required]);
                this.form.get('scheduledChangeReason').updateValueAndValidity();
                this.form.get('pickupConfirmationDate').setValue(null);
                this.form.get('pickupConfirmationDate').setValidators([Validators.required]);
                this.form.get('pickupConfirmationDate').updateValueAndValidity();
              }
            }


          }
        }
        break;
      case 'newClient':
        if (this.isAdding) {
          while ((this.form.get('contacts') as FormArray)?.length > 0)
            (this.form.get('contacts') as FormArray).removeAt(0);
        }

        if (v == 2) {
          this.isNewClient = true;
          this.isNewClientYes = true;
          this.newClientSelected = true;
          this.form.get('saveCustomer').setValue(true);
          this.form.get('selectedCustomer').clearValidators();
        } else if (v == 3) {
          this.isNewClient = false;
          this.isNewClientYes = true;
          this.newClientSelected = true;
          this.form.get('saveCustomer').setValue(false);
          this.form.get('selectedCustomer').setValidators([Validators.required]);
          // Reset contact enable/disable state
          this.isContactDisabled = false;
          this.isAddContactEnabled$.next(true);
        } else {
          this.newClientSelected = false;
          this.isNewClient = false;
          this.isNewClientYes = false;
          this.form.get('selectedCustomer').setValidators([Validators.required]);
        }
        if (this.isAdding) {
          this.updateContactValidity();
        }
        this.form.get('selectedCustomer').updateValueAndValidity()
        this.validateCustomerEmail();

        break;
      case 'customerId':
        if (v != null) {
          let customer: any = null;

          if (this.lookups.customersList != null) {
            customer = this.lookups.customersList.find(r => r.id === v);
          }

          if (customer != null) {
            this.customerSelected = true;
            this.isContactsLoading = true;
            this.formService
              .getEdit('user', customer?.guid)
              .pipe(takeUntil(this.destroy$))
              .subscribe(res => {
                const model = res.body as any;

                if (this.isAdding) {
                  //clear contact list
                  for (let i = 0; i < (this.form.get('contacts') as FormArray)?.length; i++) {
                    if (((this.form.get('contacts') as FormArray).at(i) as FormGroup).get('id').value != 0) {
                      (this.form.get('contacts') as FormArray).removeAt(i);
                    }
                  }
                  this.form.get('contacts').updateValueAndValidity();
                } else {
                  //clear contact list
                  for (let i = 0; i < (this.form.get('contacts') as FormArray)?.length; i++) {
                    if (((this.form.get('contacts') as FormArray).at(i) as FormGroup).get('id').value < 0) {
                      (this.form.get('contacts') as FormArray).removeAt(i);
                    }
                  }
                  this.form.get('contacts').updateValueAndValidity();
                }

                this.customerContacts = [];
                if (model.contacts != null && model.contacts.length > 0) {
                  this.lookups.customerContacts = [];
                  this.customerContacts = model.contacts;

                  if (this.isAdding && (v == null || !this.firstCustomerLoad)) {
                    for (let i = 0; i < (this.form.get('contacts') as FormArray)?.length; i++) {
                      if (((this.form.get('contacts') as FormArray).at(i) as FormGroup).get('id').value != 0) {
                        (this.form.get('contacts') as FormArray).removeAt(i);
                      }
                    }
                    this.form.get('contacts').updateValueAndValidity();
                  }

                  this.form.get('customerContacts').setValue([]);
                  this.form.get('customerContacts').updateValueAndValidity();
                  model.contacts.forEach(contact => {
                    this.lookups
                      .customerContacts
                      .push({
                        value: contact.id,
                        label: contact.firstName + ' ' + contact.lastName,
                      });
                  });
                  this.customerContacts.forEach(c => {
                    c.id = -c.id;
                    c.entityName = 'Order';
                    c.entityId = this.form.value.id;
                    c.label = c.firstName + ' ' + c.lastName;
                    c.value = c.id;
                  });
                  let contacts = this.form.get('contacts') as FormArray;
                  const selectedLocationIds: number[] = [];
                  this.customerContacts.forEach(contact => {
                    const contactId = contact?.id;
                    const usedLocationIds = contacts.value.map(item => -item.usedCustomerLocationId);
                    if (usedLocationIds.includes(contactId) && !selectedLocationIds.includes(contactId)) {
                      selectedLocationIds.push(contactId);
                    }
                  });
                  this.form.get('selectedLoadExistingCustomer').setValue(selectedLocationIds)
                }



                const updatedCustomer ={

                  businessName: this.form.get('customerBusinessName').value,
                  businessHours: this.form.get('customerBusinessHours').value,
                  primaryContactPhoneType:this.form.get('customerPhoneType').value,
                  phone: this.form.get('customerPhone').value,
                  stateCode: this.form.get('customerStateCode').value,
                  city:this.form.get('customerCity').value,
                  zip:this.form.get('customerZip').value,
                  address1:this.form.get('customerAddress1').value,
                  address2:this.form.get('customerAddress2').value,
                  primaryContactEmail: this.form.get('customerEmail').value,

                  }

                  const customerDb ={

                    businessName: this.model.customerBusinessName,
                    businessHours: this.model.customerBusinessHours,
                    primaryContactPhoneType:this.model.customerPhoneType,
                    phone: this.model.customerPhone,
                    stateCode: this.model.customerStateCode,
                    city:this.model.customerCity,
                    zip:this.model.customerZip,
                    address1:this.model.customerAddress1,
                    address2:this.model.customerAddress2,
                    primaryContactEmail: this.model.customerEmail,

                    }

                if (this.isAdding || !this.firstCustomerLoad){
                  if(this.isAdding || this.model.customerId!=this.form.get('customerId').value){
                    this.populateCustomer(customer, model);
                  }
                  else if( this.model.customerId==this.form.get('customerId').value && this.isEditing){
                    this.populateCustomer(customerDb, { segment:this.model.segment,subsegment:this.model.subSegment});
                  }
                  else{
                    this.populateCustomer(updatedCustomer, model);
                  }
                } 

                if (v != null) {
                  this.firstCustomerLoad = false;
                  this.form.get('customerId').setValue(v, { emitEvent: false });
                  this.customerTempId = this.form.get('customerId').value;
                  this.form.get('selectedCustomer').setValue(customer, { emitEvent: false });
                  this.form.get('customerId').updateValueAndValidity({ emitEvent: false });
                  this.form.get('selectedCustomer').updateValueAndValidity({ emitEvent: false });
                }

                this.isContactsLoading = false;


              });
          } else {
            this.customerSelected = false;
            this.lookups.customerContacts = [];
            this.form.get('customerContacts').setValue([]);
            this.form.get('customerContacts').updateValueAndValidity();
          }
        } else {
          this.customerSelected = false;
          this.lookups.customerContacts = [];

          this.form.get('customerContacts').setValue([]);
          this.form.get('customerContacts').updateValueAndValidity();
        }
        break;
      case 'customerContacts':
        this.selectContacts(null, this.customerContacts, 'contacts');
        break;
      case 'contacts':
        this.validateNewContacts();
        break;
      case 'pickupContacts':
        this.validateNewPickupContacts();
        break;
      case 'deliveryContacts':
        this.validateNewDeliveryContacts();
        break;
      case 'dealerTrade':
        if (v == 5) {
          this.form.get('numOrders')?.setValidators(Validators.required);
          this.form.get('numOrders')?.setValue(2);
        } else {
          this.form.get('numOrders')?.clearValidators();
          this.form.get('numOrders')?.setValue(1);
          this.form.get('sameCustomer')?.setValue(false);
          this.form.get('samePickup')?.setValue(false);
          this.form.get('sameDelivery')?.setValue(false);
          this.form.get('samePaymentNotes')?.setValue(false);
        }
        this.form.get('numOrders')?.updateValueAndValidity();
        break;
      case 'saveCustomer':
        this.saveCustomer = v;
        this.validateCustomerEmail();
        if (!this.form.get('saveCustomer')?.value) {
          let ix = this.errors.findIndex(e => e.key == 'customerOrLocationExist');
          if (ix > -1)
            this.errors.splice(ix, 1);
        }
        break;
      case 'assignedCarrier':
        if (v != null && v > 0 && this.lookups.carriers != null) {
          let c = this.lookups.carriers.find(c => c.value == v);

          if (c != null) {
            this.assignedCarrierPhones = this.getStringArray(c.additionalPhones, ';');
            this.assignedCargoLimit = this.getStringArray(c.cargoInsuranceLimit, ';');
            this.cargoInsuranceDeductible = this.getStringArray(c.cargoInsuranceDeductible, ';');
            let temparr = [];
            let arr = [];
            arr = this.assignedCargoLimit.length > this.cargoInsuranceDeductible.length ? this.assignedCargoLimit : this.cargoInsuranceDeductible;
            for (let index = 0; index < arr.length; index++) {
              let obj = [];
              obj = [this.assignedCargoLimit[index] ? '$ ' + this.assignedCargoLimit[index] + ' ' : '- ', this.cargoInsuranceDeductible[index] ? ' $ ' + this.cargoInsuranceDeductible[index] : ' -'];
              temparr.push(obj);
            }
            this.assignedCargoLimit = temparr;
            this.assignedCarrierPhone = c.phone;
            this.mcNumber = c.mcDotNumber;

            this.businessPhone = c.businessPhone;
          } else {
            this.assignedCarrierPhone = null;
            this.assignedCarrierPhones = [];
            this.assignedCargoLimit = [];
            this.cargoInsuranceDeductible = [];
            this.businessPhone = null;
          }
        } else {
          this.assignedCarrierPhone = null;
          this.assignedCarrierPhones = [];
          this.assignedCargoLimit = [];
          this.cargoInsuranceDeductible = [];
          this.businessPhone = null;
          this.mcNumber = null
        }
        break;
      case 'priceToCarrier':
        this.calculatePriceToCarrier();
        this.calculateCompanyProfit();
        this.setPaymentTerms();
        this.setBrokerFee()
        break;
      case 'price':
        this.calculateBalance();
        this.calculateCompanyProfit();
        this.setBrokerFee()
        break;
      case 'deposit':
      case 'wash':
        this.calculateBalance();
        break;
      case 'paymentTerms':
        this.calculatePriceToCarrier();
        break;
      case 'vip':
      case 'rush':
        let vip = this.form.get('vip')?.value;
        let rush = this.form.get('rush')?.value;

        if (vip || rush) {
          this.form.get('payDrop').setValue(2);
        } else {
          this.form.get('payDrop').setValue(3);
        }
        this.form.get('payDrop').updateValueAndValidity();

        break;
      case 'customerBusinessName':
      case 'pickupBusinessName':
      case 'deliveryBusinessName':
        let hrsKey = '';
        switch (key) {
          case 'customerBusinessName': hrsKey = 'customerBusinessHours'; break;
          case 'pickupBusinessName': hrsKey = 'pickupBusinessHours'; break;
          case 'deliveryBusinessName': hrsKey = 'deliveryBusinessHours'; break;
        }

        let n = this.form.get(key).value;

        if (n == null || n.length < 1) {
          this.form.get(hrsKey).clearValidators();
        } else {
          this.form.get(hrsKey).setValidators([Validators.required]);
        }
        this.form.get(hrsKey).updateValueAndValidity();

        break;
      case 'brokerFeePaid':
        if (v == YesNoNA.Yes) {
          this.form.get('brokerFeePaidDate').setValidators([Validators.required]);
          this.form.get('brokerFeePaidDate').markAsDirty();
          this.form.get('brokerFeePaidDate').markAsTouched();
          this.form.get('brokerFeePaidDate').updateValueAndValidity();

          this.form.get('brokerFeePaymentMethod').setValidators([Validators.required]);
          this.form.get('brokerFeePaymentMethod').markAsDirty();
          this.form.get('brokerFeePaymentMethod').markAsTouched();
          this.form.get('brokerFeePaymentMethod').updateValueAndValidity();

        } else {
          this.form.get('brokerFeePaidDate').setValue(null);
          this.form.get('brokerFeePaidDate').clearValidators();
          this.form.get('brokerFeePaidDate').updateValueAndValidity();

          this.form.get('brokerFeePaymentMethod').setValue(null);
          this.form.get('brokerFeePaymentMethod').clearValidators();
          this.form.get('brokerFeePaymentMethod').updateValueAndValidity();
        }
        break;
      case 'desiredProfit':
        if (this.form.get('desiredProfit').value == null || this.form.get('desiredProfit').value.length < 1) {
          this.showDesiredProfit = false;
        } else {
          this.showDesiredProfit = true;
        }
        break;
      case 'customerDocs':
        if (((typeof this.form.get('customerDocs').value === 'number' && this.form.get('customerDocs').value === 2) ||
(Array.isArray(this.form.get('customerDocs').value) && !this.form.get('customerDocs').value?.includes(3) && this.form.get('customerDocs').value?.length>0 ))) {
          const customerDocsValue = this.form?.get('customerDocs').value;
          this.showCustomerDocsDate = true;
          if(Array.isArray(customerDocsValue) && this.isNewCustomerDocOrder){
          this.showPickupDoc = customerDocsValue.includes(1);
          this.showDeliveryDoc = customerDocsValue.includes(2);
          this.showCustomerDoc = customerDocsValue.includes(4);
          }
          else if(Array.isArray(customerDocsValue) && !this.isNewCustomerDocOrder){
            this.showYesCustomerDocs = customerDocsValue.includes(2);
          }
        }
        else{
          this.showCustomerDocsDate = false;
          this.showPickupDoc = false;
          this.showDeliveryDoc = false;
          this.showCustomerDoc = false;
          this.showYesCustomerDocs =false;
        }
        this.showCustomerDocsDateForValidField();

        if(this.showCustomerDoc){
          this.form.get('customerDocCustomer').setValidators([Validators.required]);
        }
        else{
          this.form.get('customerDocCustomer').setValue([]);
          this.form.get('customerDocCustomer').clearValidators();
        }

        if(this.showPickupDoc){
          this.form.get('customerDocPickup').setValidators([Validators.required]);
        }
        else{
          this.form.get('customerDocPickup').setValue([]);
          this.form.get('customerDocPickup').clearValidators();
        }

        if(this.showDeliveryDoc){
          this.form.get('customerDocDelivery').setValidators([Validators.required]);
        }
        else{
          this.form.get('customerDocDelivery').setValue([]);
          this.form.get('customerDocDelivery').clearValidators();
        }
        this.form.get('customerDocCustomer').updateValueAndValidity();
        this.form.get('customerDocPickup').updateValueAndValidity();
        this.form.get('customerDocDelivery').updateValueAndValidity();

        break;
      case 'customerDocsSignedDate':
        this.changeUploads(this.uploads);
        break;
      case 'customerDocPickup':
        if(this.showPickupDoc){
        this.validationForDocMultiselect();
        this.showCustomerDocsDateForValidField();
        }
        break;
      case 'customerDocDelivery':
        if(this.showDeliveryDoc){
        this.validationForDocMultiselect();
        this.showCustomerDocsDateForValidField();
        }
        break;
      case 'customerDocCustomer':
        if(this.showCustomerDoc){
        this.validationForDocMultiselect();
        this.showCustomerDocsDateForValidField();
        }
        break;
      case 'pickupLocationId':
        this.loadLocationContacts(true);
        break;
      case 'deliveryLocationId':
        this.loadLocationContacts(false);
        break;
      case 'isPrivateCustomerAtPickupOrDelivery':
        this.checkPrivateCustomerAtPickupOrDelivery();
        break;
      case 'savePickup':
        if (!this.form.get('savePickup')?.value) {
          let ix = this.errors.findIndex(e => e.key == 'pickupLocationExist');
          if (ix > -1)
            this.errors.splice(ix, 1);
        }
        break;
      case 'saveDelivery':
        if (!this.form.get('saveDelivery')?.value) {
          let ix = this.errors.findIndex(e => e.key == 'deliveryLocationExist');
          if (ix > -1)
            this.errors.splice(ix, 1);
        }
        break;
      case 'isPickupNewETA':
        if (this.isNewRecordForDateOverhual) {
          this.commonFunctionForPickupAndDelivery('isPickupNewETA', 'pickupNewETADates', 'pickupNewETAReason', 'pickupDetails')
          if (!this.form.get('isPickupNewETA').value) {
            this.form.get('pickupNewETADates')?.disable();
            this.form.get('pickupNewETAReason')?.disable();
          }
        }
        break;
      case 'isDeliveryNewETA':
        if (this.isNewRecordForDateOverhual) {
          this.commonFunctionForPickupAndDelivery('isDeliveryNewETA', 'deliveryNewETADates', 'deliveryNewETAReason', 'pickupDetails')
          if (!this.form.get('isDeliveryNewETAForDeliveryDetails')?.value && !this.form.get('isDeliveryNewETA')?.value) {
            this.form.get('deliveryNewETADates')?.disable();
            this.form.get('deliveryNewETAReason')?.disable();
          }
        }
        break;
      case 'isDeliveryNewETAForDeliveryDetails':
        if (this.isNewRecordForDateOverhual) {
          this.commonFunctionForPickupAndDelivery('isDeliveryNewETAForDeliveryDetails', 'deliveryNewETADates', 'deliveryNewETAReason', 'deliveryDetails')
          if (!this.form.get('isDeliveryNewETAForDeliveryDetails')?.value && !this.form.get('isDeliveryNewETA')?.value) {
            this.form.get('deliveryNewETADates')?.disable();
            this.form.get('deliveryNewETAReason')?.disable();
          }
        }
        break;
      case 'deliveryNewETAReason':
        this.form.get('deliveryNewETAReason').setValue(this.form.get('deliveryNewETAReason').value, { emitEvent: false });
        this.disableSaveOnNewETAReasonInvalid();
        break;
      case 'pickupNewETAReason':
        this.disableSaveOnNewETAReasonInvalid();
        break;
      case 'callback1':
        if (this.form.get('callback1').value == true) {
          if (this.form.get("callback1date").value==null) {
            this.form.get("callback1date").setValue(new Date());
          }
          this.form.get('callback1date').setValidators([Validators.required]);
          this.form.get('callback1note').setValidators([Validators.required]);
          this.form.get('callback1date').updateValueAndValidity();
          this.form.get('callback1note').updateValueAndValidity();
        }
        else {
          this.form.get('callback1date').clearValidators();
          this.form.get('callback1note').clearValidators();
          this.form.get('callback1date').updateValueAndValidity();
          this.form.get('callback1note').updateValueAndValidity();
        }
        break;
      case 'callback2':
        if (this.form.get('callback2').value == true) {
          if (this.form.get("callback2date").value==null) {
            this.form.get("callback2date").setValue(new Date());
          }
          this.form.get('callback2date').setValidators([Validators.required]);
          this.form.get('callback2note').setValidators([Validators.required]);
          this.form.get('callback2date').updateValueAndValidity();
          this.form.get('callback2note').updateValueAndValidity();
        }
        else {
          this.form.get('callback2date').clearValidators();
          this.form.get('callback2note').clearValidators();
          this.form.get('callback2date').updateValueAndValidity();
          this.form.get('callback2note').updateValueAndValidity();
        }
        break;
      default:
        console.warn(`Call to value subscriber unknown key [${key}]`)
        break;
    
    }
  }

  checkPrivateCustomerAtPickupOrDelivery() {
    if (this.form.get('isPrivateCustomerAtPickupOrDelivery').value == YesNoNA.Yes) {
      this.isPrivateCustomerAtPickupOrDeliveryCheck = true;
      this.form.get('isPrivateCustomerAtPickupOrDelivery').setValidators([Validators.required]);
      this.form.get('privateCustomerLocationType').setValidators([Validators.required]);
    } else {
      this.isPrivateCustomerAtPickupOrDeliveryCheck = false;
      this.form.get('isPrivateCustomerAtPickupOrDelivery').clearValidators();
      this.form.get('privateCustomerLocationType').clearValidators();
    }

    this.form.get('isPrivateCustomerAtPickupOrDelivery').updateValueAndValidity({ emitEvent: false });
    this.form.get('privateCustomerLocationType').updateValueAndValidity();
  }

  customerSearch(e: any) {
    this.customerItems = this.lookups.customers.filter((customer) => {
      return customer.label.toUpperCase().match(e.query.toUpperCase());
    });
  }

  carrierSearch(e: any) {
    const query = e.query.trim();
    
    if (query.length > 0) {
      this.carrierItems = this.lookups.carriers.filter((carrier) => {
        return carrier?.label?.toUpperCase()?.includes(query.toUpperCase());
      });
    }
  }

  onClearCarrier(){
    this.form.get("assignedCarrier").setValue(null);
    this.form.get("selectedCarrier").setValue(null);
    this.form.get('paymentTerms').setValue(null);
    this.cachedCarrierPaymentTerms = null;
    this.isPaymentTermsReadOnly = false;
    this.onCarrierChange(null, this.lookups.carriers);
    this.form.get("assignedCarrier").updateValueAndValidity();
    this.form.get("selectedCarrier").updateValueAndValidity();
    this.policyDetails=[];
    this.isPolicyExpired = false;
    this.isPolicyEmpty = false;
    this.isTransitCompleteCarrier = true;
    this.validateSection('dispatch');

    if (this.isNewRecordForTruckOverhual) {
      const orderDriverDetailArray = this.form.get(
        "orderDriverDetail"
      ) as FormArray;
      if (orderDriverDetailArray) {
        orderDriverDetailArray.clear();
      }
      const newDriverForm = this.fh.getDriverTruckOverhualForm(null, this.form.get("selectedCarrier")?.value?.carrierStatus, true);
      if (orderDriverDetailArray) {
        orderDriverDetailArray.push(newDriverForm);
      } else {
        this.form.addControl(
          "orderDriverDetail",
          new FormArray([newDriverForm])
        );
      }
    }
  }

  onCarrierChange(value: any, items: any) {
    this.isDoNotUseCarrier = false;
    if (value && items && Array.isArray(items) && items.length > 0) {
      const item = items?.filter(ele => ele.value == value);
      if (item.length > 0) {
        // Map communication preferences from carrier data
        const carrierData = item[0];
        if (carrierData && carrierData.communicationPreferences) {
          this.form.get('communicationPreferences')?.setValue(carrierData.communicationPreferences);
        } else {
          this.form.get('communicationPreferences')?.setValue('');
        }

        if (item[0].carrierStatus == 5) {
          this.isDoNotUseCarrier = true;
          // this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please select another carrier. This carrier mark as do not use.' });
        } else {
          // Uncomment below code once carrier upload doc feature rolled out on a production
          // if (item[0].insuranceExpirationDate) {
          //   const today = new Date();
          //   today.setHours(0, 0, 0, 0);
          //   today.setDate(today.getDate() + 3);
          //   if (new Date(item[0].insuranceExpirationDate).getTime() < today.getTime()) {
          //     this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please update insurance certificate for this carrier.' });
          //   }
          // } else {
          //   this.form.controls['assignedCarrier'].setErrors({ 'incorrect': 'Please update insurance certificate for this carrier.' });
          // }
        }
      }
    } else {
      // Clear communication preferences if no carrier selected
      this.form.get('communicationPreferences')?.setValue('');
    }
    this.validateSection('dispatch');
  }


  locationSearch(e: any) {
    this.locationService
      .search(e.query)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.locationItems = res.body;
        this.ref.markForCheck();
      });
  }

  locationSelect(e: any) {
    this.selectedLocation = e;
  }

  customerSelect(e: any) {
    if (this.form.get('selectedCustomer') && this.form.get('customerId')) {
      this.form.get('customerId').setValue(e.value);
      this.customerTempId = this.form.get('customerId').value;
      this.form.get('selectedCustomer').setValue(e);
      (this.form.get('contacts') as FormArray).clear();
      this.isContactDisabled = false;
      this.isAddContactEnabled$.next(true);
      this.form.get('contacts').updateValueAndValidity();
      this.form.get('customerId').updateValueAndValidity({ emitEvent: false });
      this.form.get('selectedCustomer').updateValueAndValidity({ emitEvent: false });
    }
  }

  carrierSelect(e: any) {
    const selectedCarrierControl = this.form.get("selectedCarrier");
    const assignedCarrierControl = this.form.get("assignedCarrier");
    const orderDriverDetailArray = this.form.get(
      "orderDriverDetail"
    ) as FormArray;

    if (selectedCarrierControl && assignedCarrierControl) {
      const previousAssignedCarrier = assignedCarrierControl.value;

      assignedCarrierControl.setValue(e.value);
      selectedCarrierControl.setValue(e);
      if (!this.isNewRecordForTruckOverhual) {
        this.loadCarrierDriversAndPolicies(e.value);
      }
      assignedCarrierControl.markAsDirty();
      selectedCarrierControl.markAsDirty();

      assignedCarrierControl.updateValueAndValidity();
      selectedCarrierControl.updateValueAndValidity();

      if (
        previousAssignedCarrier !== e.value &&
        this.isNewRecordForTruckOverhual
      ) {
        if (orderDriverDetailArray) {
          orderDriverDetailArray.clear();
        }
        const newDriverForm = this.fh.getDriverTruckOverhualForm(null, this.form.get("selectedCarrier")?.value?.carrierStatus, true);
        if (orderDriverDetailArray) {
          orderDriverDetailArray.push(newDriverForm);
        } else {
          this.form.addControl(
            "orderDriverDetail",
            new FormArray([newDriverForm])
          );
        }
      }

      this.form.get('paymentTerms').setValue(e?.paymentTerms)
      this.cachedCarrierPaymentTerms = e?.paymentTerms ?? null;
      this.setPaymentTerms(); 
      this.onCarrierChange(e.value, this.lookups.carriers);
    }
  }

  loadCarrierDriversAndPolicies(carrierId: number): void {
    if (carrierId) {
      this.userService
        .getCarrierDrivers(carrierId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response) => {
          if (this.status < 5) {
            this.policyDetails = response.body.policyDetails;
            this.isPolicyEmpty = this.policyDetails?.length === 0;
            this.isPolicyExpired = this.policyDetails?.some(
              (item) => item.isExpire
            );
            this.isTransitCompleteCarrier = response.body?.carrierUploadComplete;
            this.validateSection('dispatch');
            this.ref.markForCheck();
          }
        });
    }
  }

  selectLocation(currentNavValue: string) {

    let e = this.selectedLocation;
    if (e == null)
      return;

    switch (this.locationSearchArea) {
      case 'pickup':
        this.hideSaveAsNewLocationForPickUp = true;
        this.form.get('pickupBusinessName').setValue(e.businessName);
        this.form.get('pickupFirstName').setValue(e.firstName);
        this.form.get('pickupLastName').setValue(e.lastName);
        this.form.get('pickupStateCode').setValue(e.stateCode);
        this.form.get('pickupCity').setValue(e.city);
        this.form.get('pickupZip').setValue(e.zip);
        this.form.get('pickupNotes').setValue(e.locationPickupNotes);
        this.form.get('pickupAddress1').setValue(e.address1);
        this.form.get('pickupAddress2').setValue(e.address2);
        this.form.get('pickupBusinessHours').setValue(e.businessHours);
        this.form.get('pickupPhone').setValue(e.phone);
        this.form.get('pickupLocationId').setValue(e.id);


        this.form.get('useCustomerContactForPickup').setValue(false);
        break;
      case 'delivery':
        this.hideSaveAsNewLocation = true;

        this.form.get('deliveryBusinessName').setValue(e.businessName);
        this.form.get('deliveryFirstName').setValue(e.firstName);
        this.form.get('deliveryLastName').setValue(e.lastName);
        this.form.get('deliveryStateCode').setValue(e.stateCode);
        this.form.get('deliveryCity').setValue(e.city);
        this.form.get('deliveryZip').setValue(e.zip);
        this.form.get('deliveryNotes').setValue(e.locationDeliveryNotes);
        this.form.get('deliveryAddress1').setValue(e.address1);
        this.form.get('deliveryAddress2').setValue(e.address2);
        this.form.get('deliveryBusinessHours').setValue(e.businessHours);
        this.form.get('deliveryPhone').setValue(e.phone);
        this.form.get('deliveryLocationId').setValue(e.id);

        this.form.get('useCustomerContactForDelivery').setValue(false);

        break;
    }

    this.selectedLocation = null;
    this.showLocationSearch = false;
    this.locationSearchString = null;
    this.customerSearchString = null;
    this.ref.markForCheck();
  }

  populateCustomer(v: any, model?: any) {

    this.form.get('customerBusinessName').setValue(v.businessName);
    this.form.get('customerBusinessHours').setValue(v.businessHours);
    this.form.get('customerPhoneType').setValue(v.primaryContactPhoneType);
    this.form.get('customerPhone').setValue(v.phone);
    this.form.get('customerStateCode').setValue(v.stateCode);
    this.form.get('customerCity').setValue(v.city);
    this.form.get('customerZip').setValue(v.zip);
    this.form.get('customerAddress1').setValue(v.address1);
    this.form.get('customerAddress2').setValue(v.address2);
    this.form.get('customerEmail').setValue(v.primaryContactEmail);
    this.form.get('segment')?.setValue(model?.segment);
    this.form.get('subsegment')?.setValue(model?.subsegment);
    this.form.get('customerPickupNotes')?.setValue(v?.customerPickupNotes);
    this.form.get('customerDeliveryNotes')?.setValue(v?.customerDeliveryNotes);
    this.ref.markForCheck();
  }

  loadExistingLocation(type: string) {
    this.locationSearchArea = type; 
    this.showLocationSearch = true;
    if(type == 'pickup') {
      (this.form.get('pickupContacts') as FormArray).clear()
      this.isAddPickupContactEnabled$.next(true);
      this.isPickupContactDisabled = false;
     } else {
      (this.form.get('deliveryContacts') as FormArray).clear();
      this.isAddDeliveryContactEnabled$.next(true);
       this.isDeliveryContactDisabled = false;
     }
  }


  populatePickup(v: any) {
    this.hideSaveAsNewLocationForPickUp = true;
    var name = this.getNameFromCustomer(v);


    this.form.get('pickupBusinessName').setValue(v.businessName);
    this.form.get('pickupBusinessHours').setValue(v.businessHours);
    this.form.get('pickupFirstName').setValue(name.firstName);
    this.form.get('pickupLastName').setValue(name.lastName);
    this.form.get('pickupStateCode').setValue(v.stateCode);
    this.form.get('pickupCity').setValue(v.city);
    this.form.get('pickupZip').setValue(v.zip);
    this.form.get('pickupNotes').setValue(v.customerPickupNotes);
    this.form.get('pickupAddress1').setValue(v.address1);
    this.form.get('pickupAddress2').setValue(v.address2);
    this.form.get('pickupBusinessHours').setValue(v.businessHours);
    this.form.get('pickupPhone').setValue(v.phone);
    this.form.get('useCustomerContactForPickup').setValue(true);
    (this.form.get('pickupContacts') as FormArray).clear()
    v.contacts.forEach(c => {
      c.entity = 'OrderPickup';
      (this.form.get('pickupContacts') as FormArray).push(this.fh.getContactForm(c, true));
    });
    this.form.get('pickupContacts').updateValueAndValidity();
    this.validateNewPickupContacts(true);
    if (v.contacts.length > 2) {
      this.isAddPickupContactEnabled$.next(false);
    } else {
      this.isAddPickupContactEnabled$.next(true);
    }
    this.ref.markForCheck();
  }

  populateDelivery(v: any) {
    this.hideSaveAsNewLocation = true;
    var name = this.getNameFromCustomer(v);
    
    this.form.get('deliveryBusinessName').setValue(v.businessName);
    this.form.get('deliveryBusinessHours').setValue(v.businessHours);
    this.form.get('deliveryFirstName').setValue(name.firstName);
    this.form.get('deliveryLastName').setValue(name.lastName);
    this.form.get('deliveryStateCode').setValue(v.stateCode);
    this.form.get('deliveryCity').setValue(v.city);
    this.form.get('deliveryZip').setValue(v.zip);
    this.form.get('deliveryNotes')?.setValue(v?.customerDeliveryNotes);
    this.form.get('deliveryAddress1').setValue(v.address1);
    this.form.get('deliveryAddress2').setValue(v.address2);
    this.form.get('deliveryBusinessHours').setValue(v.businessHours);
    this.form.get('deliveryPhone').setValue(v.phone);
    this.form.get('useCustomerContactForDelivery').setValue(true);
    // (this.form.get('deliveryContacts') as FormArray).clear();
    (this.form.get('deliveryContacts') as FormArray).clear()
    v.contacts.forEach(c => {
      c.entity = 'OrderDelivery';
      (this.form.get('deliveryContacts') as FormArray).push(this.fh.getContactForm(c, true));
    });
    this.form.get('deliveryContacts').updateValueAndValidity();
    this.validateNewDeliveryContacts(true);

    this.form.get('deliveryBusinessName').updateValueAndValidity();
    this.form.get('deliveryFirstName').updateValueAndValidity();
    this.form.get('deliveryLastName').updateValueAndValidity();
    this.form.get('deliveryStateCode').updateValueAndValidity();
    this.form.get('deliveryCity').updateValueAndValidity();
    this.form.get('deliveryZip').updateValueAndValidity();
    this.form.get('customerDeliveryNotes').updateValueAndValidity();
    this.form.get('deliveryAddress1').updateValueAndValidity();
    this.form.get('deliveryAddress2').updateValueAndValidity();
    this.form.get('deliveryBusinessHours').updateValueAndValidity();
    this.form.get('deliveryPhone').updateValueAndValidity();
    this.form.get('useCustomerContactForDelivery').updateValueAndValidity();
    // this.form.get('deliveryContacts').updateValueAndValidity();

    if (v.contacts.length > 2) {
      this.isAddDeliveryContactEnabled$.next(false);
    } else {
      this.isAddDeliveryContactEnabled$.next(true);
    }
    this.ref.markForCheck();

  }

  getNameFromCustomer(v: any) {
    var name: any = {};
    if (!this.isPrivateCustomer && this.form.get('contacts').value != null && this.form.get('contacts').value.length > 0) {
      this.form.get('contacts').value.forEach(c => {
        if (c.contactType == 1) {
          name.firstName = c.firstName;
          name.lastName = c.lastName;
        }
      });
    } else if (this.isPrivateCustomer || name.firstName == null) {
      name.firstName = v.firstName;
      name.lastName = v.lastName;
    }

    return name;
  }

  clearDelivery() {
    this.form.get('deliveryBusinessName').setValue(null);
    this.form.get('deliveryFirstName').setValue(null);
    this.form.get('deliveryLastName').setValue(null);
    this.form.get('deliveryStateCode').setValue(null);
    this.form.get('deliveryCity').setValue(null);
    this.form.get('deliveryZip').setValue(null);
    this.form.get('deliveryAddress1').setValue(null);
    this.form.get('deliveryAddress2').setValue(null);
    this.form.get('deliveryBusinessHours').setValue(null);
    this.form.get('deliveryNotes').setValue(null);
    this.form.get('deliveryLocationId').setValue(null);

    this.form.get('deliveryBusinessName').updateValueAndValidity();
    this.form.get('deliveryFirstName').updateValueAndValidity();
    this.form.get('deliveryLastName').updateValueAndValidity();
    this.form.get('deliveryStateCode').updateValueAndValidity();
    this.form.get('deliveryCity').updateValueAndValidity();
    this.form.get('deliveryZip').updateValueAndValidity();
    this.form.get('deliveryAddress1').updateValueAndValidity();
    this.form.get('deliveryAddress2').updateValueAndValidity();
    this.form.get('deliveryBusinessHours').updateValueAndValidity();
    this.form.get('deliveryNotes').updateValueAndValidity();
    this.form.get('deliveryLocationId').updateValueAndValidity();

    this.ref.markForCheck();

  }

  clearPickup() {
    this.form.get('pickupBusinessName').setValue(null);
    this.form.get('pickupFirstName').setValue(null);
    this.form.get('pickupLastName').setValue(null);
    this.form.get('pickupStateCode').setValue(null);
    this.form.get('pickupCity').setValue(null);
    this.form.get('pickupZip').setValue(null);
    this.form.get('pickupAddress1').setValue(null);
    this.form.get('pickupAddress2').setValue(null);
    this.form.get('pickupBusinessHours').setValue(null);
    this.form.get('pickupNotes').setValue(null);
    this.form.get('pickupLocationId').setValue(null);

    this.form.get('pickupBusinessName').updateValueAndValidity();
    this.form.get('pickupFirstName').updateValueAndValidity();
    this.form.get('pickupLastName').updateValueAndValidity();
    this.form.get('pickupStateCode').updateValueAndValidity();
    this.form.get('pickupCity').updateValueAndValidity();
    this.form.get('pickupZip').updateValueAndValidity();
    this.form.get('pickupAddress1').updateValueAndValidity();
    this.form.get('pickupAddress2').updateValueAndValidity();
    this.form.get('pickupBusinessHours').updateValueAndValidity();
    this.form.get('pickupNotes').updateValueAndValidity();
    this.form.get('pickupLocationId').updateValueAndValidity();

    this.ref.markForCheck();

  }

  getCustomerFromForm() {
    let customer: any = {};
    customer.businessName = this.form.get('customerBusinessName').value;
    customer.businessHours = this.form.get('customerBusinessHours').value;
    customer.firstName = this.form.get('customerFirstName').value;
    customer.lastName = this.form.get('customerLastName').value;
    customer.phoneType = this.form.get('customerPhoneType').value;
    customer.phone = this.form.get('customerPhone').value;
    customer.stateCode = this.form.get('customerStateCode').value;
    customer.city = this.form.get('customerCity').value;
    customer.zip = this.form.get('customerZip').value;
    customer.address1 = this.form.get('customerAddress1').value;
    customer.address2 = this.form.get('customerAddress2').value;
    customer.email = this.form.get('customerEmail').value;
    customer.contacts = this.form.get('contacts').value;
    customer.customerPickupNotes = this.form.get('selectedCustomer')?.value?.customerPickupNotes;
    customer.customerDeliveryNotes = this.form.get('selectedCustomer')?.value?.customerDeliveryNotes;
    return customer;
  }

  get canAddDraft(): boolean {
    let flag = true;
    let fields = [
      'payDrop'
      , 'perVehicleDollarAmount'
      , 'dealerTrade'
      , 'privateCustomer'
      , 'newClient'
      , 'customerFirstName'
      , 'customerLastName'
      , 'customerEmail'
      , 'customerPhoneType'
      , 'customerPhone'
      , 'customerAddress1'
      , 'customerCity'
      , 'customerStateCode'
      , 'customerZip'
      , 'selectedCustomer'
      , 'pickupBusinessName'
      // , 'pickupFirstName'
      // , 'pickupLastName'
      , 'pickupBusinessHours'
      , 'pickupAddress1'
      , 'pickupStateCode'
      , 'pickupCity'
      , 'pickupZip'
      , 'pickupNotes'
      , 'deliveryNotes'
      , 'deliveryBusinessName'
      // , 'deliveryFirstName'
      // , 'deliveryLastName'
      , 'deliveryBusinessHours'
      , 'deliveryAddress1'
      , 'deliveryStateCode'
      , 'deliveryCity'
      , 'deliveryZip'
      , 'customerChargedType'
      , 'carrierPaymentType'
      , 'price'
      , 'reviewRequired'
      , 'isPrivateCustomerAtPickupOrDelivery'
      , 'privateCustomerLocationType'
      , 'numOrders'];

    fields.forEach(f => {
      if (!this.form.get(f).valid)
        flag = false;
      return;
    });

    return flag;
  }

  get canAddCreated(): boolean {
    return true;
  }

  logForm() {
    console.log(this.form);
    Object.keys(this.form.controls).forEach(key => {
      if (this.form.get(key).valid === false) {
        console.warn(`form control with key ${key} is invalid`, this.form.get(key).value);
      }
    });
  }

  scrollToTop() {
    if (this.dialog?.container?.children?.[0]) {
      const editMenu =
        this.dialog.container.children[0].querySelector(".edit-menu-items");
      if (editMenu) {
        editMenu.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }

  logPickupForm() {
    console.log(this.pickupCancelForm);
  }

  countChange(key: string, count: number) {
    let l = this.leftNav.find(f => f.key == key);
    if (l != null) {
      l.count = count;
    }
  }

  // To add a removal reason in existing vehciles list
  vehicleUpdate(info: any) {
    const vehicleIndex = this.initialVehicleInformation.findIndex((i: any) => {
      return i.id === info.vehicleId
    });
    if (vehicleIndex > -1) {
      this.initialVehicleInformation[vehicleIndex].removalReason = info.removalReason;
      this.safeFormSet('newStatus', this.status);
      this.edit(false);
    }
  }
  onTransportResultDropDownSelect(lookupKey: string, selectedValues: any) {
    for (const option of this.lookups[lookupKey]) {
      if (option.value === 2) {
        option.disabled = selectedValues.includes(1);
      } else if (option.value === 1) {
        option.disabled = selectedValues.includes(2);
      } else if (option.value === 3) {
        option.disabled = selectedValues.includes(4);
      } else if (option.value === 4) {
        option.disabled = selectedValues.includes(3);
      }
    }
    if (lookupKey === "carrierTransportResults") {
      this.form.get("pickupCarrierTransportResult")?.updateValueAndValidity({ emitEvent: false });
    } else if (lookupKey === "deliveryCarrierTransportResults") {
      this.form.get("deliveryCarrierTransportResult")?.updateValueAndValidity({ emitEvent: false });
    }
  }

  showInvoice() {
      if (this.model?.isBulkUploadInvoiceActive) {
        this.messageService.add(
          this.toast(
            true,
            "Invoice cannot be edited as " +
              this.model?.bulkUploadInvoiceBy +
              " is Bulk Editing"
          )
        );
        return;
      }
      this.totalTime = 0;
      if (this.router.url.includes("search")) {
        this.navigationService.setDetail("invoice", this.model.invoiceGuid);
        this.onCancel.emit(this.model?.id ? [this.model?.id] : null);
      } else {
        this.onSaveComplete.emit(true);
        this.navigationService.setDetail("invoice", this.model?.invoiceGuid);
        if (this.model?.id) {
          this.accountService
            .setAllowOrdersEdit([this.model?.id]?.map((res) => res))
            .subscribe((r) => {});
        }
      }
  }

  get formInvalid(): boolean {
    return this.isLoading || !this.form.valid || this.errors.length > 0;
  }

  validateDriverTypeForPickup(status: string): boolean {
    const orderDriverDetailArray = this.form.get('orderDriverDetail') as FormArray;
    
    if (orderDriverDetailArray && orderDriverDetailArray.length > 0) {
      for (let i = 0; i < orderDriverDetailArray.length; i++) {
        const driverForm = orderDriverDetailArray.at(i) as FormGroup;
        const driverType = driverForm.get('driverType')?.value;
        if (driverType === 'TBD') {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Cannot mark order as ${status} when driver type is TBD. Please update driver information.`,
            life: 5000
          });
          return false;
        }
      }
    } 
    return true;
  }

  click(key: string) {
    this.applicationInsights.trackEvent('Order Action Click', {
      orderId: this.id,
      orderNumber: this.form.get('number')?.value,
      actionKey: key,
      currentStatus: this.status,
      timestamp: new Date().toISOString()
    });

    switch (key) {
      case 'showCancelDialog':
        this.showCancelDialog = !this.showCancelDialog;
        if (this.showCancelDialog === true) {
          this.loadCancelForm();
        } else {
          this.safeFormSet('newStatus');
        }
        break;
      case 'showPickupCancelDialog':
        this.showPickupCancelDialog = !this.showPickupCancelDialog;
        if (this.showPickupCancelDialog === true) {
          this.loadPickupCancelForm()
        } else {
          this.clearPickupCancelFormSubs();
          this.safeFormSet('newStatus');
        }
        break;
      case 'showCancel':
        if (!this.form.dirty) {
          this.click('cancel');
        } else {
          this.showCancelWarning = true;
        }
        break;
      case 'cancel':
        this.showCancelWarning = false;
        this.cancel();
        break;
      case 'canceled':
        this.totalCount.order = true;
        if (this.model.settings?.isTender) {
          this.totalCount.tender = true;
        }
        this.submitCancelForm();
        break;
      case 'cancelPickup':
        this.totalCount.order = true;
        if (this.model.settings?.isTender && this.pickupCancelForm.get('transportVehicle').value == 3) {
          this.totalCount.tender = true;
        }
        this.totalCount.invoice = true;
        this.submitPickupCancelForm();
        break;
      case 'draft':
        this.safeFormSet('newStatus', this.form.get('newStatus')?.value == 1 ? 1 : 0);
        if (this.isAdding) {
          this.totalCount.order = true;
        }
        this.edit(true);
        break;
      case 'draftToCreated':
        this.safeFormSet('newStatus', 1);
        this.totalCount.order = true;
          this.isPopupOpen = false;
        this.edit(false);
        break;
      case 'updateDraftToCreated':
          this.safeFormSet('newStatus', 1);
          this.totalCount.order = true;
          this.isPopupOpen = true;
          this.edit(true);
          break;
      case 'created':
        this.safeFormSet('newStatus', this.form.get('newStatus')?.value == 2 ? 2 : 1);
        this.edit(false);
        break;
        case 'createdToReadyToDispatch':
          this.totalCount.order = true;
          if (
            this.form.get("confirmReadyForPickup").value == 3 &&
            this.form.get("confirmReadyForPickup").value != null &&
            !this.isOrderConfirmDelivery
          ) {
            this.isPopupOpen = false;
            this.safeFormSet("newStatus", 1);
            this.messageService.add(
              this.toast(
                true,
                "Confirm Ready for Pickup must be Yes prior to submitting this task",
              ),
            );
          } else if (this.isOrderConfirmDelivery) {
            if (
              (this.form.get("confirmReadyForPickup").value == 3 &&
                this.form.get("confirmReadyForPickup").value != null) ||
              (this.form.get("confirmReadyForDelivery").value == 3 &&
                this.form.get("confirmReadyForDelivery").value != null)
            ) {
              this.isPopupOpen = false;
              this.safeFormSet("newStatus", 1);
              this.messageService.add(
                this.toast(
                  true,
                  "Confirm Ready for Pickup and Delivery must be Yes prior to submitting this task",
                ),
              );
            } else {
              this.isPopupOpen = true;
              this.safeFormSet("newStatus", 2);
              this.edit(false);
            }
          } else {
            if (this.form.get("customerChargedType").value == 1) {
              //prepay
              this.confirmationService.confirm({
                message:
                  "Please ensure you have uploaded credit card receipt, and private terms/delivery doc (if needed) prior to submitting this task.",
                accept: () => {
                  this.isPopupOpen = true;
                  this.safeFormSet("newStatus", 2);
                  this.edit(false);
                },
              });
            } else {
              this.isPopupOpen = true;
              this.safeFormSet("newStatus", 2);
              this.edit(false);
            }
          }
          break;
      case 'readyToDispatch':
        this.safeFormSet('newStatus', this.form.get('newStatus')?.value == 3 ? 3 : 2);
        this.edit(false);
        break;
      case 'readyToDispatchToDispatched':
        this.totalCount.order = true;
        // if (this.form.get('depositRequired').value != null && this.form.get('depositRequired').value == 2) {
        //   this.confirmationService.confirm({
        //     message: 'Please ensure you have uploaded deposit documentation prior to submitting this task.',
        //     accept: () => {
        //       this.isPopupOpen = true;
        //       this.safeFormSet('newStatus', 3);
        //       this.edit(false);
        //     }
        //   });
        // } else {
        //   this.isPopupOpen = true;
        //   this.safeFormSet('newStatus', 3);
        //   this.edit(false);
        // }
        this.isPopupOpen = true;
        this.safeFormSet('newStatus', 3);
        this.edit(false);
        break;
      case 'dispatched':
        this.safeFormSet('newStatus', this.form.get('newStatus')?.value == 4 ? 4 : 3);
        this.edit(false);
        break;
      case 'dispatchedToPickedUp':
        if (!this.validateDriverTypeForPickup('Picked Up')) {
          return; 
        }
        this.safeFormSet('newStatus', 4);
        this.totalCount.order = true;
        this.isPopupOpen = true;
        this.edit(false);
        break;
      case 'pickedUp':
        if (this.status == 5) {
          this.totalCount.invoice = true;
        }
        this.safeFormSet('newStatus', this.form.get('newStatus')?.value == 5 ? 5 : 4);
        this.edit(false);
        break;
      case 'pickedUpToDelivered':
        if (!this.validateDriverTypeForPickup('Delivered')) {
          return;
        }
        this.safeFormSet('newStatus', 5);
        this.setDefaultCarrierPaid();
        this.totalCount.order = true;
        this.totalCount.invoice = true;
        this.isPopupOpen = true;
        this.edit(false);
        break;
      case 'completedMoves':
        this.safeFormSet('newStatus', 6);
        this.isPopupOpen = true;
        this.edit(false);
        break;
      case 'delivered':
        if (this.status == 5) {
          this.totalCount.invoice = true;
        }
        this.safeFormSet('newStatus', 5);
        this.edit(false);
        break;
      case 'showRevetOrderDialog':
        this.showRevetOrderDialog = !this.showRevetOrderDialog;
        if (this.showRevetOrderDialog === true) {
          this.loadRevertOrderForm();
        } else {
          this.safeFormSet('newStatus');
        }
        break;
      case 'reverted':
        this.totalCount.order = true;
        this.totalCount.invoice = true;
        this.submitRevertOrderForm();
        break;

    }
  }

  edit(closeModal = true) {
    this.applicationInsights.trackEvent('Order Edit Started', {
      orderId: this.id,
      orderNumber: this.form.get('number')?.value,
      status: this.status,
      closeModal: closeModal,
      timestamp: new Date().toISOString()
    });

    this.isLoading = true;
    let f = this.form.value;

    if (f.orderDriverDetail && Array.isArray(f.orderDriverDetail)) {
      f.orderDriverDetail = f.orderDriverDetail.filter(driver => {

        const isEmpty = (
          (!driver.id || driver.id === 0) &&
          (!driver.driverId || driver.driverId === 0) &&
          (!driver.driverName || driver.driverName.trim() === '') &&
          (!driver.driverPhone || driver.driverPhone.trim() === '') &&
          (!driver.trailerSize || driver.trailerSize.trim() === '') &&
          !driver.truckHash &&
          (!driver.driverType || driver.driverType.trim() === '')
        );
        return !isEmpty;
      });
  
      if (f.orderDriverDetail.length === 0) {
        f.orderDriverDetail = [];
      }
    }
    
    this.form.value.pickupContacts = this.form.value.pickupContacts.map((res) => {
      if (res.entityName == 'Order') {
        res.id = 0;
      }
      res.entityName = 'OrderPickup';
      return res;
    }) || [];
    this.form.value.deliveryContacts = this.form.value.deliveryContacts?.map((res) => {
      if (res.entityName == 'Order') {
        res.id = 0;
      }
      res.entityName = 'OrderDelivery';
      return res;
    }) || [];

    if(typeof this.form.get('customerDocs').value === 'number'){
      f.customerDocs=[f.customerDocs]
      this.form.get('customerDocs').setValue(f.customerDocs)
    }

    if (!f.isPickupNewETA) {
      f.pickupNewETAReason = '';
      f.pickupNewETADates = [];
    }

    if (!f.isDeliveryNewETAForDeliveryDetails && !f.isDeliveryNewETA) {
      f.deliveryNewETAReason = '';
      f.deliveryNewETADates = [];
    }
    if (f.selectedCustomer == null && this.isEditing && f.customerId != null) {
      f.customerId = null;
    }
    f.isValidForDispatch = false;
    if (this.status == 1 || this.status == 2 || this.status ==3) {
      const issueCount = this.leftNav.find((n) => n.key != 'dispatch' && n.key != 'documents' && n.key !='pickupDetails' && n.issueCount > 0)?.issueCount
      if (!issueCount) {
        f.isValidForDispatch = true;
        if (
          ((typeof this.form.get("customerDocs").value === "number" &&
            this.form.get("customerDocs").value === 2) ||
            (Array.isArray(this.form.get("customerDocs").value) &&
              !this.form.get("customerDocs").value?.includes(3) &&
              (this.isValidSelection(this.form.get("customerDocCustomer")?.value) ||
                this.isValidSelection(
                  this.form.get("customerDocPickup")?.value
                ) ||
                this.isValidSelection(
                  this.form.get("customerDocDelivery")?.value
                ) || !this.isNewCustomerDocOrder))) &&
          this.form.get("customerDocsSignedDate").value != null
        ){
          f.isValidForDispatch = false;
          this.uploads.forEach(u => {
            let fileName = u.fileName;
            if (fileName == null)
              fileName = u.name;

            if (
              fileName != null &&
              ((this.form.get("depositPaymentDate").value != null &&
                fileName.toLowerCase().indexOf("proof") > -1) ||
                (((typeof this.form.get("customerDocs").value === "number" &&
                  this.form.get("customerDocs").value === 2) ||
                  (Array.isArray(this.form.get("customerDocs").value) &&
                    !this.form.get("customerDocs").value?.includes(3) &&
                    (this.isValidSelection(
                      this.form.get("customerDocCustomer")?.value
                    ) ||
                      this.isValidSelection(
                        this.form.get("customerDocPickup")?.value
                      ) ||
                      this.isValidSelection(
                        this.form.get("customerDocDelivery")?.value
                      ) || !this.isNewCustomerDocOrder))) &&
                  this.form.get("customerDocsSignedDate").value != null &&
                  fileName.toLowerCase().indexOf("customerdoc") > -1))
            )
              f.isValidForDispatch = true;
          });
        }
      }
    }

    // if (!this.isNewRecordForDateOverhual && this.form.value.dateToInvoiceCustomer) {
    //   this.form.value.dateToInvoiceCustomer = this.datePipe.transform(this.form.value.dateToInvoiceCustomer, 'yyyy-MM-dd');
    // }

    if (this.form.value.depositPaymentDate) {
      this.form.value.depositPaymentDate = this.datePipe.transform(this.form.value.depositPaymentDate, 'yyyy-MM-dd');
    }
    if (this.form.value.brokerFeePaidDate) {
      this.form.value.brokerFeePaidDate = this.datePipe.transform(this.form.value.brokerFeePaidDate, 'yyyy-MM-dd');
    }

    if (this.form?.get('callback1')?.value == false) {
      f.callback1date = null;
      f.callback1note = null;
    }

    if (this.form?.get('callback2')?.value == false) {
      f.callback2date = null;
      f.callback2note = null;
    }
    if (this.status === 4) {
      f.carrierPolicyDetail = this.policyDetails;
    }

    if (this.form.value.transportVehicle != 2) {
      this.copyCancleDocs = [];
    }

    if (this.isAdding) {
      if (this.uploads.length > 0) {
        f.Uploads = this.uploads;
      }

      if (this.newNotes.length > 0) {
        f.Notes = this.newNotes;
      }
      if (this.isAdding && this.form.get('dealerTrade')?.value != 5) {
        f.numOrders = 1;
      }
    }

    if (this.isAdding) {
      if (this.form.get('useCustomerContactForPickup').value || this.form.get('pickupLocationId').value) {
        f.savePickup = false;
      }
      if (this.form.get('useCustomerContactForDelivery').value || this.form.get('deliveryLocationId').value) {
        f.saveDelivery = false;
      }
      if (
        f.saveCustomer && f.savePickup &&
        f.customerBusinessName?.trim().toLowerCase() == f.pickupBusinessName.trim().toLowerCase() &&
        f.customerCity.trim().toLowerCase() == f.pickupCity.trim().toLowerCase() &&
        f.customerZip.trim().toLowerCase() == f.pickupZip.trim().toLowerCase()
      ) {
        this.messageService.add(this.toast(true, "Business name, city and zip of customer and pickup are same."));
        this.isLoading = false;
        return;
      } else if (
        f.saveCustomer && f.saveDelivery &&
        f.customerBusinessName?.trim().toLowerCase() == f.deliveryBusinessName.trim().toLowerCase() &&
        f.customerCity.trim().toLowerCase() == f.deliveryCity.trim().toLowerCase() &&
        f.customerZip.trim().toLowerCase() == f.deliveryZip.trim().toLowerCase()
      ) {
        this.messageService.add(this.toast(true, "Business name, city and zip of customer and delivery are same."));
        this.isLoading = false;
        return;
      } else if (
        f.savePickup && f.saveDelivery &&
        f.pickupBusinessName.trim().toLowerCase() == f.deliveryBusinessName.trim().toLowerCase() &&
        f.pickupCity.trim().toLowerCase() == f.deliveryCity.trim().toLowerCase() &&
        f.pickupZip.trim().toLowerCase() == f.deliveryZip.trim().toLowerCase()
      ) {
        this.messageService.add(this.toast(true, "Business name, city and zip of pickup and delivery are same."));
        this.isLoading = false;
        return;
      }
    }

    f.pickupPhones = this.getAddlInfo('pickup');
    f.deliveryPhones = this.getAddlInfo('delivery');
    f.contactEmails = this.getAddlInfo('emails');
    f.carrierEmails = this.getAddlInfo('carrierEmails');
    f.enableNotifications = f.enableNotifications ? 2 : 3
    f.isUpdateCancel = this.isUpdateCancel;
    f.copyCancleDocs = this.copyCancleDocs;
    const formControls: any = this.form.controls;
    f.pickupPhones = this.getArrayString(formControls.pickupPhones.controls.map((r) => { return r.value; }));
    f.deliveryPhones = this.getArrayString(formControls.deliveryPhones.controls.map((r) => { return r.value; }));

    if (this.form.value?.isCanceled && this.form.value?.customerChargedType === customerChargedType.Prepay) {
      f.fscPaidBy = PaymentMethod['Credit Card'];
      this.calculateCompanyProfit();
    }

    this.orderService.edit(f)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        let reloadForm = false;
        if (res != null && !res.isError) {
          this.applicationInsights.trackEvent('Order Save Success', {
            orderId: this.id,
            orderNumber: this.form.get('number')?.value,
            status: this.status,
            newStatus: f.newStatus,
            isAdding: this.isAdding,
            timestamp: new Date().toISOString()
          });
          
          if (this.isNewClient && this.isAdding) {
            this.form.get('saveCustomer')?.setValue(false);
          }
          if (res.body && res.body.vehicles) {
            // Update actual vehcile entries with latest entries
            res.body.vehicles.forEach((v: any) => {
              const isExist = this.initialVehicleInformation.findIndex((i: any) => {
                if (i.id && i.id > 0) {
                  return i.id === v.id;
                } else {
                  return i.vin === v.vin
                }
              });
              if (isExist > -1) {
                const vehicleObj = {
                  ...this.initialVehicleInformation[isExist],
                  id: v.id,
                  isTender: v.isTender,
                  make: v.make,
                  model: v.model,
                  operability: v.operability,
                  vin: v.vin,
                  year: v.year,
                }
                this.initialVehicleInformation[isExist] = vehicleObj;
              } else {
                const vehicleObj = {
                  additionalInfo: v.additionalInfo,
                  deleted: v.deleted,
                  entityId: v.entityId,
                  entityName: v.entityName,
                  id: v.id,
                  isTender: v.isTender,
                  make: v.make,
                  model: v.model,
                  operability: v.operability,
                  status: v.status,
                  vin: v.vin,
                  year: v.year,
                }
                this.initialVehicleInformation.push(vehicleObj);
              }
            });
            // Note: ID update logic removed to prevent duplicate VIN vehicles from getting same ID
            // const vehiclesForm = this.form.get('vehicles') as FormArray;
            // vehiclesForm.value.forEach((v: any, i: number) => {
            //   const isExist = res.body.vehicles.findIndex((index: any) => {
            //     return index.vin === v.vin
            //   });
            //   if (isExist > -1) {
            //     v.id = res.body.vehicles[isExist].id;
            //     vehiclesForm.at(i).patchValue({ id: res.body.vehicles[isExist].id })
            //   }
            //   return v;
            // });
          }

          if (res.body && res.body.orderDriverDetails) {   
            const orderDriverDetailArray = this.form.get('orderDriverDetail') as FormArray;
            
            if (orderDriverDetailArray) {
              orderDriverDetailArray.clear();

              res.body.orderDriverDetails.forEach((driver: any) => {
                const driverFormGroup = this.fh.getDriverTruckOverhualForm(driver, this.form.get("selectedCarrier")?.value?.carrierStatus);
                orderDriverDetailArray.push(driverFormGroup);
              });

              if (res.body.orderDriverDetails.length === 0) {
                const emptyDriverForm = this.fh.getDriverTruckOverhualForm(null, this.form.get("selectedCarrier")?.value?.carrierStatus, true);
                orderDriverDetailArray.push(emptyDriverForm);
              }
              orderDriverDetailArray.updateValueAndValidity();
              this.ref.markForCheck();
            }
          }
          if (this.initialVehicleInformation?.length > this.form.value.vehicles?.length) {
            this.addNotesForRemoveVehicles()
          }
          if (res.body != null) {
            if (res?.body?.messages?.length > 0) {
              res.body.messages.forEach(msg => {
                this.messageService.add(this.toast(true, msg));
              })
            }

            //reload form if this was an add and we have a new id
            if (this.isAdding && res.body?.id > 0) {
              reloadForm = true;
              this.id = res.body.guid;
              this.model = {};
              this.initializeForm();
            }

          }
          else if (res.message == null) {
            this.messageService.add(this.toast(true, 'Updated successfully'));
          }
          else {
            this.messageService.add(this.toast(true, res.message));
          }

          if (this.navigateOnSave && this.model.statusName != 'Move Complete') {
            this.router.navigate(['/orders']);
          }
          this.navigationService.viewInvoice(null);
        } else {
          this.applicationInsights.trackException(new Error(`Order save failed: ${res?.message || 'Unknown error'}`));
          this.messageService.add(this.toast(true, res?.message || 'Something went wrong'));
        }
        if (this.form.contains('pickupNewETAReason')) {
          this.form.get('pickupNewETAReason').setValue('');
          this.form.get('pickupNewETAReason').clearValidators();
          this.form.get('pickupNewETAReason').updateValueAndValidity();
        }
        if (this.form.contains('deliveryNewETAReason')) {
          this.form.get('deliveryNewETAReason').setValue('');
          this.form.get('deliveryNewETAReason').clearValidators();
          this.form.get('deliveryNewETAReason').updateValueAndValidity();
        }
        this.sharedService
          .getMenuCount("all")
          .subscribe((res) => {
            this.navigationService.menuCountChange(res.body, "all");
          });
        if (f?.assignedTo != this.model?.assignedTo) {
          this.navigationService.loadList(true);
        }
        if (this.totalCount.order || this.model.status == 3 || this.model.status == 4) {
          this.sharedServiceClient
            .getMenuCount("order")
            .subscribe((res) => {
              this.navigationService.menuCountChange(res.body, "order");
              this.totalCount.order = false;
            });
        }
        if (this.totalCount.tender || f.saveCustomer || f.savePickup || f.saveDelivery) {
          this.sharedServiceClient
            .getMenuCount("tenderslocations")
            .subscribe((res) => {
              this.navigationService.menuCountChange(
                res.body,
                "tenderslocations"
              );
              this.totalCount.tender = false;
            });
        }
        if (this.totalCount.invoice) {
          this.sharedServiceClient
            .getMenuCount("invoice")
            .subscribe((res) => {
              this.navigationService.menuCountChange(res.body, "invoice");
              this.totalCount.invoice = false;
            });
          this.navigationService.loadList(true);
        }
        if (f.saveCustomer) {
          this.sharedServiceClient
            .getMenuCount("users")
            .subscribe((res) => {
              this.navigationService.menuCountChange(res.body, "users");
            });
        }
        //loading state will be handled by initializeForm() if we are reloading
        if (!reloadForm) {
          this.isLoading = false;
        }
        if(closeModal){
          this.totalTime=0;
          this.onCancel.emit(this.model?.id ? [this.model?.id] : null);
        }
        if(this.model.isCanceled && this.model.cancelationType){
          this.navigationService.loadList(true);
        }
        this.showCancelWarning = false;
        this.form.markAsPristine();
        this.onSaveComplete.emit(closeModal);
        this.ref.markForCheck();
        // Below code will set custom errors
        if (this.model.status >= 2) {
          setTimeout(() => {
            this.onCarrierChange(this.form.get('assignedCarrier').value, this.lookups.carriers);
            if (this.model.status >= 3) {
              this.onTransportResultDropDownSelect('carrierTransportResults', this.model.pickupCarrierTransportResult == null ? [] : this.model.pickupCarrierTransportResult);
            }
            if (this.model.status >= 4) {
              this.onTransportResultDropDownSelect('deliveryCarrierTransportResults', this.model.deliveryCarrierTransportResult == null ? [] : this.model.deliveryCarrierTransportResult);
            }
          }, 1);
        }
      },
        err => {
          this.applicationInsights.trackException(err, 3);
          this.applicationInsights.trackEvent('Order Save Error', {
            orderId: this.id,
            orderNumber: this.form.get('number')?.value,
            error: err?.error?.message || err?.message || 'Unknown error',
            timestamp: new Date().toISOString()
          });
          
          Sentry.captureException(err);
          this.isLoading = false;
          this.isPopupOpen = false;
          this.ref.markForCheck();
          if (err && err.error && err.error.message != null) {
            if (this.isAdding && err.error.body?.length > 0 && err.error.message == 'LocationExist') {
              let error = '';
              err.error.body?.forEach((res) => {
                let ix = this.errors.findIndex(e => e.key == res.key);
                if (ix > -1)
                  this.errors.splice(ix, 1);
                if (res.key.includes("customerOrLocationExist")) {
                  this.errors.push({ key: 'customerOrLocationExist', subkey: 'customerOrLocationExist', message: res.value });
                  error = res.value;
                  this.validateSection('customer');
                }
                if (res.key.includes("pickupLocationExist")) {
                  this.errors.push({ key: 'pickupLocationExist', subkey: 'pickupLocationExist', message: res.value });
                  if (error == '') {
                    error = res.value;
                  }
                  this.validateSection('pickup');
                }
                if (res.key.includes("deliveryLocationExist")) {
                  this.errors.push({ key: 'deliveryLocationExist', subkey: 'deliveryLocationExist', message: res.value });
                  if (error == '') {
                    error = res.value;
                  }
                  this.validateSection('delivery');
                }
                this.onCustomerValueChange(res.key, res.value);
              })
              this.messageService.add(this.toast(true, error));
              this.serverError = error;
            } else {
              this.displayErrorMessage(err.error.message);
            }
          } else if (err && err.status && err.status == 500) {
            this.messageService.add(this.toast(true, 'Internal Server Error'));
            this.serverError = 'Internal Server Error';
          } else {
            /* */
          }
        });
  }

  addNotesForRemoveVehicles() {
    let note = new Note();
    note.entityName = this.initialVehicleInformation[0]?.entityName;
    note.entityId = this.form.value.id; //entityId, entityName, this.initialVehicleInformation[0].entityId
    if (this.initialVehicleInformation?.length >= 1) {
      let removedData: any[] = []
      if (this.form.value.vehicles.length > 0) {
        removedData = this.initialVehicleInformation?.filter((oldData: any) => {
          let dataLength = this.form.value.vehicles?.filter((newData: any) => {
            return oldData.vin != newData.vin ? true : false
          })
          return dataLength.length
        })
      } else {
        removedData = this.initialVehicleInformation
      }

      removedData.forEach((vehicle: any, index) => {
        if (vehicle && vehicle.removalReason !== undefined && !vehicle.isNoteAdded) {
          const vehicleIndex = this.initialVehicleInformation.findIndex((i: any) => {
            return i.vin === vehicle.vin;
          });
          if (vehicleIndex > -1) {
            this.initialVehicleInformation[vehicleIndex].isNoteAdded = true;
          }
          note.message = `Removed vehicle details - vin: ${vehicle.vin}, year: ${vehicle.year}, model: ${vehicle.model}, make: ${vehicle.make}, reason: ${vehicle.removalReason} `;
          this.addNote(note)
        }
      });
    }


  }

  addNote(note: any) {
    this.noteService.add(note).pipe(takeUntil(this.destroy$)).subscribe();
  }

  saveContact() {
    this.formService
      .getEdit("user", this.form.get("customerId").value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        let m = r.body as any;

        while ((this.form.get("contacts") as FormArray)?.length > 0)
          (this.form.get("contacts") as FormArray).removeAt(0);

        if (m.contacts != null && m.contacts.length > 0) {
          this.lookups.customerContacts = [];
          m.contacts.forEach((c) => {
            this.lookups.customerContacts.push({
              value: c.id,
              label: c.firstName + " " + c.lastName,
            });

            let userId = null;
            if (this.isAdding && this.customerId != null)
              userId = this.customerId;

            c.userId = userId;

            (this.form.get("contacts") as FormArray).push(
              this.fh.getContactForm(c, true)
            );
          });
        }

        this.ref.markForCheck();
      });
  }

  removeContactId(event: any) {
    if (event?.entityName == 'OrderPickup' && event?.contactId !== 0) {
      let a = this.form.get('selectedLoadExistingLocationForPickup')?.value;
      let index = a.indexOf(event['contactId']);
      a.splice(index, 1)
      this.form.get('selectedLoadExistingLocationForPickup').setValue([...a])
      this.form.get('selectedLoadExistingLocationForPickup').updateValueAndValidity()
    }

    if (event?.entityName == 'OrderDelivery' && event?.contactId !== 0) {
      let a = this.form.get('selectedLoadExistingLocationForDelivery')?.value
      let index = a.indexOf(event['contactId'])
      a.splice(index, 1)
      this.form.get('selectedLoadExistingLocationForDelivery').setValue([...a])
      this.form.get('selectedLoadExistingLocationForDelivery').updateValueAndValidity()
    }
    if (event?.entityName == 'Order' && event?.customerContactId !== 0 && event?.childEntityName == 'Order') {
      let a = this.form.get('selectedLoadExistingCustomer')?.value
      let index = a.indexOf(event['customerContactId'])
      a.splice(index, 1)
      this.form.get('selectedLoadExistingCustomer').setValue([...a])
      this.form.get('selectedLoadExistingCustomer').updateValueAndValidity();
    }
  }
  selectContacts(event: any = null, sourceList: any[], formKey: string) {
    let selectedContacts = event.value;
    let contactForms = (this.form.get(formKey) as FormArray)
    let contactFormIds: number[] = [];
    
    
    if (contactForms.length > 2 && event.originalEvent.selected) {
      this.messageService.add(this.toast(true, 'You can only select up to 3 contacts.'));
      event.value.pop()
      return
    }

    if (selectedContacts.length == 0) {         //remove all conatact when unselect all
      for (let i = 0; i < contactForms.length; i++) {
        const control = contactForms.controls[i];
        if ((formKey != 'contacts' && control.value.usedLocationId != null) || (formKey == 'contacts' && control.value.usedCustomerLocationId != null)) {
          contactForms.removeAt(i);
          i--; // decrease i for the removed item
        }
      }
    } else { 
      for (let i = 0; i < contactForms.length; i++) {
        const control = contactForms.controls[i];
        if ((formKey != 'contacts' && control.value.usedLocationId != null) || (formKey == 'contacts' && control.value.usedCustomerLocationId != null)) {
          contactForms.removeAt(i);
          i--; // decrease i for the removed item
        }
      }
    }
    for (let i = 0; i < contactForms.length; i++) {
      let contactForm = contactForms.at(i) as FormGroup;
      let id = formKey == 'contacts' ? contactForm.get('usedCustomerLocationId').value : contactForm.get('usedLocationId').value;
      contactFormIds.push(-id);
    }

    for (let i = 0; i < contactForms.length; i++) {
      let contactForm = contactForms.at(i) as FormGroup;
      let id = formKey == 'contacts' ? contactForm.get('usedCustomerLocationId').value : contactForm.get('usedLocationId').value;
      if ((id < 0 && selectedContacts.findIndex(c => c == (-id)) == -1)
        || (!selectedContacts?.includes(event?.itemValue) && event?.itemValue == (-id))
      ) {
        contactForms.removeAt(i);
      }
    }

    contactFormIds = contactFormIds.filter((item, index) => {
      return contactFormIds.indexOf(item) === index
    })

    selectedContacts.forEach(c => {
      if (contactFormIds.indexOf(c) == -1) {
        
        //add the contact
        let contact = sourceList.find(r => r.id == c);
        if (contact != null) {
          let contactForm = this.fh.getContactForm(contact, true);
          (contactForm.get('id') as any).setValue(0);
          if (formKey != 'contacts') {
            (contactForm.get('usedLocationId') as any).setValue(-contact.id)
          } else if (formKey == 'contacts') {
            (contactForm.get('usedCustomerLocationId') as any).setValue(-contact.id)
          }
          contactForms.push(contactForm);
        }
      }
    });
    
    if (contactForms.length > 2){ 
      if(formKey == 'contacts') {
        this.isAddContactEnabled$.next(false);
      } else if (formKey == 'pickupContacts') {
        this.isAddPickupContactEnabled$.next(false);
      } else if (formKey == 'deliveryContacts') {
        this.isAddDeliveryContactEnabled$.next(false);
      }
    } else {
      if(formKey == 'contacts') {
        this.isAddContactEnabled$.next(true);
      } else if (formKey == 'pickupContacts') {
        this.isAddPickupContactEnabled$.next(true);
      } else if (formKey == 'deliveryContacts') {
        this.isAddDeliveryContactEnabled$.next(true);
      }
    }
    
    contactForms.updateValueAndValidity();
    this.ref.markForCheck();
  }

  get showContacts(): boolean {
    return (!this.isNewClient || !this.newClientSelected);
  }

  get customerId(): number {
    if (this.form == null || this.form.get('customerId') == null)
      return null;
    return this.form.get('customerId').value;
  }

  get pickupLocationId(): number {
    if (this.form == null || this.form.get('pickupLocationId') == null)
      return null;
    return this.form.get('pickupLocationId').value;
  }

  get deliveryLocationId(): number {
    if (this.form == null || this.form.get('deliveryLocationId') == null)
      return null;
    return this.form.get('deliveryLocationId').value;
  }

  updateContactValidity() {

    let ix = this.errors.findIndex(e => e.key == 'updateContactValidity');

    if (ix > -1)
      this.errors.splice(ix, 1);

    let newClient = this.form.get('newClient').value == 2;

    if (this.isPrivateCustomer) {
      if (this.isEditing) {
        this.customerTempId = this.form.get('customerId').value;
      }
      this.form.get('customerId').setValue(null);
      this.form.get('customerId').clearValidators();

      this.form.get('customerId').updateValueAndValidity();
      this.validateNewContacts();
      this.validateNewPickupContacts();
      this.validateNewDeliveryContacts();
      this.form.get('customerId').updateValueAndValidity();
      this.form.get('contacts').updateValueAndValidity();
      this.form.get('pickupContacts').updateValueAndValidity();

    } else {
      if (this.isEditing && this.customerTempId) {
        this.form.get('customerId').setValue(this.customerTempId);
      }
      if (this.customerId != null || this.isAdding) {
        if (newClient && this.isAdding) {

          this.form.get('customerId').setValue(null);
          this.form.get('selectedCustomer').setValue(null);
          this.form.get('customerId').clearValidators();

          while ((this.form.get('contacts') as FormArray)?.length > 0)
            (this.form.get('contacts') as FormArray).removeAt(0);

          this.form.get('contacts').setValue([]);
          this.form.get('contacts').clearValidators();

          this.form.get('selectedCustomer').clearValidators();


        } else {
          this.form.get('customerId').setValidators([Validators.required]);
          this.form.get('contacts').setValidators([Validators.required]);
        }

        this.validateNewContacts();
        this.validateNewPickupContacts();
        this.validateNewDeliveryContacts();
        this.form.get('customerId').updateValueAndValidity();
        this.form.get('contacts').updateValueAndValidity();
        this.form.get('pickupContacts').updateValueAndValidity();

      } else if (!this.isAdding) {
        if (newClient && !this.model.saveCustomer) {
          this.form.get('customerId').clearValidators();
        } else {
          this.form.get('customerId').setValidators([Validators.required]);
        }

        this.form.get('contacts').setValidators([Validators.required]);

        this.form.get('customerId').updateValueAndValidity();
        this.form.get('selectedCustomer').updateValueAndValidity();
        this.form.get('contacts').updateValueAndValidity();

      }
    }
  }
  onSegmentChange() {
    this.form.get('subsegment').setValue(null);
  }

  downloadCarrierTerms() {
    if (this.isDownloadingCarrierTerms)
      return;

    this.isDownloadingCarrierTerms = true;
    this.ref.markForCheck();

    this.fileService
      .downloadCarrierTerms(
        this.model.guid,
        this.form.get("includeBoL").value,
        this.form.get("includePort").value,
        "Carrier Terms Order " + this.model.number + ".pdf",
        this.form.get("includeRidgeville").value
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.isDownloadingCarrierTerms = false;
          this.ref.markForCheck();
        },
        (err) => {
          Sentry.captureException(err);
          this.isDownloadingCarrierTerms = false;
          this.ref.markForCheck();

          this.messageService.add({
            severity: "error",
            summary: "Error occurred",
          });
        }
      );
  }

  validateNewContacts() {
    let ix = this.errors.findIndex(e => e.key == 'updateContactValidity');
    if (ix > -1)
      this.errors.splice(ix, 1);

    if ((this.form.get('contacts') as FormArray)?.length >= 1) {
      (this.form.get('contacts') as FormArray).markAllAsTouched()
    }
    if (this.isAdding && this.isNewClient) {
      if (this.form.get('contacts') != null) {
        let contacts = this.form.get('contacts') as FormArray;
        let primaryCount = 0;
        for (let i = 0; i < contacts.length; i++) {
          if (contacts.at(i).get('contactType').value == 1) {
            primaryCount++;
          }
        }
        if (primaryCount <= 0) {
          this.errors.push({ key: 'updateContactValidity', subkey: 'contacts', message: 'Customer must have atleast one contact.' });
        } else {
          let index = this.errors.findIndex(e => e.key == 'updateContactValidity');

          if (index > -1)
            this.errors.splice(index, 1);
        }

      } else {
        console.warn('Form contacts null');
      }
    }
    else if (this.isNewClientYes || !this.isNewClient) {
      let contacts = this.form.get('contacts') as FormArray;

      if (contacts.length < 1) {
        this.errors.push({ key: 'updateContactValidity', subkey: 'contacts', message: 'Please add at least 1 customer contact.' });

      }

    } else {
      let index = this.errors.findIndex(e => e.key == 'updateContactValidity');

      if (index > -1)
        this.errors.splice(index, 1);
    }
  }

  validateNewPickupContacts(useCustomerExistingLocation: boolean = false) {
    if ((this.form.get('pickupContacts') as FormArray)?.length >= 1) {
      (this.form.get('pickupContacts') as FormArray).markAllAsTouched()
    }
    // if (this.form.get('useCustomerContactForPickup').value == true) {
    // if (!useCustomerExistingLocation && !this.form.get('useCustomerContactForPickup').value) {
    if (this.form.get('pickupContacts') != null) {
      let ix = this.errors.findIndex(e => e.key == 'updatePickupValidity');
      if (ix > -1)
        this.errors.splice(ix, 1);

      let pcontacts = this.form.get('pickupContacts') as FormArray;
      if (pcontacts.length < 1) {
        this.errors.push({ key: 'updatePickupValidity', subkey: 'pickupContacts', message: 'Please add at least 1 pickup contact.' });
      }
      let pickupContactError = this.errors.findIndex(e => e.key == 'updatePickupValidity');
      if (pcontacts.length >= 1 && pickupContactError > -1) {
        this.errors.splice(pickupContactError, 1);
      }
    }
    // } else {
    //   let ix = this.errors.findIndex(e => e.key == 'updatePickupValidity');
    //   if (ix > -1)
    //     this.errors.splice(ix, 1);
    // }
  }

  validateNewDeliveryContacts(useCustomerExistingLocation: boolean = false) {
    if ((this.form.get('deliveryContacts') as FormArray)?.length >= 1) {
      (this.form.get('deliveryContacts') as FormArray).markAllAsTouched()
    }
    // if (useCustomerExistingLocation != true && this.form.get('useCustomerContactForDelivery').value != true) {
    // if (!useCustomerExistingLocation && !this.form.get('useCustomerContactForDelivery').value) {
    let ix = this.errors.findIndex(e => e.key == 'updateDeliveryValidity');
    if (ix > -1)
      this.errors.splice(ix, 1);

    let dcontacts = this.form.get('deliveryContacts') as FormArray;
    if (dcontacts.length < 1) {
      this.errors.push({ key: 'updateDeliveryValidity', subkey: 'deliveryContacts', message: 'Please add at least 1 delivery contact.' });
    }
    let deliveryContactError = this.errors.findIndex(e => e.key == 'updateDeliveryValidity');
    if (dcontacts.length >= 1 && deliveryContactError > -1) {
      this.errors.splice(deliveryContactError, 1);
    }
    // } else {
    //   let ix = this.errors.findIndex(e => e.key == 'updateDeliveryValidity');
    //   if (ix > -1)
    //     this.errors.splice(ix, 1);

    // }
  }

  validateCustomerEmail() {
    this.form.get('customerEmail').removeValidators(Validators.required)
    this.form.get('customerFirstName').clearValidators();
    this.form.get('customerLastName').clearValidators();

    if (this.isAdding  && this.form.get('privateCustomer').value != 2 && this.form.get('newClient').value == 2) {
      this.form.get('customerEmail').setValidators([Validators.required, Validators.email]);
    }

    if (this.form.get('privateCustomer').value == 2) {
      /* */
    } else {
      this.form.get('customerFirstName').setValue(null);
      this.form.get('customerLastName').setValue(null);
    }

    this.form.get('customerEmail').updateValueAndValidity();
    this.form.get('customerFirstName').updateValueAndValidity();
    this.form.get('customerLastName').updateValueAndValidity();
  }

  get requiresCustomerId(): boolean {
    return false;
  }

  get requiresContacts(): boolean {
    return false;
  }

  get requiresCustomerEmail(): boolean {
    return this.isAdding && this.form.get('privateCustomer').value != 2 && this.form.get('newClient').value == 2 && this.form.get('saveCustomer').value;
  }

  get requiresCustomerFirstLast(): boolean {
    return this.form.get('privateCustomer').value == 2;
  }

  setAgentCommissionPercentage(value: any, event: any) {
    this.isDoNotUseAssignedTo = false;
    if (value && event && Array.isArray(event) && event.length > 0) {
      const item1 = event?.filter(ele => ele.value == value);
      if (item1.length > 0) {
        if (item1[0].canBeAssignedRep !== 2) {
          this.isDoNotUseAssignedTo = true;
          // this.form.get('assignedTo').setErrors({ incorrect: 'This assign Rep is not in use' })
        }
      }
    }

    const item = event?.find(ele => ele.value == value);
    const prevValue = this.form.get('salesAgentCommissionPercentage')?.value;
    this.form.get('salesAgentCommissionPercentage')?.setValue(item.salesAgentCommissionPercentage);
    this.applicationInsights.trackEvent('SalesAgentCommission_AssignedToChange', {
      source: 'setAgentCommissionPercentage',
      orderId: this.model.id ?? null,
      orderNumber: this.model.number ?? null,
      assignedToValue: value ?? null,
      agentFound: item != null,
      previousValue: prevValue ?? null,
      newValue: item?.salesAgentCommissionPercentage ?? null,
      performedByUserId: this.userId ?? null,
      performedByUserName: localStorage.getItem('userName') ?? null,
      status: this.status ?? null,
    });
  }

  onChangeAdjuctmentToprofit() {
    if (this.form.get('adjustmentToProfit')?.value && this.form.get('calculatedCompanyProfit')?.value) {
      this.form.get('adjustmentProfit')?.setValue(Number(this.form.get('calculatedCompanyProfit')?.value) + Number(this.form.get('adjustmentToProfit')?.value));
    } else {
      this.form.get('adjustmentProfit')?.setValue(this.form.get('calculatedCompanyProfit')?.value);
    }
  }

  onCustomerDocDropDownSelect(lookupKey: string, selectedValues: any) {
    const isValueNotNeededSelected = selectedValues.includes(3);
    const isOtherValuesSelected = selectedValues.some(value => value !== 3);

    for (const option of this.lookups[lookupKey]) {
        if (option.value === 3) {
            option.disabled = isOtherValuesSelected;
        } else {
            option.disabled = isValueNotNeededSelected;
        }
    }
  }
  customerChargedTypeChanged() {
    // Payment Type Invoice, COD+Invoice, or COP+Invoice then Payment Terms are required
    if (this.form.controls.carrierPaymentType.value == carrierPaymentType.Invoice) {  //&& this.form.controls.customerChargedType.value == customerChargedType.Invoice
      if (this.form.controls.paymentTerms) {
        this.form.controls.paymentTerms.setValidators(Validators.required);
        this.form.controls.paymentTerms.updateValueAndValidity();
      }
    } else {
      if (this.form.controls.paymentTerms) {
        this.form.controls.paymentTerms.removeValidators(Validators.required);
        this.form.controls.paymentTerms.updateValueAndValidity();
      }
    }

    // Carrier payment type = COP/COD if balance due is < Price to carrier then payterms is required
    if (this.form.controls.carrierPaymentType.value == carrierPaymentType.COP ||
      this.form.controls.carrierPaymentType.value == carrierPaymentType.COD) {
      if (this.form.controls?.calculatedBalance?.value && this.form.controls?.priceToCarrier?.value) {
        if (parseFloat(this.form.controls.calculatedBalance.value) < parseFloat(this.form.controls.priceToCarrier.value)) {
          if (this.form.controls.paymentTerms) {
            this.form.controls.paymentTerms.setValidators(Validators.required);
            this.form.controls.paymentTerms.updateValueAndValidity();
          }
        } else {
          if (this.form.controls.paymentTerms) {
            this.form.controls.paymentTerms.removeValidators(Validators.required);
            this.form.controls.paymentTerms.updateValueAndValidity();
          }
        }
      }
    }
  }

  isValidSelection(selection) {
    if(selection){
    const requiredElements = [1, 2, 3];
    return requiredElements.some(element => selection.includes(element));
    }
    else{
      return false;
    }
  }

  showCustomerDocsDateForValidField(){
    if (this.showCustomerDocsDate) {
      if (
        this.model.status >= 3
      ) {
        this.form
          .get("customerDocsSignedDate")
          .setValidators([Validators.required]);
      } else {
        this.form.get("customerDocsSignedDate").clearValidators();
      }
    } else {
      this.form.get("customerDocsSignedDate").setValue(null);
      this.form.get("customerDocsSignedDate").clearValidators();
    }
    this.form.get("customerDocsSignedDate").updateValueAndValidity();
  }

  validationForDocMultiselect(){
    this.changeUploads(this.uploads);
    if (
      this.isValidSelection(this.form.get("customerDocCustomer")?.value) ||
      this.isValidSelection(this.form.get("customerDocPickup")?.value) ||
      this.isValidSelection(this.form.get("customerDocDelivery")?.value)
    ) {
      this.showCustomerDocsDate = true;
    } else {
      this.showCustomerDocsDate = false;
    }
  }

  onPolicyDetailsChange(event: any){
    if (this.status < 5) {
      this.policyDetails = event?.policyDetails;
      this.isPolicyEmpty = this.policyDetails?.length === 0;
      this.isPolicyExpired = this.policyDetails?.some((item) => item.isExpire);
      this.isTransitCompleteCarrier = event?.carrierUploadComplete;
      this.validateSection('dispatch');
    }
  }
  onReachMaxContact(event) {
    if (event.formKey == "pickupContacts") {
      this.isPickupContactDisabled = event.isContactDisabled;
      this.isAddPickupContactEnabled$.next(!this.isPickupContactDisabled);
    } else if (event.formKey == "deliveryContacts") {
      this.isDeliveryContactDisabled = event.isContactDisabled;
      this.isAddDeliveryContactEnabled$.next(!this.isDeliveryContactDisabled);
    } else if (event.formKey == "contacts") {
      this.isContactDisabled = event.isContactDisabled;
      this.isAddContactEnabled$.next(!this.isContactDisabled);
    }
  }

  confirmDelete(entityName: string ,id: number) {
    this.deleteId = id;
    this.deleteEntityName = entityName;
    this.deleteMessage = `Are you sure you want to delete this ${entityName}?`;
    this.showDeleteWarning = true;
  }

  onDeleteConfirm(confirm:boolean) {
   if (confirm && this.deleteId!=null && this.deleteEntityName!=null) {
     if (this.deleteEntityName == "Email") {
       this.removeAddlInfo("emails", this.deleteId);
     } else if (this.deleteEntityName == "Pickup Phone") {
       this.removePickupPhone(this.deleteId);
     } else if (this.deleteEntityName == "Delivery Phone") {
       this.removeDeliveryPhone(this.deleteId);
     } else if (this.deleteEntityName == "Carrier Email") {
       this.removeAddlInfo("carrierEmails", this.deleteId);
     }
   }
   this.showDeleteWarning = false;
   this.deleteId = null;
   this.deleteEntityName = null;
   this.deleteMessage = "";
}
  ngOnDestroy() {
    this.applicationInsights.trackEvent('Order Form Closed', {
      orderId: this.id,
      orderNumber: this.form?.get('number')?.value,
      status: this.status,
      timestamp: new Date().toISOString()
    });
    
    this.totalTime = 0;
    
    if (this.visibilityChangeListener) {
      document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }

    this.destroy$.next();
    this.destroy$.complete();
  }
}


@NgModule({
  declarations: [
    OrderFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NotesModule,
    DialogModule,
    LoadingModule,
    DropdownModule,
    FormsModule,
    ButtonModule,
    LastUpdatedModule,
    DynamicValueModule,
    SimpleControlModule,
    VehiclesFormModule,
    DynamicDateFormModule,
    DriverTruckOverhualFormModule,
    AutoCompleteModule,
    NotesModule,
    ModalLeftNavModule,
    UploadsModule,
    KebobMenuModule,
    InputTextareaModule,
    CheckboxModule,
    InputMaskModule,
    KeyFilterModule,
    InputTextModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ContactsFormModule,
    DynamicControlErrorModule,
    OrderTagsModule,
    ConfirmDeleteDialogModule,
    SanitizeInputDirective,
  ],
  exports: [
    OrderFormComponent,
  ]
})
export class OrderFormModule { }